webpackJsonp([1],{

/***/ 110:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalWrapper_vue__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b3e9aad6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalWrapper_vue__ = __webpack_require__(618);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalWrapper_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b3e9aad6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalWrapper_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 111:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SingleSelect_vue__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a07fe67_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SingleSelect_vue__ = __webpack_require__(634);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SingleSelect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a07fe67_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SingleSelect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 113:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_i18n__ = __webpack_require__(636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nl_json__ = __webpack_require__(637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nl_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__nl_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fr_json__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fr_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__fr_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__numbers__ = __webpack_require__(639);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]);





var messages = {
    nl: __WEBPACK_IMPORTED_MODULE_2__nl_json___default.a,
    fr: __WEBPACK_IMPORTED_MODULE_3__fr_json___default.a
};

var i18n = new __WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]({
    fallbackLocale: 'nl',
    numberFormats: __WEBPACK_IMPORTED_MODULE_4__numbers__["a" /* default */],
    messages: messages
});

/* harmony default export */ __webpack_exports__["a"] = (i18n);

/***/ }),

/***/ 114:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loader_vue__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f3e66054_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loader_vue__ = __webpack_require__(652);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f3e66054_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 158:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LOCALE_LOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LOCALE_SET; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__languages__ = __webpack_require__(113);


var _actions;




var modulePrefix = 'locale/';

var LOCALE_SET_SELECTED = modulePrefix + 'set_selected';

var LOCALE_LOAD = modulePrefix + 'load';
var LOCALE_SET = modulePrefix + 'set';

/* harmony default export */ __webpack_exports__["c"] = ({
    state: {
        labels: {
            'nl': 'Nederlands',
            'fr': 'Français'
        },
        selected: localStorage.getItem('lang') || __WEBPACK_IMPORTED_MODULE_2__languages__["a" /* default */].fallbackLocale
    },
    mutations: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, LOCALE_SET_SELECTED, function (state, lang) {
        console.log('[ Locale ]', 'Changing locale to', lang);
        if (!state.labels[lang]) {
            console.log('[ Locale ]', 'Unknown locale, falling back to default');
            lang = __WEBPACK_IMPORTED_MODULE_2__languages__["a" /* default */].fallbackLocale;
        }

        state.selected = lang;

        document.querySelector('html').setAttribute('lang', lang);
        __WEBPACK_IMPORTED_MODULE_2__languages__["a" /* default */].locale = lang;
        __WEBPACK_IMPORTED_MODULE_1_moment___default.a.locale(lang);

        localStorage.setItem('lang', lang);
    }),
    actions: (_actions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, LOCALE_LOAD, function (_ref) {
        var commit = _ref.commit;

        commit(LOCALE_SET_SELECTED, localStorage.getItem('lang') || __WEBPACK_IMPORTED_MODULE_2__languages__["a" /* default */].fallbackLocale);
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, LOCALE_SET, function (_ref2, language) {
        var commit = _ref2.commit,
            state = _ref2.state;

        commit(LOCALE_SET_SELECTED, language);
    }), _actions)
});

/***/ }),

/***/ 160:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = formatQuery;
/* unused harmony export formatDate */
/* harmony export (immutable) */ __webpack_exports__["a"] = calculateDaterangeStep;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);


function formatQuery(query) {
    var highlight = __WEBPACK_IMPORTED_MODULE_0_moment___default()(query.daterange.highlight);
    var start = highlight.isValid() ? highlight : query.daterange.start;
    var end = highlight.isValid() ? highlight : query.daterange.end;
    var result = {
        start: formatDate(start),
        end: formatDate(end),
        step: calculateDaterangeStep(start, end)
    };
    if (query.country_id) {
        result.country_id = query.country_id;
    }
    return result;
}

function formatDate(date) {
    var m = __WEBPACK_IMPORTED_MODULE_0_moment___default()(date);
    return m.format('YYYY-MM-DD');
}

function calculateDaterangeStep(start, end) {
    start = __WEBPACK_IMPORTED_MODULE_0_moment___default()(start);
    end = __WEBPACK_IMPORTED_MODULE_0_moment___default()(end);
    if (!start.isValid() || !end.isValid()) {
        return 'day';
    }
    var delta = end.diff(start, 'days');
    var monthThreshold = 30 * 4;
    if (delta > monthThreshold) {
        return 'month';
    } else {
        return 'day';
    }
}

/***/ }),

/***/ 161:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LOGIN_SSO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LOGOUT; });
/* unused harmony export UNAUTHORIZED */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jwt_decode__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jwt_decode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jwt_decode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment_moment__);



var _mutations, _actions;





var modulePrefix = 'auth/';

var SET_TOKEN = modulePrefix + 'set';
var REQUEST_START = modulePrefix + 'start';
var REQUEST_SUCCESS = modulePrefix + 'success';
var REQUEST_ERROR = modulePrefix + 'error';

var LOGIN_SSO = modulePrefix + 'login';
var LOGOUT = modulePrefix + 'logout';
var UNAUTHORIZED = modulePrefix + 'unauthorized';

function userFromToken(token) {
    if (!token || !token.length) return null;
    var decoded = __WEBPACK_IMPORTED_MODULE_3_jwt_decode___default()(token);
    var issuedAt = __WEBPACK_IMPORTED_MODULE_4_moment_moment___default()(decoded.issuedAt).toDate().getTime();
    return {
        token: token,
        id: decoded.accountId,
        iat: issuedAt,
        exp: issuedAt + decoded.ttl * 1000,
        consumerKey: decoded.consumerKey
    };
}

function validUser(user) {
    return user && typeof user.token === 'string' && user.exp > new Date().getTime() && user.exp > user.iat;
}

/* harmony default export */ __webpack_exports__["c"] = ({
    state: {
        token: localStorage.getItem('token'),
        loading: false,
        error: false
    },
    mutations: (_mutations = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, SET_TOKEN, function (state, user) {
        if (user) {
            state.token = user.token;
            localStorage.setItem('token', user.token);
        } else {
            state.token = null;
            localStorage.removeItem('token');
        }
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, REQUEST_START, function (state) {
        state.loading = true;
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, REQUEST_SUCCESS, function (state) {
        state.loading = false;
        state.error = false;
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, REQUEST_ERROR, function (state) {
        state.loading = false;
        state.error = true;
    }), _mutations),
    actions: (_actions = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, LOGIN_SSO, function (_ref, sso_token) {
        var commit = _ref.commit,
            state = _ref.state;

        commit(REQUEST_START);
        return __WEBPACK_IMPORTED_MODULE_2_vue__["default"].axios.post('auth/api/accounts/sso', { refresh_token: sso_token }).then(function (response) {
            var token = response.data.token;
            var user = userFromToken(token);
            if (validUser(user)) {
                commit(SET_TOKEN, user);
                commit(REQUEST_SUCCESS);
                return user;
            } else {
                throw new Error('Response token is invalid user');
            }
        }).catch(function (e) {
            console.error(e);
            commit(REQUEST_ERROR);
            throw e;
        });
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, LOGOUT, function (_ref2) {
        var commit = _ref2.commit,
            state = _ref2.state;

        commit(SET_TOKEN, null);
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, UNAUTHORIZED, function (_ref3) {
        var commit = _ref3.commit,
            state = _ref3.state;

        commit(SET_TOKEN, null);
    }), _actions),
    getters: {
        currentUser: function currentUser(state, getters) {
            var user = userFromToken(state.token);
            return validUser(user) ? user : null;
        }
    }
});

/***/ }),

/***/ 163:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return COUNTRIES_GET; });
/* unused harmony export COUNTRIES_CLEAR */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);


var _mutations, _actions;



var modulePrefix = 'countries/';

var COUNTRIES_SET = modulePrefix + 'set';

var COUNTRIES_GET = modulePrefix + 'get';
var COUNTRIES_GET_REQUEST = modulePrefix + 'get_request';
var COUNTRIES_GET_SUCCESS = modulePrefix + 'get_success';
var COUNTRIES_GET_ERROR = modulePrefix + 'get_error';

var COUNTRIES_CLEAR = modulePrefix + 'clear';

/* harmony default export */ __webpack_exports__["b"] = ({
    state: {
        countries: [],
        loading: false,
        errors: [],
        promise: null
    },
    mutations: (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, COUNTRIES_SET, function (state, countries) {
        state.countries = countries;
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, COUNTRIES_GET_REQUEST, function (state, promise) {
        state.loading = true;
        state.errors = [];
        state.promise = promise;
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, COUNTRIES_GET_SUCCESS, function (state) {
        state.loading = false;
        state.errors = [];
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, COUNTRIES_GET_ERROR, function (state, errors) {
        state.loading = false;
        state.errors = errors;
        state.promise = null;
    }), _mutations),
    actions: (_actions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, COUNTRIES_GET, function (_ref) {
        var commit = _ref.commit,
            state = _ref.state;

        if (state.loading || state.countries.length) return state.promise;
        var promise = __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get('autogen/api/countries').then(function (response) {
            commit(COUNTRIES_SET, response.data);
            commit(COUNTRIES_GET_SUCCESS);
        }).catch(function (_ref2) {
            var status = _ref2.status,
                errors = _ref2.errors;

            commit(COUNTRIES_GET_ERROR, errors);
            throw { status: status, errors: errors };
        });
        commit(COUNTRIES_GET_REQUEST, promise);
        return promise;
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, COUNTRIES_CLEAR, function (_ref3) {
        var commit = _ref3.commit;

        commit(COUNTRIES_SET, []);
    }), _actions),
    getters: {}
});

/***/ }),

/***/ 341:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_auth__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_countries__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_locale__ = __webpack_require__(158);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);





var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    modules: {
        auth: __WEBPACK_IMPORTED_MODULE_2__modules_auth__["c" /* default */],
        countries: __WEBPACK_IMPORTED_MODULE_3__modules_countries__["b" /* default */],
        locale: __WEBPACK_IMPORTED_MODULE_4__modules_locale__["c" /* default */]
    }
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ 352:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Datepicker_vue__ = __webpack_require__(688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66852239_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Datepicker_vue__ = __webpack_require__(690);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Datepicker_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66852239_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Datepicker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 358:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PercentagePie_vue__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f833605_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PercentagePie_vue__ = __webpack_require__(771);
function injectStyle (ssrContext) {
  __webpack_require__(721)
}
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3f833605"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PercentagePie_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f833605_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PercentagePie_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 363:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Expander_vue__ = __webpack_require__(778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_744d7314_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Expander_vue__ = __webpack_require__(779);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Expander_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_744d7314_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Expander_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 364:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GraphContainer_vue__ = __webpack_require__(802);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_da62a9fe_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GraphContainer_vue__ = __webpack_require__(806);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GraphContainer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_da62a9fe_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GraphContainer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 365:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__polyfills__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__logging__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_auth_AuthHandler__ = __webpack_require__(655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__languages__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_js_modal__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_js_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_js_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__api__ = __webpack_require__(854);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_axios__ = __webpack_require__(855);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue2_notify__ = __webpack_require__(856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue2_notify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue2_notify__);














__WEBPACK_IMPORTED_MODULE_2_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue_js_modal___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4__components_auth_AuthHandler__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_vue2_notify___default.a, {
    itemClass: '',
    permanent: false,
    duration: 300,
    visibility: 5000,
    position: 'bottom-right'
});

var types = {
    info: { itemClass: 'toaster', iconClass: 'alert__icon mdi mdi-information' },
    error: { itemClass: 'toaster--error', iconClass: 'alert__icon mdi mdi-alert-circle' },
    warning: { itemClass: 'toaster--warning', iconClass: 'alert__icon mdi mdi-alert' },
    success: { itemClass: 'toaster--success', iconClass: 'alert__icon mdi mdi-checkbox-marked-circle' }
};

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].$notify.setTypes(types);

var configFileName =  true ? 'config.json' : process.env.NODE_ENV + '.json';

__WEBPACK_IMPORTED_MODULE_9__api__["a" /* axiosInstance */].get('/static/' + configFileName).then(function (response) {
    return response.data;
}).then(function (config) {
    __WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$config = config;
    __WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$config.debug = "production" === 'development';

    __WEBPACK_IMPORTED_MODULE_9__api__["a" /* axiosInstance */].defaults.baseURL = __WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$config.api.url;
    __WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_9__api__["a" /* axiosInstance */]);

    connectAnalytics(config);

    new __WEBPACK_IMPORTED_MODULE_2_vue__["default"]({
        el: '#app',
        router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
        i18n: __WEBPACK_IMPORTED_MODULE_6__languages__["a" /* default */],
        store: __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */],
        template: '<App/>',
        components: { App: __WEBPACK_IMPORTED_MODULE_3__App__["a" /* default */] }
    });
});

function connectAnalytics(config) {
    if ("production" === 'production' && config.analytics && config.analytics.enabled) {
        var VueAnalytics = __webpack_require__(858);
        __WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(VueAnalytics, {
            id: config.analytics.id,
            router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
            autoTracking: {
                screenview: true,
                pageviewTemplate: function pageviewTemplate(route) {
                    return {
                        page: route.path,
                        title: route.name,
                        location: window.location.href
                    };
                }
            }
        });

        if (config.debug) console.log('[ Analytics ]', 'Connected analytics', config.analytics.id);
    }
}

/***/ }),

/***/ 366:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_intl__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_intl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_intl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_intl_locale_data_jsonp_en_js__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_intl_locale_data_jsonp_en_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_intl_locale_data_jsonp_en_js__);






/***/ }),

/***/ 571:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 573:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);


if (false) {
    ['log', 'warn', 'error'].forEach(function (name) {
        var func = console[name];
        console[name] = function () {
            for (var _len = arguments.length, str = Array(_len), _key = 0; _key < _len; _key++) {
                str[_key] = arguments[_key];
            }

            var message = str.map(function (item) {
                if ((typeof item === 'undefined' ? 'undefined' : _typeof(item)) === 'object') {
                    item = _JSON$stringify(item, null, 4);
                }
                return item;
            }).join(' ');
            func(message);
        };
    });
}

/***/ }),

/***/ 597:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4dcfad20_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(654);
function injectStyle (ssrContext) {
  __webpack_require__(598)
}
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4dcfad20_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 598:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 600:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return App; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_cookies_CookieNotification__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_general_TheFooter__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_general_TheHeader__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_general_Topbar__ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_modals_SellerModal__ = __webpack_require__(645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__store_modules_locale__ = __webpack_require__(158);






var _dec, _class;










var App = (_dec = Object(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__["Component"])({
    components: {
        SellerModal: __WEBPACK_IMPORTED_MODULE_11__components_modals_SellerModal__["a" /* default */],
        CookieNotification: __WEBPACK_IMPORTED_MODULE_7__components_cookies_CookieNotification__["a" /* default */],
        TheFooter: __WEBPACK_IMPORTED_MODULE_8__components_general_TheFooter__["a" /* default */],
        TheHeader: __WEBPACK_IMPORTED_MODULE_9__components_general_TheHeader__["a" /* default */],
        Topbar: __WEBPACK_IMPORTED_MODULE_10__components_general_Topbar__["a" /* default */]
    }
}), _dec(_class = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(App, _Vue);

    function App() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, App);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = App.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(App)).call.apply(_ref, [this].concat(args))), _this), _this.name = 'app', _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(App, [{
        key: 'created',
        value: function created() {
            this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_12__store_modules_locale__["a" /* LOCALE_LOAD */]);
        }
    }]);

    return App;
}(__WEBPACK_IMPORTED_MODULE_5_vue__["default"])) || _class);


/***/ }),

/***/ 613:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CookieNotification_vue__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d5097a5_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CookieNotification_vue__ = __webpack_require__(623);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CookieNotification_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d5097a5_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CookieNotification_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 614:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CookieNotification; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CookieModal_vue__ = __webpack_require__(615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CookieBanner_vue__ = __webpack_require__(620);






var _dec, _class;






var CookieNotification = (_dec = Object(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__["Component"])({
    components: {
        CookieModal: __WEBPACK_IMPORTED_MODULE_7__CookieModal_vue__["a" /* default */],
        CookieBanner: __WEBPACK_IMPORTED_MODULE_8__CookieBanner_vue__["a" /* default */]
    }
}), _dec(_class = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(CookieNotification, _Vue);

    function CookieNotification() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, CookieNotification);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = CookieNotification.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(CookieNotification)).call.apply(_ref, [this].concat(args))), _this), _this.name = 'cookie-notification', _this.show = false, _this.type = undefined, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(CookieNotification, [{
        key: 'created',
        value: function created() {
            var local = this.getLocalStorage();
            if (this.$config.cookies.enabled && !local) {
                this.show = true;
                this.type = this.$config.cookies.type;
            }
        }
    }, {
        key: 'getLocalStorage',
        value: function getLocalStorage() {
            var item = localStorage.getItem('cookies');
            if (!item) {
                return false;
            } else {
                return JSON.parse(item);
            }
        }
    }, {
        key: 'mounted',
        value: function mounted() {
            if (this.type === 'modal') {
                console.log('[ Cookies ]', 'Should show modal');
                this.$modal.show('cookie-modal');
            }
        }
    }, {
        key: 'confirm',
        value: function confirm() {
            console.log('[ Cookies ]', 'confirm');
            localStorage.setItem('cookies', true);
            this.show = false;
        }
    }]);

    return CookieNotification;
}(__WEBPACK_IMPORTED_MODULE_5_vue__["default"])) || _class);


/***/ }),

/***/ 615:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CookieModal_vue__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03808932_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CookieModal_vue__ = __webpack_require__(619);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CookieModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03808932_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CookieModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 616:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CookieModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_general_ModalWrapper__ = __webpack_require__(110);






var _dec, _class;





var CookieModal = (_dec = Object(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__["Component"])({
    components: {
        ModalWrapper: __WEBPACK_IMPORTED_MODULE_7__components_general_ModalWrapper__["a" /* default */]
    }
}), _dec(_class = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(CookieModal, _Vue);

    function CookieModal() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, CookieModal);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = CookieModal.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(CookieModal)).call.apply(_ref, [this].concat(args))), _this), _this.name = 'cookie-modal', _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(CookieModal, [{
        key: 'confirm',
        value: function confirm() {
            this.$emit('confirm');
            this.$modal.hide(this.name);
        }
    }]);

    return CookieModal;
}(__WEBPACK_IMPORTED_MODULE_5_vue__["default"])) || _class);


/***/ }),

/***/ 617:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ModalWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_js_modal__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_js_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_js_modal__);






var _dec, _class;





__WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vue_js_modal___default.a);

var ModalWrapper = (_dec = Object(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__["Component"])({
    props: {
        modalName: String,
        modalClass: String
    }
}), _dec(_class = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ModalWrapper, _Vue);

    function ModalWrapper() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ModalWrapper);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = ModalWrapper.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ModalWrapper)).call.apply(_ref, [this].concat(args))), _this), _this.name = 'modal-wrapper', _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ModalWrapper, [{
        key: 'beforeOpen',
        value: function beforeOpen(event) {
            document.getElementsByTagName('body')[0].className += ' modal__open';
            this.$emit('before-open', event);
        }
    }, {
        key: 'opened',
        value: function opened(event) {
            this.modalOpen = true;
            this.$emit('modalIsOpen', this.modalOpen);
        }
    }, {
        key: 'closed',
        value: function closed(event) {
            document.getElementsByTagName('body')[0].className = document.getElementsByTagName('body')[0].className.replace('modal__open', '');
            this.modalOpen = false;
            this.$emit('modalWasClosed', this.modalOpen);
        }
    }, {
        key: 'closeModal',
        value: function closeModal() {
            this.$modal.hide(this.modalName);
        }
    }]);

    return ModalWrapper;
}(__WEBPACK_IMPORTED_MODULE_5_vue__["default"])) || _class);


/***/ }),

/***/ 618:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{class:_vm.modalClass,attrs:{"name":_vm.modalName},on:{"before-open":_vm.beforeOpen,"opened":_vm.opened,"closed":_vm.closed}},[_c('a',{staticClass:"modal__close",attrs:{"type":"button"},on:{"click":_vm.closeModal}},[_c('i',{staticClass:"mdi mdi-close"})]),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 619:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-wrapper',{attrs:{"modalClass":"modal--small","modalName":_vm.name}},[_c('div',{staticClass:"modal__header"},[_c('h3',[_vm._v("\n            "+_vm._s(_vm.$t('cookies.modal.title'))+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"modal__content"},[_vm._v("\n        "+_vm._s(_vm.$t('cookies.modal.message'))+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"modal__footer"},[_c('button',{staticClass:"button--cta",attrs:{"type":"submit"},on:{"click":_vm.confirm}},[_vm._v("\n            "+_vm._s(_vm.$t('cookies.modal.button_confirm'))+"\n        ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 620:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CookieBanner_vue__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fddd467e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CookieBanner_vue__ = __webpack_require__(622);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CookieBanner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fddd467e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CookieBanner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 621:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CookieBanner; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__);






var _class;




var CookieBanner = Object(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__["Component"])(_class = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(CookieBanner, _Vue);

    function CookieBanner() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, CookieBanner);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = CookieBanner.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(CookieBanner)).call.apply(_ref, [this].concat(args))), _this), _this.name = 'cookie-banner', _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(CookieBanner, [{
        key: 'confirm',
        value: function confirm() {
            this.$emit('confirm');
        }
    }, {
        key: 'gotoInfoPage',
        value: function gotoInfoPage() {
            console.log('[ CookieBanner ]', 'More info');
            this.$router.push({ name: 'cookie-policy' });
        }
    }]);

    return CookieBanner;
}(__WEBPACK_IMPORTED_MODULE_5_vue__["default"])) || _class;



/***/ }),

/***/ 622:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('span',{staticClass:"cookie_bar__text"},[_vm._v(_vm._s(_vm.$t('cookies.banner.title')))]),_vm._v(" "),_c('div',{staticClass:"cookie_bar__buttons"},[_c('button',{staticClass:"button--cta",on:{"click":_vm.confirm}},[_vm._v("\n                    "+_vm._s(_vm.$t('cookies.banner.button_confirm'))+"\n                ")]),_vm._v(" "),_c('button',{staticClass:"button--link",on:{"click":_vm.gotoInfoPage}},[_vm._v("\n                    "+_vm._s(_vm.$t('cookies.banner.button_info'))+"\n                ")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 623:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"cookie_bar"},[(_vm.type !== undefined && _vm.type === 'modal')?_c('cookie-modal',{on:{"confirm":_vm.confirm}}):_vm._e(),_vm._v(" "),(_vm.type !== undefined && _vm.type === 'banner')?_c('cookie-banner',{on:{"confirm":_vm.confirm}}):_vm._e()],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 624:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TheFooter_vue__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72904f7a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TheFooter_vue__ = __webpack_require__(626);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TheFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72904f7a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TheFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 625:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TheFooter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_property_decorator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_property_decorator__);





var _class;




var TheFooter = Object(__WEBPACK_IMPORTED_MODULE_5_vue_property_decorator__["Component"])(_class = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(TheFooter, _Vue);

    function TheFooter() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, TheFooter);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = TheFooter.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(TheFooter)).call.apply(_ref, [this].concat(args))), _this), _this.name = 'the-footer', _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    return TheFooter;
}(__WEBPACK_IMPORTED_MODULE_4_vue__["default"])) || _class;



/***/ }),

/***/ 626:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"footer__text"},[_vm._v("\n        © "+_vm._s(new Date().getFullYear())+" "+_vm._s(_vm.$t('footer.copyrights'))+"\n    ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 627:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TheHeader_vue__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06c30659_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TheHeader_vue__ = __webpack_require__(641);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TheHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06c30659_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TheHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 628:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TheHeader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_v_media_query__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_v_media_query___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_v_media_query__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__LanguagePicker__ = __webpack_require__(629);






var _dec, _class;






__WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_v_media_query___default.a);

var TheHeader = (_dec = Object(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__["Component"])({
    components: {
        LanguagePicker: __WEBPACK_IMPORTED_MODULE_8__LanguagePicker__["a" /* default */]
    },
    watch: {
        '$mq.resize': 'hideMobileMenu',
        '$route': 'onRouteChanged',

        showMobileMenu: function showMobileMenu(newVal) {
            var className = 'nav__mobile_open';
            if (newVal) {
                document.body.classList.add(className);
            } else {
                document.body.classList.remove(className);
            }
        }
    }
}), _dec(_class = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(TheHeader, _Vue);

    function TheHeader() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, TheHeader);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = TheHeader.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(TheHeader)).call.apply(_ref, [this].concat(args))), _this), _this.name = 'the-header', _this.showMobileMenu = false, _this.authenticated = false, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(TheHeader, [{
        key: 'toggleMobileMenu',
        value: function toggleMobileMenu() {
            if (this.$mq.below(992)) {
                this.showMobileMenu = !this.showMobileMenu;
            } else {
                this.showMobileMenu = false;
            }
        }
    }, {
        key: 'hideMobileMenu',
        value: function hideMobileMenu() {
            if (this.$mq.above(991)) {
                this.showMobileMenu = false;
            }
        }
    }, {
        key: 'created',
        value: function created() {
            this.showMobileMenu = false;
            this.onRouteChanged();
        }
    }, {
        key: 'signOut',
        value: function signOut() {
            var _this2 = this;

            console.log('[ Header ]', 'Sign out');
            this.$auth.signOut().then(function () {
                _this2.$router.replace({
                    name: 'sign-in'
                });
            });
        }
    }, {
        key: 'onRouteChanged',
        value: function onRouteChanged() {
            this.authenticated = this.$auth.currentUser();
        }
    }]);

    return TheHeader;
}(__WEBPACK_IMPORTED_MODULE_5_vue__["default"])) || _class);


/***/ }),

/***/ 629:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LanguagePicker_vue__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_124a3fcd_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LanguagePicker_vue__ = __webpack_require__(640);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LanguagePicker_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_124a3fcd_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LanguagePicker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 630:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LanguagePicker; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SingleSelect__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_modules_locale__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash__);






var _dec, _class;







var LanguagePicker = (_dec = Object(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__["Component"])({
    components: { SingleSelect: __WEBPACK_IMPORTED_MODULE_7__SingleSelect__["a" /* default */] }
}), _dec(_class = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(LanguagePicker, _Vue);

    function LanguagePicker() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, LanguagePicker);

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (LanguagePicker.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(LanguagePicker)).apply(this, arguments));
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(LanguagePicker, [{
        key: 'languages',
        get: function get() {
            return __WEBPACK_IMPORTED_MODULE_9_lodash___default.a.map(this.$store.state.locale.labels, function (label, code) {
                return { value: code, label: label };
            });
        }
    }, {
        key: 'selectedLanguage',
        get: function get() {
            var locale = this.$store.state.locale;
            var selected = locale.selected;
            return {
                value: selected,
                label: locale.labels[selected]
            };
        },
        set: function set(language) {
            this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_8__store_modules_locale__["b" /* LOCALE_SET */], language.value);
        }
    }]);

    return LanguagePicker;
}(__WEBPACK_IMPORTED_MODULE_5_vue__["default"])) || _class);


/***/ }),

/***/ 631:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SimpleSelect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_select__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_select__);








var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;

function _initDefineProp(target, property, descriptor, context) {
    if (!descriptor) return;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, property, {
        enumerable: descriptor.enumerable,
        configurable: descriptor.configurable,
        writable: descriptor.writable,
        value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
    });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}

function _initializerWarningHelper(descriptor, context) {
    throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}





var SimpleSelect = (_dec = Object(__WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__["Component"])({
    components: {
        vSelect: __WEBPACK_IMPORTED_MODULE_9_vue_select___default.a
    }
}), _dec2 = Object(__WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__["Prop"])(), _dec3 = Object(__WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__["Prop"])(), _dec4 = Object(__WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__["Prop"])({ type: Function }), _dec5 = Object(__WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__["Prop"])({ type: String }), _dec6 = Object(__WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__["Prop"])({ type: Boolean }), _dec7 = Object(__WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__["Watch"])('value'), _dec(_class = (_class2 = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(SimpleSelect, _Vue);

    function SimpleSelect() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, SimpleSelect);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = SimpleSelect.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(SimpleSelect)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'options', _descriptor, _this), _initDefineProp(_this, 'value', _descriptor2, _this), _initDefineProp(_this, 'getOptionLabel', _descriptor3, _this), _initDefineProp(_this, 'placeholder', _descriptor4, _this), _initDefineProp(_this, 'disabled', _descriptor5, _this), _this.localValue = null, _temp), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(SimpleSelect, [{
        key: 'onValueChanged',
        value: function onValueChanged() {
            this.localValue = this.value;
        }
    }, {
        key: 'mounted',
        value: function mounted() {
            this.localValue = this.value;
        }
    }, {
        key: 'onSelectionChanged',
        value: function onSelectionChanged(newSelection) {
            var _this2 = this;

            if (newSelection) {
                this.localValue = newSelection;
                this.$emit('input', newSelection);
            } else {
                var resetValue = this.localValue;
                this.localValue = null;
                this.$nextTick(function () {
                    _this2.localValue = resetValue;
                });
            }
        }
    }]);

    return SimpleSelect;
}(__WEBPACK_IMPORTED_MODULE_7_vue__["default"]), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'options', [_dec2], {
    enumerable: true,
    initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'value', [_dec3], {
    enumerable: true,
    initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, 'getOptionLabel', [_dec4], {
    enumerable: true,
    initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, 'placeholder', [_dec5], {
    enumerable: true,
    initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, 'disabled', [_dec6], {
    enumerable: true,
    initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, 'onValueChanged', [_dec7], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'onValueChanged'), _class2.prototype)), _class2)) || _class);


/***/ }),

/***/ 634:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',_vm._b({attrs:{"value":_vm.localValue,"searchable":false,"multiple":false,"filterable":false},on:{"input":_vm.onSelectionChanged}},'v-select',{options: _vm.options, getOptionLabel: _vm.getOptionLabel, placeholder: _vm.placeholder, disabled: _vm.disabled},false),[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 635:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 218,
	"./af.js": 218,
	"./ar": 219,
	"./ar-dz": 220,
	"./ar-dz.js": 220,
	"./ar-kw": 221,
	"./ar-kw.js": 221,
	"./ar-ly": 222,
	"./ar-ly.js": 222,
	"./ar-ma": 223,
	"./ar-ma.js": 223,
	"./ar-sa": 224,
	"./ar-sa.js": 224,
	"./ar-tn": 225,
	"./ar-tn.js": 225,
	"./ar.js": 219,
	"./az": 226,
	"./az.js": 226,
	"./be": 227,
	"./be.js": 227,
	"./bg": 228,
	"./bg.js": 228,
	"./bm": 229,
	"./bm.js": 229,
	"./bn": 230,
	"./bn.js": 230,
	"./bo": 231,
	"./bo.js": 231,
	"./br": 232,
	"./br.js": 232,
	"./bs": 233,
	"./bs.js": 233,
	"./ca": 234,
	"./ca.js": 234,
	"./cs": 235,
	"./cs.js": 235,
	"./cv": 236,
	"./cv.js": 236,
	"./cy": 237,
	"./cy.js": 237,
	"./da": 238,
	"./da.js": 238,
	"./de": 239,
	"./de-at": 240,
	"./de-at.js": 240,
	"./de-ch": 241,
	"./de-ch.js": 241,
	"./de.js": 239,
	"./dv": 242,
	"./dv.js": 242,
	"./el": 243,
	"./el.js": 243,
	"./en-au": 244,
	"./en-au.js": 244,
	"./en-ca": 245,
	"./en-ca.js": 245,
	"./en-gb": 246,
	"./en-gb.js": 246,
	"./en-ie": 247,
	"./en-ie.js": 247,
	"./en-il": 248,
	"./en-il.js": 248,
	"./en-nz": 249,
	"./en-nz.js": 249,
	"./eo": 250,
	"./eo.js": 250,
	"./es": 251,
	"./es-do": 252,
	"./es-do.js": 252,
	"./es-us": 253,
	"./es-us.js": 253,
	"./es.js": 251,
	"./et": 254,
	"./et.js": 254,
	"./eu": 255,
	"./eu.js": 255,
	"./fa": 256,
	"./fa.js": 256,
	"./fi": 257,
	"./fi.js": 257,
	"./fo": 258,
	"./fo.js": 258,
	"./fr": 259,
	"./fr-ca": 260,
	"./fr-ca.js": 260,
	"./fr-ch": 261,
	"./fr-ch.js": 261,
	"./fr.js": 259,
	"./fy": 262,
	"./fy.js": 262,
	"./gd": 263,
	"./gd.js": 263,
	"./gl": 264,
	"./gl.js": 264,
	"./gom-latn": 265,
	"./gom-latn.js": 265,
	"./gu": 266,
	"./gu.js": 266,
	"./he": 267,
	"./he.js": 267,
	"./hi": 268,
	"./hi.js": 268,
	"./hr": 269,
	"./hr.js": 269,
	"./hu": 270,
	"./hu.js": 270,
	"./hy-am": 271,
	"./hy-am.js": 271,
	"./id": 272,
	"./id.js": 272,
	"./is": 273,
	"./is.js": 273,
	"./it": 274,
	"./it.js": 274,
	"./ja": 275,
	"./ja.js": 275,
	"./jv": 276,
	"./jv.js": 276,
	"./ka": 277,
	"./ka.js": 277,
	"./kk": 278,
	"./kk.js": 278,
	"./km": 279,
	"./km.js": 279,
	"./kn": 280,
	"./kn.js": 280,
	"./ko": 281,
	"./ko.js": 281,
	"./ky": 282,
	"./ky.js": 282,
	"./lb": 283,
	"./lb.js": 283,
	"./lo": 284,
	"./lo.js": 284,
	"./lt": 285,
	"./lt.js": 285,
	"./lv": 286,
	"./lv.js": 286,
	"./me": 287,
	"./me.js": 287,
	"./mi": 288,
	"./mi.js": 288,
	"./mk": 289,
	"./mk.js": 289,
	"./ml": 290,
	"./ml.js": 290,
	"./mn": 291,
	"./mn.js": 291,
	"./mr": 292,
	"./mr.js": 292,
	"./ms": 293,
	"./ms-my": 294,
	"./ms-my.js": 294,
	"./ms.js": 293,
	"./mt": 295,
	"./mt.js": 295,
	"./my": 296,
	"./my.js": 296,
	"./nb": 297,
	"./nb.js": 297,
	"./ne": 298,
	"./ne.js": 298,
	"./nl": 299,
	"./nl-be": 300,
	"./nl-be.js": 300,
	"./nl.js": 299,
	"./nn": 301,
	"./nn.js": 301,
	"./pa-in": 302,
	"./pa-in.js": 302,
	"./pl": 303,
	"./pl.js": 303,
	"./pt": 304,
	"./pt-br": 305,
	"./pt-br.js": 305,
	"./pt.js": 304,
	"./ro": 306,
	"./ro.js": 306,
	"./ru": 307,
	"./ru.js": 307,
	"./sd": 308,
	"./sd.js": 308,
	"./se": 309,
	"./se.js": 309,
	"./si": 310,
	"./si.js": 310,
	"./sk": 311,
	"./sk.js": 311,
	"./sl": 312,
	"./sl.js": 312,
	"./sq": 313,
	"./sq.js": 313,
	"./sr": 314,
	"./sr-cyrl": 315,
	"./sr-cyrl.js": 315,
	"./sr.js": 314,
	"./ss": 316,
	"./ss.js": 316,
	"./sv": 317,
	"./sv.js": 317,
	"./sw": 318,
	"./sw.js": 318,
	"./ta": 319,
	"./ta.js": 319,
	"./te": 320,
	"./te.js": 320,
	"./tet": 321,
	"./tet.js": 321,
	"./tg": 322,
	"./tg.js": 322,
	"./th": 323,
	"./th.js": 323,
	"./tl-ph": 324,
	"./tl-ph.js": 324,
	"./tlh": 325,
	"./tlh.js": 325,
	"./tr": 326,
	"./tr.js": 326,
	"./tzl": 327,
	"./tzl.js": 327,
	"./tzm": 328,
	"./tzm-latn": 329,
	"./tzm-latn.js": 329,
	"./tzm.js": 328,
	"./ug-cn": 330,
	"./ug-cn.js": 330,
	"./uk": 331,
	"./uk.js": 331,
	"./ur": 332,
	"./ur.js": 332,
	"./uz": 333,
	"./uz-latn": 334,
	"./uz-latn.js": 334,
	"./uz.js": 333,
	"./vi": 335,
	"./vi.js": 335,
	"./x-pseudo": 336,
	"./x-pseudo.js": 336,
	"./yo": 337,
	"./yo.js": 337,
	"./zh-cn": 338,
	"./zh-cn.js": 338,
	"./zh-hk": 339,
	"./zh-hk.js": 339,
	"./zh-tw": 340,
	"./zh-tw.js": 340
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 635;

/***/ }),

/***/ 637:
/***/ (function(module, exports) {

module.exports = {"menu":{"title_logo":"Minimax Dashboard","dashboard":"Dashboard","annualreport":"Jaaroverzicht","signout":"Log uit"},"auth":{"header_signin":"Log in met gebruikersnaam en wachtwoord","header_forgotten_password":"Wachtwoord vergeten?","header_reset_password":"Wachtwoord resetten","message_forgotten_password":"Vul hieronder je emailadres in en we zullen je een email sturen om je wachtwoord te wijzigen.","message_busy":"Inloggen...","hint_email":"Emailadres","hint_password":"Wachtwoord","button_signin":"Log in","button_reset_password":"Reset wachtwoord","button_cancel":"Annuleren","button_change_password":"Wijzig wachtwoord","link_no_account":"Niet geregistreerd?","link_forgot_password":"Wachtwoord vergeten?"},"footer":{"copyrights":"Minimax Waterontharders. Alle rechten voorbehouden"},"single_sign_on":{"header_no_sso":"U heeft geen toegang tot deze pagina","header_sso_busy":"Uitvoeren log in","header_sso_error":"Er is iets mis gegaan","link_go_back":"Ga terug"},"notfound":{"header":"Sorry, deze pagina bestaat niet","link_go_back":"Ga terug"},"cookies":{"banner":{"title":"Deze website maakt gebruik van cookies ter verbetering van de gebruikerservaring","button_confirm":"Ik accepteer cookies","button_info":"Meer informatie"},"modal":{"title":"Cookies","message":"Deze website maakt gebruik van cookies ter verbetering van de gebruikerservaring","button_confirm":"Ik accepteer cookies"},"infopage":{"title":"Ons cookies-beleid","sections":["First line of cookie policy","Second line of cookie policy","Third line of cookie policy"]}},"datepicker":{"months":["januari","februari","maart","april","mei","juni","juli","augustus","september","oktober","november","december"],"months_short":["jan","feb","maa","apr","mei","jun","jul","aug","sep","okt","nov","dec"],"days":["zo","ma","di","wo","do","vr","za"],"year_suffix":""},"presetbar":{"label_placeholder":"Kies bereik...","label_days7":"Afgelopen 7 dagen","label_days30":"Afgelopen 30 dagen","label_thismonth":"Deze maand","label_thisyear":"Dit jaar","label_months1":"Afgelopen maand","label_months3":"Afgelopen 3 maanden","label_months6":"Afgelopen 6 maanden"},"dashboard":{"datepickers":{"from":"Gegevens van","to":"tot en met","highlight":"Je bekijkt nu de gegevens van"}},"annualreport":{"title":"Jaarcijfers"},"loader":{"loading":"Laden...","error":"Er is iets mis gegaan"},"graph_container":{"label_no_data":"Geen data beschikbaar","label_no_selection":"Selecteer grafiekgegevens om te plotten","label_dropdown":"Selecteer grafiekgegevens","label_dropdown_limit":"U heeft de limiet van {limit} lijnen bereikt"},"expander":{"label_expand":"Meer","label_collapse":"Minder"},"countries":{"all":"Alle landen","NL":"Nederland","EN":"Engeland","BE":"België","FR":"Frankrijk","LU":"Luxemburg"},"modals":{"seller":{"label_subtitle":"Verkopen","button_close":"Sluiten","columns":{"buyer":"Klant","address":"Adres"}},"buyer":{"button_close":"Sluiten"}},"widgets":{"error_general":"Er is iets mis gegaan, probeer het opnieuw","error_rate_limit":"Te veel verzoeken, kalmeer","error_not_found":"Data niet gevonden","quick_insights":{"title":"Snelle inzichten","label_conversion_current":"Bestelbonnen ondertekend huidige periode","label_conversion_compare":"Bestelbonnen ondertekend vorige periode","label_conversion_delta":"Verschil","label_range":"Ten opzichte van {start} t/m {end}"},"sellers":{"title":"Afspraak conversie","label_no_data":"Geen gegevens voor selectie","columns":{"name":"Naam verkoper","appointments":"Afspraken","sold":"Verkocht","conversion":"Percentage","revenue":"Omzet"}},"geotable":{"title":"Geografische data","label_no_data":"Geen gegevens voor dit gebied","columns":{"country_id":"Land","province_id":"Provincie","language_id":"Taal","postal_code":"Postcode","postal_code_group":"Postcode groep","lead":"Lead","appointment":"Afspraak verkoper","offer":"Plaatsing in te plannen","sales":"Plaatsing ingepland"}},"tracker_graph":{"title":"Overzicht","label_xaxis":"Datum","label_yaxis":"Interacties","lines":{"lead":"Mogelijke klant","followup":"Opvolg mogelijkheid","appointment":"Afspraak","billed":"Gefactureerd"}},"year_graph":{"title":"Verkopen in {country}","format_label":"MMM","format_tooltip":"MMMM","label_xaxis":"Datum","label_yaxis":"Verkopen (euro)","columns":{"year":"Jaar","value":"Omzet (ex. BTW)"}}}}

/***/ }),

/***/ 638:
/***/ (function(module, exports) {

module.exports = {"menu":{"title_logo":"Tableau de bord Minimax","dashboard":"Tableau de bord","annualreport":"Report annuel","signout":"Déconnexion"},"auth":{"header_signin":"Connexion avec nom d'utilisateur et mot de passe","header_forgotten_password":"Mot de passe oublié?","header_reset_password":"Changez votre mot de passe","message_forgotten_password":"Entrez votre adresse e-mail ci-dessous et nous vous enverrons un e-mail pour réinitialiser votre mot de passe.","message_busy":"Se connecter...","hint_email":"Adresse e-mail","hint_password":"Mot de passe","button_signin":"S'identifier","button_reset_password":"Réinitialiser le mot de passe","button_cancel":"Annuler","button_change_password":"Changer le mot de passe","link_no_account":"Ne pas avoir de compte?","link_forgot_password":"Mot de passe oublié?"},"footer":{"copyrights":"Adoucisseurs Minimax. Tous les droits sont réservés"},"single_sign_on":{"header_no_sso":"Vous n'êtes pas autorisé à visiter cette page","header_sso_busy":"Authentification unique","header_sso_error":"Une erreur s'est produite lors de la connexion","link_go_back":"Retourner"},"notfound":{"header":"Sorry, this page does not exist","link_go_back":"Retourner"},"cookies":{"banner":{"title":"Ce site utilise des cookies pour améliorer l'expérience utilisateur","button_confirm":"Je comprends","button_info":"Plus d'information"},"modal":{"title":"Cookies","message":"Ce site utilise des cookies pour améliorer l'expérience utilisateur.","button_confirm":"Je comprends"},"infopage":{"title":"Notre politique de cookies","sections":["TODO: Write cookie policy","Second line of cookie policy","Third line of cookie policy"]}},"datepicker":{"months":["Janvier","Février","Mars","Avril","Mai","Juin","Julliet","Août","Septembre","Octobre","Novembre","Décembre"],"months_short":["janv.","févr.","mars","avril","mai","juin","juil.","août","sept.","oct.","nov.","déc."],"days":["Dim","Lun","Mar","Mer","Jeu","Ven","Sam"],"year_suffix":""},"presetbar":{"label_placeholder":"Choisissez la plage...","label_days7":"7 derniers jours","label_days30":"30 derniers jours","label_thismonth":"Ce mois-ci","label_thisyear":"Cette année","label_months1":"Le mois dernier","label_months3":"3 derniers mois","label_months6":"6 derniers mois"},"dashboard":{"datepickers":{"from":"Données de","to":"jusqu'à et y compris","highlight":"Vous visualisez maintenant les données de"}},"annualreport":{"title":"Chiffres annuels"},"loader":{"loading":"Obtenir des données","error":"Quelque chose s'est mal passé"},"graph_container":{"label_no_data":"Aucune donnée disponible","label_no_selection":"Sélectionner les données du graphe à tracer","label_dropdown":"Sélectionnez les données du graphique","label_dropdown_limit":"Vous avez atteint la limite de {limit} lignes"},"expander":{"label_expand":"Plus","label_collapse":"Moins"},"countries":{"all":"Tous les pays","NL":"les Pays-Bas","EN":"l'Angleterre","BE":"La Belgique","FR":"La France","LU":"Luxembourg"},"modals":{"seller":{"label_subtitle":"Vendre","button_close":"Fermer","columns":{"buyer":"Client","address":"Adresse"}},"buyer":{"button_close":"Fermer"}},"widgets":{"error_general":"Quelque chose s'est mal passé, essayez à nouveau","error_rate_limit":"Trop de requêtes, calme","error_not_found":"Données non trouvées","quick_insights":{"title":"Aperçu rapide","label_conversion_current":"Reçus de commandes signés période en cours","label_conversion_compare":"Reçus de commande signés la dernière période","label_conversion_delta":"Différence","label_range":"Par rapport à {start} de {end}"},"sellers":{"title":"Vendeurs","label_no_data":"Aucune donnée pour la sélection","columns":{"name":"Nom du vendeur","appointments":"Rendez-vous","sold":"Vendu","conversion":"Pourcentage","revenue":"Chiffre d'affaires"}},"geotable":{"title":"Données géographiques","label_no_data":"Aucune donnée pour cette zone","columns":{"country_id":"Pays","province_id":"Province","language_id":"La langue","postal_code":"Code postal","postal_code_group":"Groupe de code postal","lead":"Lead","appointment":"Nomination","offer":"Proposition","sales":"Vendu"}},"tracker_graph":{"title":"Aperçu","label_xaxis":"Date","label_yaxis":"Interactions","lines":{"lead":"Client possible","followup":"Possibilité de suivi","appointment":"Nomination","billed":"Facturé"}},"year_graph":{"title":"Vendre en {country}","format_label":"MMM","format_tooltip":"MMMM","label_xaxis":"Date","label_yaxis":"Vendre (euro)","columns":{"year":"Année","value":"CA (hors TVA)"}}}}

/***/ }),

/***/ 639:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
    'nl': {
        'percentage': {
            style: 'percent',
            minimumFractionDigits: 0,
            maximumFractionDigits: 1
        },
        'percentage_whole': {
            style: 'percent',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        },
        'number_whole': {
            style: 'decimal',
            maximumFractionDigits: 0
        },
        'money': {
            style: 'currency',
            currency: 'EUR',
            currencyDisplay: 'symbol',
            useGrouping: true
        }
    },
    'fr': {
        'percentage': {
            style: 'percent',
            minimumFractionDigits: 0,
            maximumFractionDigits: 1
        },
        'percentage_whole': {
            style: 'percent',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        },
        'number_whole': {
            style: 'decimal',
            maximumFractionDigits: 0
        },
        'money': {
            style: 'currency',
            currency: 'EUR',
            currencyDisplay: 'symbol',
            useGrouping: true
        }
    }
});

/***/ }),

/***/ 640:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('single-select',{attrs:{"options":_vm.languages},model:{value:(_vm.selectedLanguage),callback:function ($$v) {_vm.selectedLanguage=$$v},expression:"selectedLanguage"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 641:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"header"},[_c('router-link',{staticClass:"header__logo",attrs:{"to":{ name: 'home' }}},[_c('img',{attrs:{"src":"/static/img/minimax-logo@2x.png","alt":_vm.$t('menu.title_logo'),"title":_vm.$t('menu.title_logo'),"height":"48px"}})]),_vm._v(" "),_c('language-picker',{staticClass:"header__language"}),_vm._v(" "),[_c('a',{staticClass:"nav__toggle_mobile",attrs:{"href":"#"},on:{"click":_vm.toggleMobileMenu}},[_vm._v("\n            Menu\n            "),_c('span',{staticClass:"nav__toggle_mobile__icon"},[_c('transition',{attrs:{"name":"fade"}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showMobileMenu),expression:"!showMobileMenu"}],staticClass:"mdi mdi-menu"})]),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.showMobileMenu),expression:"showMobileMenu"}],staticClass:"mdi mdi-close"})])],1)]),_vm._v(" "),_c('nav',{staticClass:"nav",class:{ 'is-active': _vm.showMobileMenu }},[_c('ul',[(_vm.authenticated)?_c('li',{staticClass:"nav__item"},[_c('router-link',{staticClass:"nav__link",attrs:{"to":{ name: 'dashboard' }},nativeOn:{"click":function($event){_vm.toggleMobileMenu($event)}}},[_vm._v(_vm._s(_vm.$t('menu.dashboard')))])],1):_vm._e(),_vm._v(" "),(_vm.authenticated)?_c('li',{staticClass:"nav__item"},[_c('router-link',{staticClass:"nav__link",attrs:{"to":{ name: 'annualreport' }},nativeOn:{"click":function($event){_vm.toggleMobileMenu($event)}}},[_vm._v(_vm._s(_vm.$t('menu.annualreport')))])],1):_vm._e(),_vm._v(" "),_c('li',{staticClass:"nav__item--mobile"},[_c('language-picker',{staticClass:"header__language"})],1),_vm._v(" "),(_vm.authenticated)?_c('li',{staticClass:"nav__item--mobile"},[_c('a',{staticClass:"nav__link",on:{"click":_vm.signOut},nativeOn:{"click":function($event){$event.preventDefault();_vm.toggleMobileMenu($event)}}},[_vm._v("\n                        "+_vm._s(_vm.$t('menu.signout'))+"\n                    ")])]):_vm._e()])])]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 642:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Topbar_vue__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fa6e888_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Topbar_vue__ = __webpack_require__(644);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Topbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fa6e888_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Topbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 643:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Topbar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__);






var _dec, _class;




var Topbar = (_dec = Object(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__["Component"])(), _dec(_class = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Topbar, _Vue);

    function Topbar() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Topbar);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Topbar.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Topbar)).call.apply(_ref, [this].concat(args))), _this), _this.name = 'topbar', _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Topbar, [{
        key: 'signOut',
        value: function signOut() {
            var _this2 = this;

            this.$auth.signOut().then(function () {
                _this2.$router.go(_this2.$config.redirects.signout);
            });
        }
    }]);

    return Topbar;
}(__WEBPACK_IMPORTED_MODULE_5_vue__["default"])) || _class);


/***/ }),

/***/ 644:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.getters.currentUser)?_c('div',{staticClass:"topbar"},[_c('a',{staticClass:"topbar__logout",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.signOut($event)}}},[_vm._v(_vm._s(_vm.$t('menu.signout')))])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 645:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SellerModal_vue__ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2715e40e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SellerModal_vue__ = __webpack_require__(653);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SellerModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2715e40e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SellerModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 646:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SellerModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__general_ModalWrapper__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__general_Loader__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__api_format_query__ = __webpack_require__(160);







var _dec, _class;







var SellerModal = (_dec = Object(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__["Component"])({
    components: {
        ModalWrapper: __WEBPACK_IMPORTED_MODULE_8__general_ModalWrapper__["a" /* default */],
        Loader: __WEBPACK_IMPORTED_MODULE_9__general_Loader__["a" /* default */]
    }
}), _dec(_class = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(SellerModal, _Vue);

    function SellerModal() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, SellerModal);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = SellerModal.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(SellerModal)).call.apply(_ref, [this].concat(args))), _this), _this.name = 'seller-modal', _this.api = {
            endpoint: 'dashboard/api/sales/contact_persons',
            loading: false,
            error: false
        }, _this.query = {
            daterange: {},
            country_id: null,
            account_id: null
        }, _this.seller = {
            id: 1,
            name: 'Nico Favresse',
            sales: [{
                id: 1,
                buyer: { id: 1, name: 'SomeBuyer' },
                address: 'de Bjirk 2'
            }, {
                id: 2,
                buyer: { id: 1, name: 'SomeBuyer' },
                address: 'de Bjirk 2'
            }, {
                id: 3,
                buyer: { id: 2, name: 'McRichFace' },
                address: 'Rondestraat 9'
            }, {
                id: 4,
                buyer: { id: 2, name: 'McRichFace' },
                address: 'Rondestraat 9'
            }]
        }, _this.response = [{
            'id': 128466,
            'crm_contact_person_id': 43538,
            'action_timestamp': '03-05-2018 11:45',
            'completed': false,
            'name': 'Jeremy Gilson',
            'postal_code': '7340',
            'city_name': 'Colfontaine'
        }, {
            'id': 86259,
            'crm_contact_person_id': 36074,
            'action_timestamp': '21-01-2016 17:00',
            'completed': true,
            'name': 'Francine Natalis',
            'postal_code': '4053',
            'city_name': 'Embourg'
        }], _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(SellerModal, [{
        key: 'setupData',
        value: function setupData(modalOptions) {
            var _this2 = this;

            console.log('[ SellerModal ]', modalOptions);
            this.seller = modalOptions.params.seller;
            this.query = modalOptions.params.query;
            this.api.loading = true;
            this.api.error = false;
            this.querySellerData(this.seller.id).catch(function (e) {
                return _this2.onQueryError(e);
            }).then(function (response) {
                return _this2.onQueryData(response);
            }).then(function () {
                return _this2.api.error = false;
            }).catch(function () {
                return _this2.api.error = true;
            }).finally(function () {
                return _this2.api.loading = false;
            });
        }
    }, {
        key: 'querySellerData',
        value: function querySellerData(sellerId) {
            return this.axios.post(this.api.endpoint, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_10__api_format_query__["b" /* formatQuery */])(this.query), { google_calendar_id: sellerId }));
        }
    }, {
        key: 'onQueryError',
        value: function onQueryError(error) {
            var status = error.response && error.response.status;
            if (status === 404) {
                return { data: [] };
            } else {
                throw error;
            }
        }
    }, {
        key: 'onQueryData',
        value: function onQueryData(_ref2) {
            var _ref2$data = _ref2.data,
                data = _ref2$data === undefined ? [] : _ref2$data;

            this.seller.sales = data.map(function (entry) {
                return {
                    id: entry.id,
                    buyer: {
                        id: entry.crm_contact_person_id,
                        name: entry.name
                    },
                    address: entry.city_name + ' ' + entry.postal_code
                };
            });
        }
    }, {
        key: 'onSaleClicked',
        value: function onSaleClicked(sale) {
            var redirects = this.$config.redirects;
            if (redirects && redirects.crm_contact_person) {
                window.open(redirects.crm_contact_person + sale.buyer.id, '_blank');
            }
        }
    }]);

    return SellerModal;
}(__WEBPACK_IMPORTED_MODULE_6_vue__["default"])) || _class);


/***/ }),

/***/ 651:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Loading; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__);






var _dec, _dec2, _dec3, _dec4, _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4;

function _initDefineProp(target, property, descriptor, context) {
    if (!descriptor) return;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, property, {
        enumerable: descriptor.enumerable,
        configurable: descriptor.configurable,
        writable: descriptor.writable,
        value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
    });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}

function _initializerWarningHelper(descriptor, context) {
    throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}




var Loading = (_dec = Object(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__["Prop"])({ default: false, type: Boolean }), _dec2 = Object(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__["Prop"])({ type: String }), _dec3 = Object(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__["Prop"])({ default: false, type: Boolean }), _dec4 = Object(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__["Prop"])({ type: String }), Object(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__["Component"])(_class = (_class2 = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Loading, _Vue);

    function Loading() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Loading);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Loading.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(Loading)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'loading', _descriptor, _this), _initDefineProp(_this, 'loadingMessage', _descriptor2, _this), _initDefineProp(_this, 'error', _descriptor3, _this), _initDefineProp(_this, 'errorMessage', _descriptor4, _this), _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    return Loading;
}(__WEBPACK_IMPORTED_MODULE_5_vue__["default"]), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'loading', [_dec], {
    enumerable: true,
    initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'loadingMessage', [_dec2], {
    enumerable: true,
    initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, 'error', [_dec3], {
    enumerable: true,
    initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, 'errorMessage', [_dec4], {
    enumerable: true,
    initializer: null
})), _class2)) || _class);


/***/ }),

/***/ 652:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader"},[(_vm.loading)?_c('div',[_c('h3',{staticClass:"loader__loading"},[_vm._v("\n            "+_vm._s(_vm.loadingMessage || _vm.$t('loader.loading'))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"spinner"})]):_c('div',[(_vm.error)?_c('div',[_c('h3',{staticClass:"loader__error"},[_vm._v("\n                "+_vm._s(_vm.errorMessage || _vm.$t('loader.error'))+"\n            ")])]):_c('div',[_vm._t("default")],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 653:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-wrapper',{attrs:{"modalClass":"modal","modalName":_vm.name},on:{"before-open":_vm.setupData}},[_c('div',{staticClass:"modal__header"},[_c('h1',[_vm._v(_vm._s(_vm.seller.name))]),_vm._v(" "),_c('h2',[_vm._v(_vm._s(_vm.$t('modals.seller.label_subtitle')))])]),_vm._v(" "),_c('div',{staticClass:"modal__content"},[_c('loader',{staticClass:"table__responsive",attrs:{"loading":_vm.api.loading,"error":_vm.api.error}},[_c('table',{staticClass:"table--hover--clickable"},[_c('thead',[_c('tr',[_c('th',[_vm._v("\n                            "+_vm._s(_vm.$t('modals.seller.columns.buyer'))+"\n                        ")]),_vm._v(" "),_c('th',[_vm._v("\n                            "+_vm._s(_vm.$t('modals.seller.columns.address'))+"\n                        ")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.seller.sales),function(sale){return _c('tr',{on:{"click":function($event){_vm.onSaleClicked(sale)}}},[_c('td',[_vm._v(_vm._s(sale.buyer.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(sale.address))])])}))])])],1),_vm._v(" "),_c('div',{staticClass:"modal__footer"},[_c('button',{staticClass:"button--cta",attrs:{"type":"button"},on:{"click":function($event){_vm.$modal.hide(_vm.name)}}},[_vm._v("\n            "+_vm._s(_vm.$t('modals.seller.button_close'))+"\n        ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 654:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper",attrs:{"id":"app"}},[_c('topbar'),_vm._v(" "),_c('the-header'),_vm._v(" "),_c('main',{staticClass:"main"},[_c('div',{staticClass:"container"},[_c('router-view')],1)]),_vm._v(" "),_c('the-footer'),_vm._v(" "),_c('cookie-notification'),_vm._v(" "),_c('seller-modal')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 655:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_modules_auth__ = __webpack_require__(161);



var AuthHandler = {
    install: function install(Vue, options) {
        Vue.prototype.$auth = {
            currentUser: function currentUser() {
                return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].getters.currentUser;
            },
            signInWithToken: function signInWithToken(sso_token) {
                return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_1__store_modules_auth__["a" /* LOGIN_SSO */], sso_token);
            },
            signOut: function signOut() {
                return __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch(__WEBPACK_IMPORTED_MODULE_1__store_modules_auth__["b" /* LOGOUT */]);
            }
        };
    }
};

/* harmony default export */ __webpack_exports__["a"] = (AuthHandler);

/***/ }),

/***/ 670:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_PageNotFound__ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_DashboardPage__ = __webpack_require__(675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_Styleguide__ = __webpack_require__(813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_AuthenticationPage__ = __webpack_require__(835);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_AnnualReportPage__ = __webpack_require__(844);








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    mode: 'history',
    linkActiveClass: 'is-active',
    routes: [{
        path: '/',
        name: 'home',
        redirect: { name: 'dashboard' }
    }, {
        path: '/dashboard/:start(\\d{4}\\-\\d{2}\\-\\d{2})?/:end(\\d{4}\\-\\d{2}\\-\\d{2})?',
        name: 'dashboard',
        component: __WEBPACK_IMPORTED_MODULE_3__pages_DashboardPage__["a" /* default */],
        meta: {
            auth: true
        }
    }, {
        path: '/report/annual',
        name: 'annualreport',
        component: __WEBPACK_IMPORTED_MODULE_6__pages_AnnualReportPage__["a" /* default */],
        meta: {
            auth: true
        }
    }, {
        path: '/auth',
        name: 'sign-in',
        component: __WEBPACK_IMPORTED_MODULE_5__pages_AuthenticationPage__["a" /* default */]
    }, {
        path: '/styleguide',
        name: 'styleguide',
        component: __WEBPACK_IMPORTED_MODULE_4__pages_Styleguide__["a" /* default */],
        meta: {
            debugRoute: true
        }
    }, {
        path: '/page-not-found',
        name: 'PageNotFound',
        component: __WEBPACK_IMPORTED_MODULE_2__pages_PageNotFound__["a" /* default */]
    }, {
        path: '**',
        redirect: '/page-not-found'
    }]
});

router.beforeEach(function (to, from, next) {
    if (to.meta !== undefined && to.meta.auth) {
        if (__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$auth.currentUser() === null) {
            next({
                name: 'sign-in',
                query: {
                    redirect: to.path
                }
            });
            return;
        }
    }
    next();
});

router.beforeEach(function (to, from, next) {
    if (to.matched.some(function (record) {
        return record.meta.debugRoute;
    })) {
        if (!__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$config.debug) {
            next({ path: '/' });
        } else {
            next();
        }
    } else {
        next();
    }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 672:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageNotFound_vue__ = __webpack_require__(673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8118589a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageNotFound_vue__ = __webpack_require__(674);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageNotFound_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8118589a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageNotFound_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 673:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PageNotFound; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_property_decorator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_property_decorator__);





var _class;




var PageNotFound = Object(__WEBPACK_IMPORTED_MODULE_5_vue_property_decorator__["Component"])(_class = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(PageNotFound, _Vue);

    function PageNotFound() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, PageNotFound);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = PageNotFound.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(PageNotFound)).call.apply(_ref, [this].concat(args))), _this), _this.name = 'page-not-found', _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    return PageNotFound;
}(__WEBPACK_IMPORTED_MODULE_4_vue__["default"])) || _class;



/***/ }),

/***/ 674:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block--small"},[_c('h2',[_vm._v("\n        "+_vm._s(_vm.$t('notfound.header'))+"\n    ")]),_vm._v(" "),_c('p',[_c('router-link',{staticClass:"button--cta",attrs:{"to":{ name: 'home' }}},[_vm._v("\n            "+_vm._s(_vm.$t('notfound.link_go_back'))+"\n        ")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 675:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardPage_vue__ = __webpack_require__(676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b65e192a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardPage_vue__ = __webpack_require__(812);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b65e192a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 676:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DashboardPage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_dashboard_PresetBar__ = __webpack_require__(677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_dashboard_DaterangePicker__ = __webpack_require__(686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_dashboard_WidgetDragArea__ = __webpack_require__(692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_dashboard_HighlightedDate__ = __webpack_require__(809);







var _dec, _dec2, _dec3, _class, _desc, _value, _class2;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}









var DashboardPage = (_dec = Object(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__["Component"])({
    components: {
        HighlightedDate: __WEBPACK_IMPORTED_MODULE_12__components_dashboard_HighlightedDate__["a" /* default */],
        PresetBar: __WEBPACK_IMPORTED_MODULE_9__components_dashboard_PresetBar__["a" /* default */],
        DaterangePicker: __WEBPACK_IMPORTED_MODULE_10__components_dashboard_DaterangePicker__["a" /* default */],
        WidgetDragArea: __WEBPACK_IMPORTED_MODULE_11__components_dashboard_WidgetDragArea__["a" /* default */]
    }
}), _dec2 = Object(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__["Watch"])('query.daterange', { deep: true }), _dec3 = Object(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__["Watch"])('$route'), _dec(_class = (_class2 = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(DashboardPage, _Vue);

    function DashboardPage() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, DashboardPage);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = DashboardPage.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(DashboardPage)).call.apply(_ref, [this].concat(args))), _this), _this.query = {
            daterange: {
                start: __WEBPACK_IMPORTED_MODULE_8_moment___default()(),
                end: __WEBPACK_IMPORTED_MODULE_8_moment___default()(),
                highlight: null
            },
            country_id: null
        }, _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(DashboardPage, [{
        key: 'onDaterangeChanged',
        value: function onDaterangeChanged() {
            var start = this.query.daterange.start;
            var end = this.query.daterange.end;
            var route = {
                name: 'dashboard',
                params: {
                    start: start.format('YYYY-MM-DD'),
                    end: end.format('YYYY-MM-DD')
                }
            };
            this.$router.push(route);
        }
    }, {
        key: 'onRouteChanged',
        value: function onRouteChanged() {
            var params = this.$route.params;
            var start = params.start ? __WEBPACK_IMPORTED_MODULE_8_moment___default()(params.start) : __WEBPACK_IMPORTED_MODULE_8_moment___default.a.invalid();
            var end = params.end ? __WEBPACK_IMPORTED_MODULE_8_moment___default()(params.end) : __WEBPACK_IMPORTED_MODULE_8_moment___default.a.invalid();

            if (!this.isRangeValid(start, end)) {
                start = __WEBPACK_IMPORTED_MODULE_8_moment___default()().subtract(7, 'days');
                end = __WEBPACK_IMPORTED_MODULE_8_moment___default()();
            }

            var daterange = this.query.daterange;
            var sameRange = start.isSame(daterange.start, 'day') && end.isSame(daterange.end, 'day');
            if (!sameRange) {
                this.query.daterange.start = start;
                this.query.daterange.end = end;
            }
        }
    }, {
        key: 'isRangeValid',
        value: function isRangeValid(start, end) {
            return start.isValid() && end.isValid() && !start.isAfter(end, 'day');
        }
    }, {
        key: 'mounted',
        value: function mounted() {
            this.onRouteChanged();
        }
    }]);

    return DashboardPage;
}(__WEBPACK_IMPORTED_MODULE_6_vue__["default"]), (_applyDecoratedDescriptor(_class2.prototype, 'onDaterangeChanged', [_dec2], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'onDaterangeChanged'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onRouteChanged', [_dec3], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'onRouteChanged'), _class2.prototype)), _class2)) || _class);


/***/ }),

/***/ 677:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PresetBar_vue__ = __webpack_require__(678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78cf8f34_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PresetBar_vue__ = __webpack_require__(685);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PresetBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78cf8f34_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PresetBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 678:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PresetBar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__presetbar_DaterangePresets__ = __webpack_require__(679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__presetbar_CountryFilter__ = __webpack_require__(682);






var _dec, _dec2, _class, _desc, _value, _class2, _descriptor;

function _initDefineProp(target, property, descriptor, context) {
    if (!descriptor) return;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, property, {
        enumerable: descriptor.enumerable,
        configurable: descriptor.configurable,
        writable: descriptor.writable,
        value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
    });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}

function _initializerWarningHelper(descriptor, context) {
    throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}






var PresetBar = (_dec = Object(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__["Component"])({
    components: {
        DaterangePresets: __WEBPACK_IMPORTED_MODULE_7__presetbar_DaterangePresets__["a" /* default */],
        CountryFilter: __WEBPACK_IMPORTED_MODULE_8__presetbar_CountryFilter__["a" /* default */]
    }
}), _dec2 = Object(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__["Model"])({
    type: Object,
    default: function _default() {
        return {
            begin: null,
            end: null
        };
    }
}), _dec(_class = (_class2 = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(PresetBar, _Vue);

    function PresetBar() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, PresetBar);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = PresetBar.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(PresetBar)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'query', _descriptor, _this), _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    return PresetBar;
}(__WEBPACK_IMPORTED_MODULE_5_vue__["default"]), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'query', [_dec2], {
    enumerable: true,
    initializer: null
})), _class2)) || _class);


/***/ }),

/***/ 679:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DaterangePresets_vue__ = __webpack_require__(680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f87185e8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DaterangePresets_vue__ = __webpack_require__(681);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DaterangePresets_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f87185e8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DaterangePresets_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 680:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DaterangePresets; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__general_SingleSelect__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment__);








var _dec, _dec2, _class, _desc, _value, _class2, _descriptor;

function _initDefineProp(target, property, descriptor, context) {
    if (!descriptor) return;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, property, {
        enumerable: descriptor.enumerable,
        configurable: descriptor.configurable,
        writable: descriptor.writable,
        value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
    });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}

function _initializerWarningHelper(descriptor, context) {
    throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}






var DaterangePresets = (_dec = Object(__WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__["Component"])({
    components: {
        SingleSelect: __WEBPACK_IMPORTED_MODULE_9__general_SingleSelect__["a" /* default */]
    }
}), _dec2 = Object(__WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__["Model"])({
    type: Object,
    default: function _default() {
        return {
            begin: null,
            end: null
        };
    }
}), _dec(_class = (_class2 = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(DaterangePresets, _Vue);

    function DaterangePresets() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, DaterangePresets);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = DaterangePresets.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(DaterangePresets)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'daterange', _descriptor, _this), _this.presets = [{ label: 'presetbar.label_days7', to: function to() {
                return _this.linkDays(7);
            } }, { label: 'presetbar.label_days30', to: function to() {
                return _this.linkDays(30);
            } }, { label: 'presetbar.label_thismonth', to: function to() {
                return _this.linkThisMonth();
            } }, { label: 'presetbar.label_thisyear', to: function to() {
                return _this.linkThisYear();
            } }, { label: 'presetbar.label_months1', to: function to() {
                return _this.linkMonths(1);
            } }, { label: 'presetbar.label_months3', to: function to() {
                return _this.linkMonths(3);
            } }, { label: 'presetbar.label_months6', to: function to() {
                return _this.linkMonths(6);
            } }], _temp), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(DaterangePresets, [{
        key: 'onPresetSelected',
        value: function onPresetSelected(preset) {
            var _preset$to = preset.to(),
                start = _preset$to.start,
                end = _preset$to.end;

            this.setDateRange(start, end);
        }
    }, {
        key: 'localizeOption',
        value: function localizeOption(option) {
            return this.$t(option.label);
        }
    }, {
        key: 'linkDays',
        value: function linkDays(days) {
            var end = __WEBPACK_IMPORTED_MODULE_10_moment___default()();

            var start = __WEBPACK_IMPORTED_MODULE_10_moment___default()(end).subtract(days - 1, 'days');
            return { start: start, end: end };
        }
    }, {
        key: 'linkMonths',
        value: function linkMonths(months) {
            var end = __WEBPACK_IMPORTED_MODULE_10_moment___default()();
            var start = __WEBPACK_IMPORTED_MODULE_10_moment___default()(end).subtract(months, 'months');
            return { start: start, end: end };
        }
    }, {
        key: 'linkThisMonth',
        value: function linkThisMonth() {
            var end = __WEBPACK_IMPORTED_MODULE_10_moment___default()().endOf('month');
            var start = __WEBPACK_IMPORTED_MODULE_10_moment___default()(end).startOf('month');
            return { start: start, end: end };
        }
    }, {
        key: 'linkThisYear',
        value: function linkThisYear() {
            var end = __WEBPACK_IMPORTED_MODULE_10_moment___default()().endOf('year');
            var start = __WEBPACK_IMPORTED_MODULE_10_moment___default()(end).startOf('year');
            return { start: start, end: end };
        }
    }, {
        key: 'setDateRange',
        value: function setDateRange(start, end) {
            this.daterange.start = start;
            this.daterange.end = end;
            this.daterange.highlight = null;
        }
    }, {
        key: 'usedPreset',
        get: function get() {
            var start = __WEBPACK_IMPORTED_MODULE_10_moment___default()(this.daterange.start);
            var end = __WEBPACK_IMPORTED_MODULE_10_moment___default()(this.daterange.end);
            return this.presets.map(function (preset) {
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({ preset: preset }, preset.to());
            }).filter(function (data) {
                return start.isSame(data.start, 'day');
            }).filter(function (data) {
                return end.isSame(data.end, 'day');
            }).map(function (data) {
                return data.preset;
            })[0] || null;
        }
    }]);

    return DaterangePresets;
}(__WEBPACK_IMPORTED_MODULE_7_vue__["default"]), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'daterange', [_dec2], {
    enumerable: true,
    initializer: null
})), _class2)) || _class);


/***/ }),

/***/ 681:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('single-select',{attrs:{"value":_vm.usedPreset,"options":_vm.presets,"getOptionLabel":_vm.localizeOption,"placeholder":_vm.$t('presetbar.label_placeholder')},on:{"input":_vm.onPresetSelected}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 682:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CountryFilter_vue__ = __webpack_require__(683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aca2b472_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CountryFilter_vue__ = __webpack_require__(684);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CountryFilter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aca2b472_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CountryFilter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 683:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CountryFilter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__general_SingleSelect__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_modules_countries__ = __webpack_require__(163);







var _dec, _dec2, _class, _desc, _value, _class2, _descriptor;

function _initDefineProp(target, property, descriptor, context) {
    if (!descriptor) return;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, property, {
        enumerable: descriptor.enumerable,
        configurable: descriptor.configurable,
        writable: descriptor.writable,
        value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
    });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}

function _initializerWarningHelper(descriptor, context) {
    throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}






var CountryFilter = (_dec = Object(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__["Component"])({
    components: { SingleSelect: __WEBPACK_IMPORTED_MODULE_8__general_SingleSelect__["a" /* default */] }
}), _dec2 = Object(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__["Model"])('input', { type: Number, default: null }), _dec(_class = (_class2 = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(CountryFilter, _Vue);

    function CountryFilter() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, CountryFilter);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = CountryFilter.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(CountryFilter)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'input', _descriptor, _this), _this.allCountry = {
            id: null,
            code: 'all',
            has_sales: true
        }, _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(CountryFilter, [{
        key: 'created',
        value: function created() {
            this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_9__store_modules_countries__["a" /* COUNTRIES_GET */]);
        }
    }, {
        key: 'localizeOption',
        value: function localizeOption(country) {
            return this.$t('countries.' + country.code);
        }
    }, {
        key: 'onCountrySelected',
        value: function onCountrySelected(country) {
            this.country_id = country ? country.id : null;
        }
    }, {
        key: 'country_id',
        get: function get() {
            return this.input;
        },
        set: function set(value) {
            this.$emit('input', value);
        }
    }, {
        key: 'countries',
        get: function get() {
            return [this.allCountry].concat(this.$store.state.countries.countries);
        }
    }, {
        key: 'loading',
        get: function get() {
            return this.$store.state.countries.loading;
        }
    }, {
        key: 'error',
        get: function get() {
            return this.$store.state.countries.errors.length > 0;
        }
    }, {
        key: 'selectedCountry',
        get: function get() {
            var _this2 = this;

            if (this.loading || this.error || !this.country_id) {
                return this.allCountry;
            } else {
                return this.countries.find(function (country) {
                    return country.id === _this2.country_id;
                });
            }
        }
    }]);

    return CountryFilter;
}(__WEBPACK_IMPORTED_MODULE_6_vue__["default"]), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'input', [_dec2], {
    enumerable: true,
    initializer: null
})), _class2)) || _class);


/***/ }),

/***/ 684:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('single-select',{attrs:{"value":_vm.selectedCountry,"options":_vm.countries,"getOptionLabel":_vm.localizeOption},on:{"input":_vm.onCountrySelected}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 685:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-md-6 col-lg-12"},[_c('div',{staticClass:"preset_bar"},[_c('div',{staticClass:"preset_bar__field"},[_c('i',{staticClass:"icon icon-chevron-down"}),_vm._v(" "),_c('i',{staticClass:"preset_bar__icon mdi mdi-clock-outline"}),_vm._v(" "),_c('daterange-presets',{model:{value:(_vm.query.daterange),callback:function ($$v) {_vm.$set(_vm.query, "daterange", $$v)},expression:"query.daterange"}})],1),_vm._v(" "),_c('div',{staticClass:"preset_bar__field"},[_c('i',{staticClass:"icon icon-chevron-down"}),_vm._v(" "),_c('i',{staticClass:"preset_bar__icon mdi mdi-map-marker-outline"}),_vm._v(" "),_c('country-filter',{model:{value:(_vm.query.country_id),callback:function ($$v) {_vm.$set(_vm.query, "country_id", $$v)},expression:"query.country_id"}})],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 686:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DaterangePicker_vue__ = __webpack_require__(687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e43d669_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DaterangePicker_vue__ = __webpack_require__(691);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DaterangePicker_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e43d669_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DaterangePicker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 687:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DaterangePicker; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__general_Datepicker__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);







var _dec, _dec2, _class, _desc, _value, _class2, _descriptor;

function _initDefineProp(target, property, descriptor, context) {
    if (!descriptor) return;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, property, {
        enumerable: descriptor.enumerable,
        configurable: descriptor.configurable,
        writable: descriptor.writable,
        value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
    });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}

function _initializerWarningHelper(descriptor, context) {
    throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}






var DaterangePicker = (_dec = Object(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__["Component"])({
    components: {
        Datepicker: __WEBPACK_IMPORTED_MODULE_8__general_Datepicker__["a" /* default */]
    }
}), _dec2 = Object(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__["Model"])({
    type: Object,
    default: function _default() {
        return {
            begin: null,
            end: null
        };
    }
}), _dec(_class = (_class2 = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(DaterangePicker, _Vue);

    function DaterangePicker() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, DaterangePicker);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = DaterangePicker.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(DaterangePicker)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'daterange', _descriptor, _this), _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(DaterangePicker, [{
        key: 'start',
        get: function get() {
            return this.daterange.start.toDate();
        },
        set: function set(value) {
            this.daterange.start = __WEBPACK_IMPORTED_MODULE_9_moment___default()(value);
        }
    }, {
        key: 'end',
        get: function get() {
            return this.daterange.end.toDate();
        },
        set: function set(value) {
            this.daterange.end = __WEBPACK_IMPORTED_MODULE_9_moment___default()(value);
        }
    }]);

    return DaterangePicker;
}(__WEBPACK_IMPORTED_MODULE_6_vue__["default"]), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'daterange', [_dec2], {
    enumerable: true,
    initializer: null
})), _class2)) || _class);


/***/ }),

/***/ 688:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Datepicker; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuejs_datepicker__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__languages__ = __webpack_require__(113);







var _dec, _dec2, _dec3, _dec4, _dec5, _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4;

function _initDefineProp(target, property, descriptor, context) {
    if (!descriptor) return;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, property, {
        enumerable: descriptor.enumerable,
        configurable: descriptor.configurable,
        writable: descriptor.writable,
        value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
    });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}

function _initializerWarningHelper(descriptor, context) {
    throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}







var Datepicker = (_dec = Object(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__["Component"])({
    components: {
        VuejsDatepicker: __WEBPACK_IMPORTED_MODULE_8_vuejs_datepicker__["a" /* default */]
    }
}), _dec2 = Object(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__["Prop"])({ type: Date }), _dec3 = Object(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__["Prop"])({ type: Boolean, default: false }), _dec4 = Object(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__["Prop"])({ type: Object }), _dec5 = Object(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__["Prop"])({ type: Object }), _dec(_class = (_class2 = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Datepicker, _Vue);

    function Datepicker() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Datepicker);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Datepicker.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(Datepicker)).call.apply(_ref, [this].concat(args))), _this), _this.dynLanguage = {
            get language() {
                return __WEBPACK_IMPORTED_MODULE_9__languages__["a" /* default */].locale;
            },
            get months() {
                return __WEBPACK_IMPORTED_MODULE_9__languages__["a" /* default */].t('datepicker.months');
            },
            get monthsAbbr() {
                return __WEBPACK_IMPORTED_MODULE_9__languages__["a" /* default */].t('datepicker.months_short');
            },
            get days() {
                return __WEBPACK_IMPORTED_MODULE_9__languages__["a" /* default */].t('datepicker.days');
            },
            get rtl() {
                return false;
            },
            get ymd() {
                return false;
            },
            get yearSuffix() {
                return __WEBPACK_IMPORTED_MODULE_9__languages__["a" /* default */].t('datepicker.year_suffix');
            }
        }, _initDefineProp(_this, 'value', _descriptor, _this), _initDefineProp(_this, 'disabled', _descriptor2, _this), _initDefineProp(_this, 'disabledDates', _descriptor3, _this), _initDefineProp(_this, 'highlighted', _descriptor4, _this), _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Datepicker, [{
        key: 'mounted',
        value: function mounted() {
            this.$refs.mainChild.$el.querySelector('input').readOnly = true;
        }
    }]);

    return Datepicker;
}(__WEBPACK_IMPORTED_MODULE_6_vue__["default"]), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'value', [_dec2], {
    enumerable: true,
    initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'disabled', [_dec3], {
    enumerable: true,
    initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, 'disabledDates', [_dec4], {
    enumerable: true,
    initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, 'highlighted', [_dec5], {
    enumerable: true,
    initializer: null
})), _class2)) || _class);


/***/ }),

/***/ 690:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vuejs-datepicker',_vm._b({ref:"mainChild",attrs:{"typeable":false,"language":_vm.dynLanguage},on:{"input":function($event){_vm.$emit('input', $event)}}},'vuejs-datepicker',{value: _vm.value, disabled: _vm.disabled, disabledDates: _vm.disabledDates, highlighted: _vm.highlighted},false))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 691:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"datepicker__container"},[_c('span',{staticClass:"row"},[_c('span',{staticClass:"col-xs-12 col-sm-6"},[_vm._v("\n            "+_vm._s(_vm.$t('dashboard.datepickers.from'))+"\n            "),_c('datepicker',{staticClass:"datepicker",attrs:{"disabledDates":{from: _vm.end},"highlighted":{from:_vm.start, to:_vm.end}},model:{value:(_vm.start),callback:function ($$v) {_vm.start=$$v},expression:"start"}})],1),_vm._v(" "),_c('span',{staticClass:"col-xs-12 col-sm-6"},[_vm._v("\n            "+_vm._s(_vm.$t('dashboard.datepickers.to'))+"\n            "),_c('datepicker',{staticClass:"datepicker",attrs:{"disabledDates":{to: _vm.start},"highlighted":{from:_vm.start, to:_vm.end}},model:{value:(_vm.end),callback:function ($$v) {_vm.end=$$v},expression:"end"}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 692:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WidgetDragArea_vue__ = __webpack_require__(693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ee316e4e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WidgetDragArea_vue__ = __webpack_require__(808);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WidgetDragArea_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ee316e4e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WidgetDragArea_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 693:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WidgetDragArea; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuedraggable__ = __webpack_require__(694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__widgets_quick_insights_QuickInsightsWidget__ = __webpack_require__(696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__widgets_sellers_SellersWidget__ = __webpack_require__(773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__widgets_geotable_GeoTableWidget__ = __webpack_require__(781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__widgets_tracker_graph_TrackerGraphWidget__ = __webpack_require__(798);







var _dec, _dec2, _class, _desc, _value, _class2, _descriptor;

function _initDefineProp(target, property, descriptor, context) {
    if (!descriptor) return;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, property, {
        enumerable: descriptor.enumerable,
        configurable: descriptor.configurable,
        writable: descriptor.writable,
        value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
    });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}

function _initializerWarningHelper(descriptor, context) {
    throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}









var WidgetDragArea = (_dec = Object(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__["Component"])({
    components: {
        draggable: __WEBPACK_IMPORTED_MODULE_8_vuedraggable___default.a
    }
}), _dec2 = Object(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__["Prop"])(), _dec(_class = (_class2 = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(WidgetDragArea, _Vue);

    function WidgetDragArea() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, WidgetDragArea);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = WidgetDragArea.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(WidgetDragArea)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'query', _descriptor, _this), _this.areas = [{
            name: 'top',
            class: 'col-xl-12',
            components: [{ class: __WEBPACK_IMPORTED_MODULE_12__widgets_tracker_graph_TrackerGraphWidget__["a" /* default */], model: {} }]
        }, {
            name: 'left',
            class: 'col-xl-7 col-md-12',
            components: [{ class: __WEBPACK_IMPORTED_MODULE_10__widgets_sellers_SellersWidget__["a" /* default */], model: {} }]
        }, {
            name: 'right',
            class: 'col-xl-5 col-md-12',
            components: [{ class: __WEBPACK_IMPORTED_MODULE_9__widgets_quick_insights_QuickInsightsWidget__["a" /* default */], model: {} }]
        }, {
            name: 'bottom',
            class: 'col-xl-12',
            components: [{ class: __WEBPACK_IMPORTED_MODULE_11__widgets_geotable_GeoTableWidget__["a" /* default */], model: {} }]
        }], _this.dragOptions = {
            group: 'widgets',
            handle: '.widget__handle',
            ghostClass: 'widget__ghost',
            dragClass: 'widget__drag'
        }, _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(WidgetDragArea, [{
        key: 'onWidgetMove',
        value: function onWidgetMove(event) {
            var _this2 = this;

            if (!this.changeTriggered) {
                this.changeTriggered = true;
                __WEBPACK_IMPORTED_MODULE_6_vue__["default"].nextTick().then(function () {
                    _this2.changeTriggered = false;
                    _this2.onWidgetLayoutChanged();
                });
            }
        }
    }, {
        key: 'onWidgetLayoutChanged',
        value: function onWidgetLayoutChanged() {}
    }]);

    return WidgetDragArea;
}(__WEBPACK_IMPORTED_MODULE_6_vue__["default"]), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'query', [_dec2], {
    enumerable: true,
    initializer: null
})), _class2)) || _class);


/***/ }),

/***/ 696:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QuickInsightsWidget_vue__ = __webpack_require__(697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_464238d5_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QuickInsightsWidget_vue__ = __webpack_require__(772);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QuickInsightsWidget_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_464238d5_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QuickInsightsWidget_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 697:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return QuickInsightsWidget; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DashboardWidget__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__WidgetWrapper__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__WidgetDataDecorator__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__PercentagePie__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_moment__);







var _dec, _dec2, _class, _desc, _value, _class2, _descriptor;

function _initDefineProp(target, property, descriptor, context) {
    if (!descriptor) return;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, property, {
        enumerable: descriptor.enumerable,
        configurable: descriptor.configurable,
        writable: descriptor.writable,
        value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
    });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}

function _initializerWarningHelper(descriptor, context) {
    throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}








var QuickInsightsWidget = (_dec = Object(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__["Component"])({
    components: {
        WidgetWrapper: __WEBPACK_IMPORTED_MODULE_8__WidgetWrapper__["a" /* default */],
        PercentagePie: __WEBPACK_IMPORTED_MODULE_10__PercentagePie__["a" /* default */]
    }
}), _dec2 = Object(__WEBPACK_IMPORTED_MODULE_9__WidgetDataDecorator__["a" /* default */])(function () {
    return {
        'num_total_appointments': 8,
        'num_total_orders': 9,
        'num_total_appointments_second_period': 7,
        'num_total_orders_second_period': 10,
        'second_period': { 'start': '2017-05-08', 'end': '2017-12-31' },
        'conversion_rate': 88.88888888888889,
        'conversion_rate_second_period': 70
    };
}), _dec(_class = (_class2 = function (_DashboardWidget) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(QuickInsightsWidget, _DashboardWidget);

    function QuickInsightsWidget() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, QuickInsightsWidget);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = QuickInsightsWidget.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(QuickInsightsWidget)).call.apply(_ref, [this].concat(args))), _this), _this.api = {
            endpoint: 'dashboard/api/sales/quick_insights'
        }, _initDefineProp(_this, 'response', _descriptor, _this), _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(QuickInsightsWidget, [{
        key: 'onQueryData',
        value: function onQueryData(_ref2) {
            var data = _ref2.data;

            this.response = data;
        }
    }, {
        key: 'currentPeriod',
        get: function get() {
            return {
                start: __WEBPACK_IMPORTED_MODULE_11_moment___default()(this.query.daterange.start).calendar(),
                end: __WEBPACK_IMPORTED_MODULE_11_moment___default()(this.query.daterange.end).calendar(),
                total_appointments: parseInt(this.response.num_total_appointments),
                total_orders: parseInt(this.response.num_total_orders),
                conversion: this.response.conversion_rate / 100
            };
        }
    }, {
        key: 'comparePeriod',
        get: function get() {
            return {
                start: __WEBPACK_IMPORTED_MODULE_11_moment___default()(this.response.second_period.start).calendar(),
                end: __WEBPACK_IMPORTED_MODULE_11_moment___default()(this.response.second_period.end).calendar(),
                total_appointments: parseInt(this.response.num_total_appointments_second_period),
                total_orders: parseInt(this.response.num_total_orders_second_period),
                conversion: this.response.conversion_rate_second_period / 100
            };
        }
    }]);

    return QuickInsightsWidget;
}(__WEBPACK_IMPORTED_MODULE_7__DashboardWidget__["a" /* default */]), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'response', [_dec2], {
    enumerable: true,
    initializer: null
})), _class2)) || _class);


/***/ }),

/***/ 698:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DashboardWidget; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_property_decorator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__api_format_query__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_axios__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_axios__);









var _dec, _dec2, _dec3, _class, _desc, _value, _class2, _descriptor, _descriptor2;

function _initDefineProp(target, property, descriptor, context) {
    if (!descriptor) return;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, property, {
        enumerable: descriptor.enumerable,
        configurable: descriptor.configurable,
        writable: descriptor.writable,
        value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
    });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}

function _initializerWarningHelper(descriptor, context) {
    throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}






var DashboardWidget = (_dec = Object(__WEBPACK_IMPORTED_MODULE_9_vue_property_decorator__["Prop"])({
    type: Object,
    default: function _default() {
        return {
            daterange: {
                start: new Date(),
                end: new Date()
            },
            filters: {
                recruiter: [],
                company: [],
                branch: [],
                subbranch: []
            }
        };
    }
}), _dec2 = Object(__WEBPACK_IMPORTED_MODULE_9_vue_property_decorator__["Model"])('widgetData', {
    type: Object,
    default: function _default() {
        return {};
    }
}), _dec3 = Object(__WEBPACK_IMPORTED_MODULE_9_vue_property_decorator__["Watch"])('query', { deep: true }), Object(__WEBPACK_IMPORTED_MODULE_9_vue_property_decorator__["Component"])(_class = (_class2 = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default()(DashboardWidget, _Vue);

    function DashboardWidget() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, DashboardWidget);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = DashboardWidget.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(DashboardWidget)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'query', _descriptor, _this), _initDefineProp(_this, 'widgetData', _descriptor2, _this), _this.api = {
            endpoint: null,
            loading: null,
            error: false,
            loadingMessage: null,
            errorMessage: null,
            cancel: null,
            allow404: false
        }, _temp), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(DashboardWidget, [{
        key: 'onQueryChanged',
        value: function onQueryChanged() {
            if (this.shouldRequestData()) {
                this.requestData();
            }
        }
    }, {
        key: 'requestData',
        value: function requestData() {
            var _this2 = this;

            if (this.api.cancel) {
                this.api.cancel.cancel('Rapid re-request');
            }
            this.api.loading = true;
            this.api.error = false;
            this.api.cancel = __WEBPACK_IMPORTED_MODULE_11_axios___default.a.CancelToken.source();
            return this.createQuery().then(function (response) {
                return _this2.onQueryData(response);
            }).then(function () {
                return _this2.api.error = false;
            }).catch(function (error) {
                var isCancel = error && error.message === 'Rapid re-request';
                if (!isCancel) {
                    _this2.api.error = true;
                    return _this2.onQueryError(error);
                }
            }).finally(function () {
                return _this2.api.cancel = null;
            }).finally(function () {
                return _this2.api.loading = false;
            });
        }
    }, {
        key: 'shouldRequestData',
        value: function shouldRequestData() {
            return this.api.endpoint;
        }
    }, {
        key: 'createQuery',
        value: function createQuery() {
            return this.axios.post(this.api.endpoint, this.requestParams, this.requestOptions);
        }
    }, {
        key: 'onQueryData',
        value: function onQueryData(response) {}
    }, {
        key: 'onQueryError',
        value: function onQueryError(error) {
            var _translateStatus;

            console.error('[ DashboardWidget ]', 'QueryError', error.response);
            var translateStatus = (_translateStatus = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_translateStatus, 404, 'widgets.error_not_found'), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_translateStatus, 429, 'widgets.error_rate_limit'), _translateStatus);
            var status = error.response && error.response.status;
            if (this.api.allow404 && status === 404) {
                this.api.error = false;
                return this.onQueryData(null);
            } else {
                var translation = this.$t(translateStatus[status] || 'widgets.error_general');
                return this.showError(translation);
            }
        }
    }, {
        key: 'showError',
        value: function showError(message) {
            this.api.errorMessage = message;
            this.$notify.error(message);
        }
    }, {
        key: 'requestParams',
        get: function get() {
            return Object(__WEBPACK_IMPORTED_MODULE_10__api_format_query__["b" /* formatQuery */])(this.query);
        }
    }, {
        key: 'requestOptions',
        get: function get() {
            return {
                cancelToken: this.api.cancel.token
            };
        }
    }]);

    return DashboardWidget;
}(__WEBPACK_IMPORTED_MODULE_8_vue__["default"]), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'query', [_dec], {
    enumerable: true,
    initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'widgetData', [_dec2], {
    enumerable: true,
    initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, 'onQueryChanged', [_dec3], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'onQueryChanged'), _class2.prototype)), _class2)) || _class);


/***/ }),

/***/ 717:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',[_vm._v("This widget has no visual implementation")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 718:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WidgetWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_general_Loader__ = __webpack_require__(114);






var _dec, _dec2, _dec3, _dec4, _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3;

function _initDefineProp(target, property, descriptor, context) {
    if (!descriptor) return;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, property, {
        enumerable: descriptor.enumerable,
        configurable: descriptor.configurable,
        writable: descriptor.writable,
        value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
    });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}

function _initializerWarningHelper(descriptor, context) {
    throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}





var WidgetWrapper = (_dec = Object(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__["Component"])({
    components: {
        Loader: __WEBPACK_IMPORTED_MODULE_7__components_general_Loader__["a" /* default */]
    }
}), _dec2 = Object(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__["Prop"])({ type: Boolean, default: true }), _dec3 = Object(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__["Prop"])({ type: Object, required: true, default: function _default() {
        return { loading: false, error: false };
    } }), _dec4 = Object(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__["Prop"])({ required: true, type: String }), _dec(_class = (_class2 = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(WidgetWrapper, _Vue);

    function WidgetWrapper() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, WidgetWrapper);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = WidgetWrapper.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(WidgetWrapper)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'draggable', _descriptor, _this), _initDefineProp(_this, 'loader', _descriptor2, _this), _initDefineProp(_this, 'title', _descriptor3, _this), _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    return WidgetWrapper;
}(__WEBPACK_IMPORTED_MODULE_5_vue__["default"]), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'draggable', [_dec2], {
    enumerable: true,
    initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'loader', [_dec3], {
    enumerable: true,
    initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, 'title', [_dec4], {
    enumerable: true,
    initializer: null
})), _class2)) || _class);


/***/ }),

/***/ 719:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"widget"},[_c('h3',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.draggable)?_c('i',{staticClass:"widget__handle mdi mdi-cursor-move"}):_vm._e(),_vm._v(" "),_c('loader',_vm._b({},'loader',_vm.loader,false),[_vm._t("default")],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 721:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 722:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PercentagePie; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PieChart__ = __webpack_require__(723);






var _dec, _dec2, _class, _desc, _value, _class2, _descriptor;

function _initDefineProp(target, property, descriptor, context) {
    if (!descriptor) return;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, property, {
        enumerable: descriptor.enumerable,
        configurable: descriptor.configurable,
        writable: descriptor.writable,
        value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
    });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}

function _initializerWarningHelper(descriptor, context) {
    throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}





var PercentagePie = (_dec = Object(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__["Component"])({
    components: {
        PieChart: __WEBPACK_IMPORTED_MODULE_7__PieChart__["a" /* default */]
    }
}), _dec2 = Object(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__["Prop"])({ type: Number }), _dec(_class = (_class2 = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(PercentagePie, _Vue);

    function PercentagePie() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, PercentagePie);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = PercentagePie.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(PercentagePie)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'fraction', _descriptor, _this), _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    return PercentagePie;
}(__WEBPACK_IMPORTED_MODULE_5_vue__["default"]), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'fraction', [_dec2], {
    enumerable: true,
    initializer: null
})), _class2)) || _class);


/***/ }),

/***/ 723:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(166);




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'PieChart',
    extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["a" /* Doughnut */],
    props: {
        fill: {
            type: Number,
            default: 0.4
        },
        total: {
            type: Number,
            default: 1
        },
        fillColor: {
            type: String,
            default: '#375278'
        },
        emptyColor: {
            type: String,
            default: '#6d9ee1'
        }
    },
    data: function data() {
        return {
            chartOptions: {
                cutoutPercentage: 85,

                animation: false,
                title: {
                    display: false
                },
                legend: {
                    display: false
                },
                tooltips: {
                    enabled: false
                },
                hover: {
                    mode: null
                },
                responsive: true
            }
        };
    },
    watch: {
        fraction: 'updateChart',
        total: 'updateChart'
    },
    methods: {
        updateChart: function updateChart() {
            var remainder = this.total - Math.abs(this.fill);
            var dataset = {
                backgroundColor: [this.fillColor, this.emptyColor],
                data: [this.fill, remainder]
            };
            if (this.fill < 0) {
                dataset.backgroundColor.reverse();
                dataset.data.reverse();
            }
            this.renderChart({ datasets: [dataset] }, this.chartOptions);
        }
    },
    mounted: function mounted() {
        this.updateChart();
    }
});

/***/ }),

/***/ 771:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pie"},[_c('pie-chart',{attrs:{"fill":_vm.fraction}}),_vm._v(" "),_c('div',{ref:"content",staticClass:"pie__content"},[_c('div',[_vm._t("default")],2)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 772:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('widget-wrapper',{staticClass:"quick_insights",attrs:{"loader":_vm.api,"title":_vm.$t('widgets.quick_insights.title'),"id":"quick-insights"}},[_c('div',{staticClass:"pie__container"},[_c('percentage-pie',{staticClass:"pie",attrs:{"fraction":_vm.currentPeriod.conversion}},[_c('span',{staticClass:"pie__percentage"},[_vm._v(_vm._s(_vm.$n(_vm.currentPeriod.conversion, 'percentage_whole')))]),_vm._v(" "),_c('span',{staticClass:"pie__label"},[_vm._v(_vm._s(_vm.$t('widgets.quick_insights.label_conversion_current')))])]),_vm._v(" "),_c('percentage-pie',{staticClass:"pie",attrs:{"fraction":_vm.comparePeriod.conversion}},[_c('span',{staticClass:"pie__percentage"},[_vm._v(_vm._s(_vm.$n(_vm.comparePeriod.conversion, 'percentage_whole')))]),_vm._v(" "),_c('span',{staticClass:"pie__label"},[_vm._v(_vm._s(_vm.$t('widgets.quick_insights.label_conversion_compare')))])]),_vm._v(" "),_c('percentage-pie',{staticClass:"pie",attrs:{"fraction":_vm.currentPeriod.conversion - _vm.comparePeriod.conversion}},[_c('span',{staticClass:"pie__percentage"},[_vm._v(_vm._s(_vm.$n(_vm.currentPeriod.conversion - _vm.comparePeriod.conversion, 'percentage_whole')))]),_vm._v(" "),_c('span',{staticClass:"pie__label"},[_vm._v(_vm._s(_vm.$t('widgets.quick_insights.label_conversion_delta')))])])],1),_vm._v(" "),_c('p',{staticClass:"text-center text-small"},[_vm._v("\n        ("+_vm._s(_vm.$t('widgets.quick_insights.label_range', {start:_vm.comparePeriod.start, end: _vm.comparePeriod.end}))+")\n    ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 773:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SellersWidget_vue__ = __webpack_require__(774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c066841a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SellersWidget_vue__ = __webpack_require__(780);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SellersWidget_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c066841a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SellersWidget_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 774:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SellersWidget; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DashboardWidget__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__WidgetWrapper__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__WidgetDataDecorator__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__SellerRow__ = __webpack_require__(775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__general_Expander__ = __webpack_require__(363);







var _dec, _dec2, _class, _desc, _value, _class2, _descriptor;

function _initDefineProp(target, property, descriptor, context) {
    if (!descriptor) return;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, property, {
        enumerable: descriptor.enumerable,
        configurable: descriptor.configurable,
        writable: descriptor.writable,
        value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
    });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}

function _initializerWarningHelper(descriptor, context) {
    throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}








var SellersWidget = (_dec = Object(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__["Component"])({
    components: {
        Expander: __WEBPACK_IMPORTED_MODULE_11__general_Expander__["a" /* default */],
        SellerRow: __WEBPACK_IMPORTED_MODULE_10__SellerRow__["a" /* default */],
        WidgetWrapper: __WEBPACK_IMPORTED_MODULE_8__WidgetWrapper__["a" /* default */]
    }
}), _dec2 = Object(__WEBPACK_IMPORTED_MODULE_9__WidgetDataDecorator__["a" /* default */])(function () {
    return [{
        id: 1001,
        name: 'Jan van Hooijdonck',
        appointments: 20,
        sold: 20,
        revenue: 1
    }, {
        id: 1002,
        name: 'Pieter-Jan de Feber',
        appointments: 16,
        sold: 10,
        revenue: 2
    }, {
        id: 1003,
        name: 'Else Vink',
        appointments: 17,
        sold: 1,
        revenue: 3
    }, {
        id: 1004,
        name: 'Else Vink',
        appointments: 0,
        sold: 0,
        revenue: 4
    }];
}), _dec(_class = (_class2 = function (_DashboardWidget) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(SellersWidget, _DashboardWidget);

    function SellersWidget() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, SellersWidget);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = SellersWidget.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(SellersWidget)).call.apply(_ref, [this].concat(args))), _this), _this.api = {
            endpoint: 'dashboard/api/sales/sales_people',
            allow404: true
        }, _initDefineProp(_this, 'sellers', _descriptor, _this), _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(SellersWidget, [{
        key: 'onQueryData',
        value: function onQueryData(response) {
            if (!response) {
                this.sellers = [];
                return;
            }
            this.sellers = response.data.map(function (seller) {
                return {
                    id: seller.id,
                    name: seller.name,
                    appointments: seller.num_appointments,
                    sold: seller.num_orders,
                    revenue: seller.total_ex_vat
                };
            });
        }
    }, {
        key: 'showDetails',
        value: function showDetails(seller) {
            this.$modal.show('seller-modal', { seller: seller, query: this.query });
        }
    }]);

    return SellersWidget;
}(__WEBPACK_IMPORTED_MODULE_7__DashboardWidget__["a" /* default */]), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'sellers', [_dec2], {
    enumerable: true,
    initializer: null
})), _class2)) || _class);


/***/ }),

/***/ 775:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SellerRow_vue__ = __webpack_require__(776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3246865c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SellerRow_vue__ = __webpack_require__(777);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SellerRow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3246865c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SellerRow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 776:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SellerRow; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__);







var _dec, _dec2, _dec3, _dec4, _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4;

function _initDefineProp(target, property, descriptor, context) {
    if (!descriptor) return;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, property, {
        enumerable: descriptor.enumerable,
        configurable: descriptor.configurable,
        writable: descriptor.writable,
        value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
    });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}

function _initializerWarningHelper(descriptor, context) {
    throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}




var SellerRow = (_dec = Object(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__["Prop"])({ type: String, default: 'no-name' }), _dec2 = Object(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__["Prop"])({ type: Number, default: 0 }), _dec3 = Object(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__["Prop"])({ type: Number, default: 0 }), _dec4 = Object(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__["Prop"])({ type: Number, default: 0 }), Object(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__["Component"])(_class = (_class2 = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(SellerRow, _Vue);

    function SellerRow() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, SellerRow);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = SellerRow.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(SellerRow)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'name', _descriptor, _this), _initDefineProp(_this, 'appointments', _descriptor2, _this), _initDefineProp(_this, 'sold', _descriptor3, _this), _initDefineProp(_this, 'revenue', _descriptor4, _this), _this.warningThreshold = 0.1, _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(SellerRow, [{
        key: 'conversion',
        get: function get() {
            var start = this.appointments;
            var end = this.sold;
            if (start === 0) {
                return undefined;
            } else {
                return end / start;
            }
        }
    }, {
        key: 'isWarning',
        get: function get() {
            return this.conversion <= this.warningThreshold;
        }
    }, {
        key: 'conversionText',
        get: function get() {
            var fraction = this.conversion;
            if (fraction !== undefined) {
                return this.$n(fraction, 'percentage_whole');
            } else {
                return '';
            }
        }
    }]);

    return SellerRow;
}(__WEBPACK_IMPORTED_MODULE_6_vue__["default"]), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'name', [_dec], {
    enumerable: true,
    initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'appointments', [_dec2], {
    enumerable: true,
    initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, 'sold', [_dec3], {
    enumerable: true,
    initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, 'revenue', [_dec4], {
    enumerable: true,
    initializer: null
})), _class2)) || _class);


/***/ }),

/***/ 777:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{on:{"click":function($event){_vm.$emit('click')}}},[_c('td',[_vm._v(_vm._s(_vm.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.appointments))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.sold))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$n(_vm.revenue, 'money')))]),_vm._v(" "),_c('td',{class:{'is-warning': _vm.isWarning}},[_c('strong',[_vm._v(_vm._s(_vm.conversionText))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 778:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Expander; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__);







var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;

function _initDefineProp(target, property, descriptor, context) {
    if (!descriptor) return;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, property, {
        enumerable: descriptor.enumerable,
        configurable: descriptor.configurable,
        writable: descriptor.writable,
        value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
    });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}

function _initializerWarningHelper(descriptor, context) {
    throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}




var Expander = (_dec = Object(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__["Prop"])({ type: Boolean, default: true }), _dec2 = Object(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__["Prop"])({ type: Boolean, default: true }), _dec3 = Object(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__["Prop"])({ type: Boolean, default: false }), _dec4 = Object(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__["Prop"])({ type: Boolean, default: false }), _dec5 = Object(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__["Prop"])({ type: Number, default: 300 }), _dec6 = Object(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__["Prop"])({ type: String, default: 'expander__content--expanded' }), _dec7 = Object(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__["Prop"])({ type: String, default: 'expander__content--collapsed' }), Object(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__["Component"])(_class = (_class2 = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Expander, _Vue);

    function Expander() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Expander);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Expander.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(Expander)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'allowExpand', _descriptor, _this), _initDefineProp(_this, 'allowCollapse', _descriptor2, _this), _initDefineProp(_this, 'forceExpanded', _descriptor3, _this), _initDefineProp(_this, 'forceCollapsed', _descriptor4, _this), _initDefineProp(_this, 'collapsedHeight', _descriptor5, _this), _initDefineProp(_this, 'expandedCssClass', _descriptor6, _this), _initDefineProp(_this, 'collapsedCssClass', _descriptor7, _this), _this.expandedInternal = false, _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Expander, [{
        key: 'onExpand',
        value: function onExpand() {
            this.expanded = true;
        }
    }, {
        key: 'onCollapse',
        value: function onCollapse() {
            this.expanded = false;
        }
    }, {
        key: 'expanded',
        get: function get() {
            return (this.forceExpanded || this.expandedInternal) && !this.forceCollapsed;
        },
        set: function set(value) {
            if (!this.forced) {
                console.log('set', this.expandedInternal);
                this.expandedInternal = value;
                this.$emit(this.expandedInternal ? 'expand' : 'collapse');
            }
        }
    }, {
        key: 'contentCssClass',
        get: function get() {
            return this.expanded ? this.expandedCssClass : this.collapsedCssClass;
        }
    }, {
        key: 'forced',
        get: function get() {
            return this.forceExpanded || this.forceCollapsed;
        }
    }, {
        key: 'showExpander',
        get: function get() {
            return !this.forced && this.allowExpand && !this.expanded;
        }
    }, {
        key: 'showCollapser',
        get: function get() {
            return !this.forced && this.allowCollapse && this.expanded;
        }
    }]);

    return Expander;
}(__WEBPACK_IMPORTED_MODULE_6_vue__["default"]), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'allowExpand', [_dec], {
    enumerable: true,
    initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'allowCollapse', [_dec2], {
    enumerable: true,
    initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, 'forceExpanded', [_dec3], {
    enumerable: true,
    initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, 'forceCollapsed', [_dec4], {
    enumerable: true,
    initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, 'collapsedHeight', [_dec5], {
    enumerable: true,
    initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, 'expandedCssClass', [_dec6], {
    enumerable: true,
    initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, 'collapsedCssClass', [_dec7], {
    enumerable: true,
    initializer: null
})), _class2)) || _class);


/***/ }),

/***/ 779:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"expander"},[_c('div',{staticClass:"expander__content",class:_vm.contentCssClass},[_vm._t("default")],2),_vm._v(" "),(_vm.showExpander)?_vm._t("expander",[_c('div',{staticClass:"expander__toggle"},[_c('a',{staticClass:"button--cta",on:{"click":_vm.onExpand}},[_vm._v("\n                "+_vm._s(_vm.$t('expander.label_expand'))+"\n            ")])])],{callback:_vm.onExpand}):_vm._e(),_vm._v(" "),(_vm.showCollapser)?_vm._t("collapser",[_c('div',{staticClass:"expander__toggle"},[_c('a',{staticClass:"button--cta",on:{"click":_vm.onCollapse}},[_vm._v("\n                "+_vm._s(_vm.$t('expander.label_collapse'))+"\n            ")])])],{callback:_vm.onCollapse}):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 780:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('widget-wrapper',{attrs:{"loader":_vm.api,"title":_vm.$t('widgets.sellers.title'),"id":"sellers"}},[_c('div',{staticClass:"table__responsive"},[_c('table',{staticClass:"table--hover--clickable"},[_c('thead',[_c('tr',{staticClass:"table__row--header table--hover--clickable__row--non_clickable"},[_c('th',[_vm._v(_vm._s(_vm.$t('widgets.sellers.columns.name')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('widgets.sellers.columns.appointments')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('widgets.sellers.columns.sold')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('widgets.sellers.columns.revenue')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('widgets.sellers.columns.conversion')))])])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.sellers),function(seller){return _c('seller-row',_vm._b({key:seller.id,on:{"click":function($event){_vm.showDetails(seller)}}},'seller-row',seller,false))}),_vm._v(" "),(!_vm.sellers || !_vm.sellers.length)?_c('tr',[_c('td',{staticClass:"table__cell--no_data",attrs:{"colspan":"10000"}},[_vm._v(_vm._s(_vm.$t('widgets.sellers.label_no_data')))])]):_vm._e()],2)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 781:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GeoTableWidget_vue__ = __webpack_require__(782);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ecd9997_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GeoTableWidget_vue__ = __webpack_require__(797);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GeoTableWidget_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ecd9997_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GeoTableWidget_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 782:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GeoTableWidget; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DashboardWidget__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__WidgetWrapper__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__WidgetDataDecorator__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__GeoTableBreadCrumb__ = __webpack_require__(783);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__GeoTableHead__ = __webpack_require__(786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__GeoTableBody__ = __webpack_require__(794);







var _dec, _dec2, _class, _desc, _value, _class2, _descriptor;

function _initDefineProp(target, property, descriptor, context) {
    if (!descriptor) return;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, property, {
        enumerable: descriptor.enumerable,
        configurable: descriptor.configurable,
        writable: descriptor.writable,
        value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
    });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}

function _initializerWarningHelper(descriptor, context) {
    throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}










function populate() {
    return {
        lead: __WEBPACK_IMPORTED_MODULE_10_lodash___default.a.random(1, 100),
        appointment: __WEBPACK_IMPORTED_MODULE_10_lodash___default.a.random(1, 100),
        offer: __WEBPACK_IMPORTED_MODULE_10_lodash___default.a.random(1, 100),
        sales: __WEBPACK_IMPORTED_MODULE_10_lodash___default.a.random(1, 100)
    };
}

var GeoTableWidget = (_dec = Object(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__["Component"])({
    components: {
        GeoTableBody: __WEBPACK_IMPORTED_MODULE_13__GeoTableBody__["a" /* default */],
        GeoTableHead: __WEBPACK_IMPORTED_MODULE_12__GeoTableHead__["a" /* default */],
        GeoTableBreadCrumb: __WEBPACK_IMPORTED_MODULE_11__GeoTableBreadCrumb__["a" /* default */],
        WidgetWrapper: __WEBPACK_IMPORTED_MODULE_8__WidgetWrapper__["a" /* default */]
    }
}), _dec2 = Object(__WEBPACK_IMPORTED_MODULE_9__WidgetDataDecorator__["a" /* default */])(function () {
    return [];
}), _dec(_class = (_class2 = function (_DashboardWidget) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(GeoTableWidget, _DashboardWidget);

    function GeoTableWidget() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, GeoTableWidget);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = GeoTableWidget.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(GeoTableWidget)).call.apply(_ref, [this].concat(args))), _this), _this.api = {
            endpoint: 'dashboard/api/sales/geo_data',
            allow404: true
        }, _initDefineProp(_this, 'countries', _descriptor, _this), _this.columns = ['lead', 'appointment', 'offer', 'sales'], _this.breadcrumbs = [], _this.activeView = null, _this.activeCode = 'country_id', _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(GeoTableWidget, [{
        key: 'show',
        value: function show(view) {
            this.activeView = view;
            if (view.child.length) {
                this.activeCode = view.child[0].code;
            } else {
                this.activeCode = 'country_id';
            }
            this.breadcrumbs.push(view);
        }
    }, {
        key: 'created',
        value: function created() {
            this.show(this.world);
        }
    }, {
        key: 'onQueryData',
        value: function onQueryData(response) {
            console.log('queryData');
            if (response && response.data) {
                this.countries = response.data;
            } else {
                this.countries = [];
            }
            this.breadcrumbs = [];
            this.show(this.world);
        }
    }, {
        key: 'onBreadcrumbClicked',
        value: function onBreadcrumbClicked(crumb) {
            while (this.breadcrumbs.length) {
                if (this.breadcrumbs.pop() === crumb) {
                    break;
                }
            }

            this.show(crumb);
        }
    }, {
        key: 'onChildClicked',
        value: function onChildClicked(child) {
            if (child.child && child.child.length) {
                this.show(child);
            }
        }
    }, {
        key: 'world',
        get: function get() {
            return {
                name: 'all',
                data: this.totals,
                child: this.countries
            };
        }
    }, {
        key: 'totals',
        get: function get() {
            if (!this.countries.length) {
                return __WEBPACK_IMPORTED_MODULE_10_lodash___default.a.times(4, function () {
                    return 0;
                });
            }
            var columns = this.countries[0].data.map(function (i) {
                return i.name;
            });
            var groups = __WEBPACK_IMPORTED_MODULE_10_lodash___default.a.times(columns.length, function () {
                return [];
            });
            this.countries.reduce(function (sum, country) {
                country.data.forEach(function (entry, index) {
                    return sum[index].push(entry);
                });
                return sum;
            }, groups);
            return groups.map(function (group) {
                return { value: group.reduce(function (sum, entry) {
                        return sum + entry.value;
                    }, 0) };
            });
        }
    }]);

    return GeoTableWidget;
}(__WEBPACK_IMPORTED_MODULE_7__DashboardWidget__["a" /* default */]), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'countries', [_dec2], {
    enumerable: true,
    initializer: null
})), _class2)) || _class);


/***/ }),

/***/ 783:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GeoTableBreadCrumb_vue__ = __webpack_require__(784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ebb0e73_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GeoTableBreadCrumb_vue__ = __webpack_require__(785);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GeoTableBreadCrumb_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ebb0e73_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GeoTableBreadCrumb_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 784:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GeoTableBreadCrumb; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__);







var _dec, _dec2, _class, _desc, _value, _class2, _descriptor, _descriptor2;

function _initDefineProp(target, property, descriptor, context) {
    if (!descriptor) return;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, property, {
        enumerable: descriptor.enumerable,
        configurable: descriptor.configurable,
        writable: descriptor.writable,
        value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
    });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}

function _initializerWarningHelper(descriptor, context) {
    throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}




var GeoTableBreadCrumb = (_dec = Object(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__["Prop"])({ type: Array, default: function _default() {
        return [];
    } }), _dec2 = Object(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__["Prop"])({ type: Array, default: function _default() {
        return ['lead'];
    } }), Object(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__["Component"])(_class = (_class2 = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(GeoTableBreadCrumb, _Vue);

    function GeoTableBreadCrumb() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, GeoTableBreadCrumb);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = GeoTableBreadCrumb.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(GeoTableBreadCrumb)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'breadcrumbs', _descriptor, _this), _initDefineProp(_this, 'columns', _descriptor2, _this), _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(GeoTableBreadCrumb, [{
        key: 'localizeName',
        value: function localizeName(name) {
            var path = 'countries.' + name;
            if (this.$te(path)) {
                return this.$t(path);
            } else {
                return name;
            }
        }
    }]);

    return GeoTableBreadCrumb;
}(__WEBPACK_IMPORTED_MODULE_6_vue__["default"]), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'breadcrumbs', [_dec], {
    enumerable: true,
    initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'columns', [_dec2], {
    enumerable: true,
    initializer: null
})), _class2)) || _class);


/***/ }),

/***/ 785:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',_vm._l((_vm.breadcrumbs),function(crumb){return _c('tr',{key:crumb.name,staticClass:"table--hover__row__last_unclickable",on:{"click":function($event){_vm.$emit('crumb-click', crumb)}}},[_c('td',[_vm._v(_vm._s(_vm.localizeName(crumb.name)))]),_vm._v(" "),_vm._l((crumb.data),function(entry){return _c('td',[_vm._v("\n            "+_vm._s(entry.value)+"\n        ")])})],2)}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 786:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GeoTableHead_vue__ = __webpack_require__(787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_84abc7ea_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GeoTableHead_vue__ = __webpack_require__(793);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GeoTableHead_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_84abc7ea_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GeoTableHead_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 787:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GeoTableHead; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__);








var _dec, _dec2, _class, _desc, _value, _class2, _descriptor, _descriptor2;

function _initDefineProp(target, property, descriptor, context) {
    if (!descriptor) return;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, property, {
        enumerable: descriptor.enumerable,
        configurable: descriptor.configurable,
        writable: descriptor.writable,
        value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
    });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}

function _initializerWarningHelper(descriptor, context) {
    throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}




var GeoTableHead = (_dec = Object(__WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__["Prop"])({ type: String, default: 'country_id' }), _dec2 = Object(__WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__["Prop"])({ type: Array, default: function _default() {
        return ['lead'];
    } }), Object(__WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__["Component"])(_class = (_class2 = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(GeoTableHead, _Vue);

    function GeoTableHead() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, GeoTableHead);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = GeoTableHead.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(GeoTableHead)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'mode', _descriptor, _this), _initDefineProp(_this, 'columns', _descriptor2, _this), _temp), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(GeoTableHead, [{
        key: 'allColumns',
        get: function get() {
            return [this.mode].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.columns));
        }
    }, {
        key: 'localizedColumns',
        get: function get() {
            var _this2 = this;

            return this.allColumns.map(function (column) {
                return _this2.$t('widgets.geotable.columns.' + column);
            });
        }
    }]);

    return GeoTableHead;
}(__WEBPACK_IMPORTED_MODULE_7_vue__["default"]), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'mode', [_dec], {
    enumerable: true,
    initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'columns', [_dec2], {
    enumerable: true,
    initializer: null
})), _class2)) || _class);


/***/ }),

/***/ 793:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',{staticClass:"table__row--header table--hover--clickable__row--non_clickable"},_vm._l((_vm.localizedColumns),function(column){return _c('th',[_vm._v(_vm._s(column))])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 794:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GeoTableBody_vue__ = __webpack_require__(795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d1dad9c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GeoTableBody_vue__ = __webpack_require__(796);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GeoTableBody_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d1dad9c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GeoTableBody_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 795:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GeoTableBody; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__);







var _dec, _dec2, _class, _desc, _value, _class2, _descriptor, _descriptor2;

function _initDefineProp(target, property, descriptor, context) {
    if (!descriptor) return;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, property, {
        enumerable: descriptor.enumerable,
        configurable: descriptor.configurable,
        writable: descriptor.writable,
        value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
    });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}

function _initializerWarningHelper(descriptor, context) {
    throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}




var GeoTableBody = (_dec = Object(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__["Prop"])({ type: Array, default: function _default() {
        return [];
    } }), _dec2 = Object(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__["Prop"])({ type: Array, default: function _default() {
        return ['lead'];
    } }), Object(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__["Component"])(_class = (_class2 = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(GeoTableBody, _Vue);

    function GeoTableBody() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, GeoTableBody);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = GeoTableBody.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(GeoTableBody)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'items', _descriptor, _this), _initDefineProp(_this, 'columns', _descriptor2, _this), _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(GeoTableBody, [{
        key: 'localizeName',
        value: function localizeName(name) {
            var path = 'countries.' + name;
            if (this.$te(path)) {
                return this.$t(path);
            } else {
                return name;
            }
        }
    }, {
        key: 'itemClass',
        value: function itemClass(item) {
            return {
                'table--hover--clickable__row--non_clickable': !this.isItemClickable(item)
            };
        }
    }, {
        key: 'isItemClickable',
        value: function isItemClickable(item) {
            return item.child && item.child.length;
        }
    }]);

    return GeoTableBody;
}(__WEBPACK_IMPORTED_MODULE_6_vue__["default"]), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'items', [_dec], {
    enumerable: true,
    initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'columns', [_dec2], {
    enumerable: true,
    initializer: null
})), _class2)) || _class);


/***/ }),

/***/ 796:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tbody',_vm._l((_vm.items),function(item){return _c('tr',{key:item.name,class:_vm.itemClass(item),on:{"click":function($event){_vm.$emit('child-click', item)}}},[_c('td',[_vm._v("\n            "+_vm._s(_vm.localizeName(item.name))+"\n        ")]),_vm._v(" "),_vm._l((item.data),function(entry){return _c('td',[_vm._v("\n            "+_vm._s(entry.value)+"\n        ")])})],2)}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 797:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('widget-wrapper',{attrs:{"loader":_vm.api,"title":_vm.$t('widgets.geotable.title'),"id":"geotable"}},[_c('div',{staticClass:"table__responsive"},[_c('table',{staticClass:"table--hover--clickable"},[_c('geo-table-bread-crumb',{attrs:{"breadcrumbs":_vm.breadcrumbs,"columns":_vm.columns},on:{"crumb-click":_vm.onBreadcrumbClicked}}),_vm._v(" "),_c('geo-table-head',{attrs:{"mode":_vm.activeCode,"columns":_vm.columns}}),_vm._v(" "),_c('geo-table-body',{attrs:{"items":_vm.activeView.child,"columns":_vm.columns},on:{"child-click":_vm.onChildClicked}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 798:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrackerGraphWidget_vue__ = __webpack_require__(799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63a1b759_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrackerGraphWidget_vue__ = __webpack_require__(807);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrackerGraphWidget_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63a1b759_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrackerGraphWidget_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 799:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TrackerGraphWidget; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DashboardWidget__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__WidgetWrapper__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__WidgetDataDecorator__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__TrackerGraph__ = __webpack_require__(800);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__graphs_GraphContainer__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__api_format_query__ = __webpack_require__(160);







var _dec, _dec2, _dec3, _dec4, _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3;

function _initDefineProp(target, property, descriptor, context) {
    if (!descriptor) return;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, property, {
        enumerable: descriptor.enumerable,
        configurable: descriptor.configurable,
        writable: descriptor.writable,
        value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
    });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}

function _initializerWarningHelper(descriptor, context) {
    throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}











var TrackerGraphWidget = (_dec = Object(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__["Component"])({
    components: {
        GraphContainer: __WEBPACK_IMPORTED_MODULE_13__graphs_GraphContainer__["a" /* default */],
        WidgetWrapper: __WEBPACK_IMPORTED_MODULE_8__WidgetWrapper__["a" /* default */],
        TrackerGraph: __WEBPACK_IMPORTED_MODULE_10__TrackerGraph__["a" /* default */]
    }
}), _dec2 = Object(__WEBPACK_IMPORTED_MODULE_9__WidgetDataDecorator__["a" /* default */])(function () {
    return [];
}), _dec3 = Object(__WEBPACK_IMPORTED_MODULE_9__WidgetDataDecorator__["a" /* default */])(function () {
    return [];
}), _dec4 = Object(__WEBPACK_IMPORTED_MODULE_9__WidgetDataDecorator__["a" /* default */])(function () {
    return [];
}), _dec(_class = (_class2 = function (_DashboardWidget) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(TrackerGraphWidget, _DashboardWidget);

    function TrackerGraphWidget() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, TrackerGraphWidget);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = TrackerGraphWidget.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(TrackerGraphWidget)).call.apply(_ref, [this].concat(args))), _this), _this.api = {
            endpoint: 'dashboard/api/sales/contact_moments'
        }, _initDefineProp(_this, 'labels', _descriptor, _this), _initDefineProp(_this, 'datasets', _descriptor2, _this), _this.settingHighlight = false, _initDefineProp(_this, 'legendLabels', _descriptor3, _this), _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(TrackerGraphWidget, [{
        key: 'onHighlightClick',
        value: function onHighlightClick(newValue) {
            if (this.highlight) {
                this.highlight = null;
            } else {
                if (this.graphStep === 'month') {
                    this.highlightMonth(newValue);
                } else {
                    this.highlight = newValue;
                }
            }
        }
    }, {
        key: 'highlightMonth',
        value: function highlightMonth(firstDay) {
            var start = __WEBPACK_IMPORTED_MODULE_11_moment___default()(firstDay).startOf('month');
            var end = __WEBPACK_IMPORTED_MODULE_11_moment___default()(start).endOf('month');
            this.query.daterange.start = start;
            this.query.daterange.end = end;
        }
    }, {
        key: 'shouldRequestData',
        value: function shouldRequestData() {
            var result = this.settingHighlight;
            this.settingHighlight = false;
            return !result;
        }
    }, {
        key: 'onQueryData',
        value: function onQueryData(response) {
            if (!response) {
                this.labels = [];
                this.datasets = [];
                return;
            }

            var enabledLabels = this.datasets.filter(function (dataset) {
                return dataset.enabled;
            }).map(function (dataset) {
                return dataset.label;
            });

            var graphLegend = response.data.legend;
            var graphData = response.data.data;
            this.labels = __WEBPACK_IMPORTED_MODULE_12_lodash___default.a.keys(graphData).map(function (label) {
                return new Date(label);
            });
            this.datasets = graphLegend.map(function (name, index) {
                return {
                    label: graphLegend[index],
                    data: __WEBPACK_IMPORTED_MODULE_12_lodash___default.a.map(graphData, function (column) {
                        return column[index];
                    }),
                    hidden: false,
                    enabled: enabledLabels.includes(graphLegend[index]) };
            });
        }
    }, {
        key: 'highlight',
        get: function get() {
            if (this.query.daterange.highlight) {
                return this.query.daterange.highlight.toDate();
            } else {
                return null;
            }
        },
        set: function set(value) {
            this.settingHighlight = true;
            if (value) {
                this.settingHighlight = true;
                this.query.daterange.highlight = __WEBPACK_IMPORTED_MODULE_11_moment___default()(value);
            } else {
                this.query.daterange.highlight = null;
            }
        }
    }, {
        key: 'graphStep',
        get: function get() {
            return Object(__WEBPACK_IMPORTED_MODULE_14__api_format_query__["a" /* calculateDaterangeStep */])(this.query.daterange.start, this.query.daterange.end);
        }
    }, {
        key: 'axisLabels',
        get: function get() {
            return {
                xAxis: this.$t('widgets.tracker_graph.label_xaxis'),
                yAxis: this.$t('widgets.tracker_graph.label_yaxis')
            };
        }
    }]);

    return TrackerGraphWidget;
}(__WEBPACK_IMPORTED_MODULE_7__DashboardWidget__["a" /* default */]), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'labels', [_dec2], {
    enumerable: true,
    initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'datasets', [_dec3], {
    enumerable: true,
    initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, 'legendLabels', [_dec4], {
    enumerable: true,
    initializer: null
})), _class2)) || _class);


/***/ }),

/***/ 800:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__workaround__ = __webpack_require__(801);





/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'TrackerGraph',
    extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["b" /* Line */],
    data: function data() {
        return {
            chartOptions: {
                animation: false,
                title: {
                    display: false
                },
                legend: {
                    display: false
                },
                tooltips: {
                    enabled: true,
                    mode: 'index',
                    axis: 'x',
                    intersect: false,
                    yAlign: 'center',
                    yAlignForced: true,
                    position: 'TrackerGraphTooltipPositioner',
                    xPadding: 24,
                    yPadding: 24,
                    BackgroundColor: 'rgba(0,0,0,0.9)',
                    titleFontFamily: 'Lato',
                    titleFontSize: 12,
                    titleFontWeight: 'regular',
                    titleSpacing: 20,
                    titleFontColor: '#ccc',
                    titleMarginBottom: 16,
                    bodyFontSize: 16,
                    bodyFontColor: '#fff',
                    bodyFontFamily: 'Lato',
                    caretSize: 16,
                    caretPadding: 8,
                    cornerRadius: 3,
                    bodySpacing: 10
                },
                scales: {
                    yAxes: [{
                        type: 'linear',
                        ticks: {
                            beginAtZero: true,
                            min: 0,
                            suggestedMax: 1
                        },
                        scaleLabel: {}
                    }],
                    xAxes: [{
                        type: 'time',
                        ticks: {
                            autoSkip: true,
                            maxTicksLimit: 11
                        },
                        scaleLabel: {},
                        time: {
                            unit: 'day',
                            tooltipFormat: 'll' },
                        gridLines: {
                            display: false
                        }
                    }]
                },
                elements: {
                    line: {
                        borderWidth: 2,
                        fill: false,
                        tension: 0
                    },
                    point: {
                        borderWidth: 0,
                        hitRadius: 2,
                        radius: 0
                    }
                }
            },
            tracker: {
                color: '#757575',
                width: 4
            }
        };
    },
    props: {
        chartData: { type: Object, default: function _default() {
                return { datasets: [], labels: [] };
            } },
        step: { type: String, default: 'day' },
        value: { type: Date, default: null },
        labelXaxis: { type: String, default: '' },
        labelYaxis: { type: String, default: '' }
    },
    computed: {
        reactiveHidden: function reactiveHidden() {
            return this.chartData.datasets.map(function (dataset) {
                return dataset.hidden;
            });
        }
    },
    model: {
        prop: 'value',
        event: 'input'
    },
    watch: {
        chartData: 'updateChart',
        step: 'updateChart',
        reactiveHidden: 'updateChart',
        labelXaxis: 'updateChart',
        labelYaxis: 'updateChart'
    },
    mounted: function mounted() {
        var vue_component = this;

        this.addPlugin({
            afterDraw: function afterDraw(chart) {
                var shouldDraw = false;
                var tracker = vue_component.tracker;
                if (vue_component.value) {
                    tracker.x = chart.scales['x-axis-0'].getPixelForValue(vue_component.value);
                    shouldDraw = true;
                }
                if (!shouldDraw && chart.tooltip._active && chart.tooltip._active.length) {
                    tracker.x = chart.tooltip._active[0].tooltipPosition().x;
                    shouldDraw = true;
                }
                if (shouldDraw) {
                    var ctx = chart.ctx;
                    var topY = chart.scales['y-axis-0'].top;
                    var bottomY = chart.scales['y-axis-0'].bottom;
                    var x = tracker.x;

                    ctx.save();
                    ctx.beginPath();
                    ctx.moveTo(x, topY);
                    ctx.lineTo(x, bottomY);
                    ctx.lineWidth = tracker.width;
                    ctx.strokeStyle = tracker.color;
                    ctx.stroke();
                    ctx.restore();
                }
            },
            afterEvent: function afterEvent(chart, e) {
                if (!(e.type === 'click' || e.type === 'mouseup')) {
                    return;
                }
                var tooltip = chart.tooltip._active[0];
                var index = tooltip._index;
                var date = chart.data.labels[index];
                vue_component.$emit('input', date);
            }
        });

        this.addPlugin({
            beforeRender: function beforeRender(chart) {
                chart.pluginTooltips = [];
                if (vue_component.value) {
                    var valueIndex = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.findIndex(chart.data.labels, function (item) {
                        return item.getTime() === vue_component.value.getTime();
                    });
                    chart.pluginTooltips.push(new __WEBPACK_IMPORTED_MODULE_1_chart_js___default.a.Tooltip({
                        _chart: chart.chart,
                        _chartInstance: chart,
                        _data: chart.data,
                        _options: chart.options.tooltips,
                        _active: chart.config.data.datasets.map(function (dataset, i) {
                            return chart.getDatasetMeta(i).data[valueIndex];
                        })
                    }, chart));

                    chart.options.tooltips.enabled = false;
                } else {
                    chart.options.tooltips.enabled = true;
                }
            },
            afterDraw: function afterDraw(chart, easing) {
                if (vue_component.value) {
                    if (!chart.allTooltipsOnce) {
                        if (easing !== 1) return;
                        chart.allTooltipsOnce = true;
                    }

                    chart.options.tooltips.enabled = true;
                    __WEBPACK_IMPORTED_MODULE_1_chart_js___default.a.helpers.each(chart.pluginTooltips, function (tooltip) {
                        tooltip.initialize();
                        tooltip.update();

                        tooltip.pivot();
                        tooltip.transition(easing).draw();
                    });
                    chart.options.tooltips.enabled = false;
                }
            }
        });
        this.updateChart();
    },

    methods: {
        updateChart: function updateChart() {
            this.updateChartOptions();
            this.renderChart(this.chartData, this.chartOptions);
        },
        updateChartOptions: function updateChartOptions() {
            this.chartOptions.scales.xAxes[0].scaleLabel.display = !!this.labelXaxis;
            this.chartOptions.scales.xAxes[0].scaleLabel.labelString = this.labelXaxis;
            this.chartOptions.scales.yAxes[0].scaleLabel.display = !!this.labelYaxis;
            this.chartOptions.scales.yAxes[0].scaleLabel.labelString = this.labelYaxis;
            this.chartOptions.scales.xAxes[0].time.unit = this.step;
        }
    }
});

__WEBPACK_IMPORTED_MODULE_1_chart_js___default.a.Tooltip.positioners.TrackerGraphTooltipPositioner = function (elements) {
    var element = elements[0];
    var x = element.tooltipPosition().x;
    return {
        x: x,
        y: (this._chart.chartArea.bottom - this._chart.chartArea.top) / 2
    };
};

/***/ }),

/***/ 801:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_chart_js__);



var defaults = __WEBPACK_IMPORTED_MODULE_0_chart_js___default.a.defaults;
var helpers = __WEBPACK_IMPORTED_MODULE_0_chart_js___default.a.helpers;

function createTooltipItem(element) {
    var xScale = element._xScale;
    var yScale = element._yScale || element._scale;
    var index = element._index;
    var datasetIndex = element._datasetIndex;

    return {
        xLabel: xScale ? xScale.getLabelForIndex(index, datasetIndex) : '',
        yLabel: yScale ? yScale.getLabelForIndex(index, datasetIndex) : '',
        index: index,
        datasetIndex: datasetIndex,
        x: element._model.x,
        y: element._model.y
    };
}

function getBaseModel(tooltipOpts) {
    var globalDefaults = defaults.global;
    var valueOrDefault = helpers.valueOrDefault;

    return {
        xPadding: tooltipOpts.xPadding,
        yPadding: tooltipOpts.yPadding,
        xAlign: tooltipOpts.xAlign,
        yAlign: tooltipOpts.yAlign,
        yAlignForced: tooltipOpts.yAlignForced,

        bodyFontColor: tooltipOpts.bodyFontColor,
        _bodyFontFamily: valueOrDefault(tooltipOpts.bodyFontFamily, globalDefaults.defaultFontFamily),
        _bodyFontStyle: valueOrDefault(tooltipOpts.bodyFontStyle, globalDefaults.defaultFontStyle),
        _bodyAlign: tooltipOpts.bodyAlign,
        bodyFontSize: valueOrDefault(tooltipOpts.bodyFontSize, globalDefaults.defaultFontSize),
        bodySpacing: tooltipOpts.bodySpacing,

        titleFontColor: tooltipOpts.titleFontColor,
        _titleFontFamily: valueOrDefault(tooltipOpts.titleFontFamily, globalDefaults.defaultFontFamily),
        _titleFontStyle: valueOrDefault(tooltipOpts.titleFontStyle, globalDefaults.defaultFontStyle),
        titleFontSize: valueOrDefault(tooltipOpts.titleFontSize, globalDefaults.defaultFontSize),
        _titleAlign: tooltipOpts.titleAlign,
        titleSpacing: tooltipOpts.titleSpacing,
        titleMarginBottom: tooltipOpts.titleMarginBottom,

        footerFontColor: tooltipOpts.footerFontColor,
        _footerFontFamily: valueOrDefault(tooltipOpts.footerFontFamily, globalDefaults.defaultFontFamily),
        _footerFontStyle: valueOrDefault(tooltipOpts.footerFontStyle, globalDefaults.defaultFontStyle),
        footerFontSize: valueOrDefault(tooltipOpts.footerFontSize, globalDefaults.defaultFontSize),
        _footerAlign: tooltipOpts.footerAlign,
        footerSpacing: tooltipOpts.footerSpacing,
        footerMarginTop: tooltipOpts.footerMarginTop,

        caretSize: tooltipOpts.caretSize,
        cornerRadius: tooltipOpts.cornerRadius,
        backgroundColor: tooltipOpts.backgroundColor,
        opacity: 0,
        legendColorBackground: tooltipOpts.multiKeyBackground,
        displayColors: tooltipOpts.displayColors,
        borderColor: tooltipOpts.borderColor,
        borderWidth: tooltipOpts.borderWidth
    };
}

function getTooltipSize(tooltip, model) {
    var ctx = tooltip._chart.ctx;

    var height = model.yPadding * 2;
    var width = 0;

    var body = model.body;
    var combinedBodyLength = body.reduce(function (count, bodyItem) {
        return count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length;
    }, 0);
    combinedBodyLength += model.beforeBody.length + model.afterBody.length;

    var titleLineCount = model.title.length;
    var footerLineCount = model.footer.length;
    var titleFontSize = model.titleFontSize;
    var bodyFontSize = model.bodyFontSize;
    var footerFontSize = model.footerFontSize;

    height += titleLineCount * titleFontSize;
    height += titleLineCount ? (titleLineCount - 1) * model.titleSpacing : 0;
    height += titleLineCount ? model.titleMarginBottom : 0;
    height += combinedBodyLength * bodyFontSize;
    height += combinedBodyLength ? (combinedBodyLength - 1) * model.bodySpacing : 0;
    height += footerLineCount ? model.footerMarginTop : 0;
    height += footerLineCount * footerFontSize;
    height += footerLineCount ? (footerLineCount - 1) * model.footerSpacing : 0;
    var widthPadding = 0;
    var maxLineWidth = function maxLineWidth(line) {
        width = Math.max(width, ctx.measureText(line).width + widthPadding);
    };

    ctx.font = helpers.fontString(titleFontSize, model._titleFontStyle, model._titleFontFamily);
    helpers.each(model.title, maxLineWidth);

    ctx.font = helpers.fontString(bodyFontSize, model._bodyFontStyle, model._bodyFontFamily);
    helpers.each(model.beforeBody.concat(model.afterBody), maxLineWidth);

    widthPadding = model.displayColors ? bodyFontSize + 2 : 0;
    helpers.each(body, function (bodyItem) {
        helpers.each(bodyItem.before, maxLineWidth);
        helpers.each(bodyItem.lines, maxLineWidth);
        helpers.each(bodyItem.after, maxLineWidth);
    });

    widthPadding = 0;

    ctx.font = helpers.fontString(footerFontSize, model._footerFontStyle, model._footerFontFamily);
    helpers.each(model.footer, maxLineWidth);

    width += 2 * model.xPadding;

    return {
        width: width,
        height: height
    };
}

function determineAlignment(tooltip, size) {
    var model = tooltip._model;
    var chart = tooltip._chart;
    var chartArea = tooltip._chart.chartArea;
    var xAlign = 'center';
    var yAlign = 'center';

    if (!tooltip._options.yAlignForced) {
        if (model.y < size.height) {
            yAlign = 'top';
        } else if (model.y > chart.height - size.height) {
            yAlign = 'bottom';
        }
    } else {
        yAlign = tooltip._options.yAlign || 'center';
    }

    var lf = void 0,
        rf = void 0;
    var olf = void 0,
        orf = void 0;
    var yf = void 0;
    var midX = (chartArea.left + chartArea.right) / 2;
    var midY = (chartArea.top + chartArea.bottom) / 2;

    if (yAlign === 'center') {
        lf = function lf(x) {
            return x <= midX;
        };
        rf = function rf(x) {
            return x > midX;
        };
    } else {
        lf = function lf(x) {
            return x <= size.width / 2;
        };
        rf = function rf(x) {
            return x >= chart.width - size.width / 2;
        };
    }

    olf = function olf(x) {
        return x + size.width + model.caretSize + model.caretPadding > chart.width;
    };
    orf = function orf(x) {
        return x - size.width - model.caretSize - model.caretPadding < 0;
    };
    yf = function yf(y) {
        return y <= midY ? 'top' : 'bottom';
    };

    if (lf(model.x)) {
        xAlign = 'left';

        if (olf(model.x)) {
            xAlign = 'center';
            yAlign = yf(model.y);
        }
    } else if (rf(model.x)) {
        xAlign = 'right';

        if (orf(model.x)) {
            xAlign = 'center';
            yAlign = yf(model.y);
        }
    }

    var opts = tooltip._options;
    return {
        xAlign: opts.xAlign ? opts.xAlign : xAlign,
        yAlign: opts.yAlign ? opts.yAlign : yAlign
    };
}

function getBackgroundPoint(vm, size, alignment, chart) {
    var x = vm.x;
    var y = vm.y;

    var caretSize = vm.caretSize;
    var caretPadding = vm.caretPadding;
    var cornerRadius = vm.cornerRadius;
    var xAlign = alignment.xAlign;
    var yAlign = alignment.yAlign;
    var paddingAndSize = caretSize + caretPadding;
    var radiusAndPadding = cornerRadius + caretPadding;

    if (xAlign === 'right') {
        x -= size.width;
    } else if (xAlign === 'center') {
        x -= size.width / 2;
        if (x + size.width > chart.width) {
            x = chart.width - size.width;
        }
        if (x < 0) {
            x = 0;
        }
    }

    if (yAlign === 'top') {
        y += paddingAndSize;
    } else if (yAlign === 'bottom') {
        y -= size.height + paddingAndSize;
    } else {
        y -= size.height / 2;
    }

    if (yAlign === 'center') {
        if (xAlign === 'left') {
            x += paddingAndSize;
        } else if (xAlign === 'right') {
            x -= paddingAndSize;
        }
    } else if (xAlign === 'left') {
        x -= radiusAndPadding;
    } else if (xAlign === 'right') {
        x += radiusAndPadding;
    }

    return {
        x: x,
        y: y
    };
}

function fixedUpdate(changed) {
    var me = this;
    var opts = me._options;

    var existingModel = me._model;
    var model = me._model = getBaseModel(opts);
    var active = me._active;

    var data = me._data;

    var alignment = {
        xAlign: existingModel.xAlign,
        yAlign: existingModel.yAlign
    };
    var backgroundPoint = {
        x: existingModel.x,
        y: existingModel.y
    };
    var tooltipSize = {
        width: existingModel.width,
        height: existingModel.height
    };
    var tooltipPosition = {
        x: existingModel.caretX,
        y: existingModel.caretY
    };

    var i = void 0,
        len = void 0;

    if (active.length) {
        model.opacity = 1;

        var labelColors = [];
        var labelTextColors = [];
        tooltipPosition = __WEBPACK_IMPORTED_MODULE_0_chart_js___default.a.Tooltip.positioners[opts.position].call(me, active, me._eventPosition);

        var tooltipItems = [];
        for (i = 0, len = active.length; i < len; ++i) {
            tooltipItems.push(createTooltipItem(active[i]));
        }

        if (opts.filter) {
            tooltipItems = tooltipItems.filter(function (a) {
                return opts.filter(a, data);
            });
        }

        if (opts.itemSort) {
            tooltipItems = tooltipItems.sort(function (a, b) {
                return opts.itemSort(a, b, data);
            });
        }

        helpers.each(tooltipItems, function (tooltipItem) {
            labelColors.push(opts.callbacks.labelColor.call(me, tooltipItem, me._chart));
            labelTextColors.push(opts.callbacks.labelTextColor.call(me, tooltipItem, me._chart));
        });

        model.title = me.getTitle(tooltipItems, data);
        model.beforeBody = me.getBeforeBody(tooltipItems, data);
        model.body = me.getBody(tooltipItems, data);
        model.afterBody = me.getAfterBody(tooltipItems, data);
        model.footer = me.getFooter(tooltipItems, data);

        model.x = Math.round(tooltipPosition.x);
        model.y = Math.round(tooltipPosition.y);
        model.caretPadding = opts.caretPadding;
        model.labelColors = labelColors;
        model.labelTextColors = labelTextColors;

        model.dataPoints = tooltipItems;

        tooltipSize = getTooltipSize(this, model);
        alignment = determineAlignment(this, tooltipSize);

        backgroundPoint = getBackgroundPoint(model, tooltipSize, alignment, me._chart);
    } else {
        model.opacity = 0;
    }

    model.xAlign = alignment.xAlign;
    model.yAlign = alignment.yAlign;
    model.x = backgroundPoint.x;
    model.y = backgroundPoint.y;
    model.width = tooltipSize.width;
    model.height = tooltipSize.height;

    model.caretX = tooltipPosition.x;
    model.caretY = tooltipPosition.y;

    me._model = model;

    if (changed && opts.custom) {
        opts.custom.call(me, model);
    }

    return me;
}
__WEBPACK_IMPORTED_MODULE_0_chart_js___default.a.Tooltip.prototype.update = fixedUpdate;

/***/ }),

/***/ 802:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GraphContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__GraphLegend__ = __webpack_require__(803);








var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;

function _initDefineProp(target, property, descriptor, context) {
    if (!descriptor) return;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, property, {
        enumerable: descriptor.enumerable,
        configurable: descriptor.configurable,
        writable: descriptor.writable,
        value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
    });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}

function _initializerWarningHelper(descriptor, context) {
    throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}





var GraphContainer = (_dec = Object(__WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__["Component"])({
    components: { GraphLegend: __WEBPACK_IMPORTED_MODULE_9__GraphLegend__["a" /* default */] }
}), _dec2 = Object(__WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__["Prop"])({ type: [String, Object] }), _dec3 = Object(__WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__["Prop"])({ type: Array, required: true }), _dec4 = Object(__WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__["Prop"])({ type: Array, required: false }), _dec5 = Object(__WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__["Prop"])({ type: Number, default: 3 }), _dec6 = Object(__WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__["Prop"])({ type: Number, default: 8 }), _dec7 = Object(__WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__["Prop"])({
    type: [Array, Function],
    default: function _default() {
        return ['#18bf5C', '#ee411a', '#FF9900', '#14a3da', '#990099', '#3B3EAC', '#0099C6', '#DD4477', '#66AA00', '#B82E2E', '#316395', '#994499', '#22AA99', '#AAAA11', '#6633CC', '#E67300', '#8B0707', '#329262', '#5574A6', '#651067'];
    }
}), _dec8 = Object(__WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__["Prop"])({ type: Boolean, default: false }), _dec(_class = (_class2 = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(GraphContainer, _Vue);

    function GraphContainer() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, GraphContainer);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = GraphContainer.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(GraphContainer)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'graphComponent', _descriptor, _this), _initDefineProp(_this, 'datasets', _descriptor2, _this), _initDefineProp(_this, 'labels', _descriptor3, _this), _initDefineProp(_this, 'dropdownLimit', _descriptor4, _this), _initDefineProp(_this, 'dropdownThreshold', _descriptor5, _this), _initDefineProp(_this, 'colors', _descriptor6, _this), _initDefineProp(_this, 'responsive', _descriptor7, _this), _this.enabledDatasets = [], _temp), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(GraphContainer, [{
        key: 'onDatasetAdd',
        value: function onDatasetAdd(dataset) {
            var _this2 = this;

            dataset.enabled = true;
            this.enabledDatasets.forEach(function (dataset, index) {
                var colors = _this2.getLineColors(index);
                dataset.borderColor = colors.border;
                dataset.backgroundColor = colors.background;
                dataset.pointBackgroundColor = colors.point;
            });
        }
    }, {
        key: 'onDatasetRemove',
        value: function onDatasetRemove(dataset) {
            var _this3 = this;

            dataset.enabled = false;
            this.enabledDatasets.forEach(function (dataset, index) {
                var colors = _this3.getLineColors(index);
                dataset.borderColor = colors.border;
                dataset.backgroundColor = colors.background;
                dataset.pointBackgroundColor = colors.point;
            });
        }
    }, {
        key: 'getLineColors',
        value: function getLineColors(index) {
            var result = void 0;
            if (typeof this.colors === 'function') {
                result = this.colors(index);
            } else {
                result = this.colors[index];
            }
            if ((typeof result === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(result)) === 'object') {
                return result;
            } else {
                return {
                    border: result,
                    background: result,
                    point: result
                };
            }
        }
    }, {
        key: 'dropdown',
        get: function get() {
            if (!this.datasets || this.datasets.length <= this.dropdownThreshold) {
                return null;
            }
            return {
                placeholder: this.$t('graph_container.label_dropdown'),
                limit: this.dropdownLimit,
                limit_warning: this.$t('graph_container.label_dropdown_limit', { limit: this.dropdownLimit })
            };
        }
    }, {
        key: 'notification',
        get: function get() {
            if (!this.datasets || !this.datasets.length) {
                return this.$t('graph_container.label_no_data');
            }
            if (!this.enabledDatasets || !this.enabledDatasets.some(function (dataset) {
                return !dataset.hidden;
            })) {
                return this.$t('graph_container.label_no_selection');
            }
        }
    }]);

    return GraphContainer;
}(__WEBPACK_IMPORTED_MODULE_7_vue__["default"]), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'graphComponent', [_dec2], {
    enumerable: true,
    initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'datasets', [_dec3], {
    enumerable: true,
    initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, 'labels', [_dec4], {
    enumerable: true,
    initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, 'dropdownLimit', [_dec5], {
    enumerable: true,
    initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, 'dropdownThreshold', [_dec6], {
    enumerable: true,
    initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, 'colors', [_dec7], {
    enumerable: true,
    initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, 'responsive', [_dec8], {
    enumerable: true,
    initializer: null
})), _class2)) || _class);


/***/ }),

/***/ 803:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GraphLegend_vue__ = __webpack_require__(804);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59480bf5_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GraphLegend_vue__ = __webpack_require__(805);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GraphLegend_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59480bf5_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GraphLegend_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 804:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GraphLegend; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__general_SingleSelect__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash__);








var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4;

function _initDefineProp(target, property, descriptor, context) {
    if (!descriptor) return;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, property, {
        enumerable: descriptor.enumerable,
        configurable: descriptor.configurable,
        writable: descriptor.writable,
        value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
    });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}

function _initializerWarningHelper(descriptor, context) {
    throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}






var GraphLegend = (_dec = Object(__WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__["Component"])({
    components: {
        SingleSelect: __WEBPACK_IMPORTED_MODULE_9__general_SingleSelect__["a" /* default */]
    }
}), _dec2 = Object(__WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__["Prop"])({ type: Array, default: function _default() {
        return [];
    } }), _dec3 = Object(__WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__["Prop"])({ type: Object, default: null }), _dec4 = Object(__WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__["Prop"])({ type: Array, default: function _default() {
        return [];
    } }), _dec5 = Object(__WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__["Prop"])({ type: String, default: '' }), _dec6 = Object(__WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__["Watch"])('datasets'), _dec7 = Object(__WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__["Watch"])('dropdown'), _dec(_class = (_class2 = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(GraphLegend, _Vue);

    function GraphLegend() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, GraphLegend);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = GraphLegend.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(GraphLegend)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'datasets', _descriptor, _this), _initDefineProp(_this, 'dropdown', _descriptor2, _this), _initDefineProp(_this, 'value', _descriptor3, _this), _initDefineProp(_this, 'dropdownPlaceholder', _descriptor4, _this), _this.singleSelectValue = null, _temp), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(GraphLegend, [{
        key: 'onDatasetsChanged',
        value: function onDatasetsChanged() {
            var _this2 = this;

            var active = this.activeDatasets || [];
            active.splice(0, active.length);
            if (!this.dropdown) {
                (this.datasets || []).forEach(function (dataset) {
                    return _this2.onLabelAdd(dataset);
                });
            } else {
                (this.datasets || []).forEach(function (dataset) {
                    return dataset.enabled ? _this2.onLabelAdd(dataset) : _this2.onLabelRemove(dataset);
                });
            }
        }
    }, {
        key: 'mounted',
        value: function mounted() {
            this.onDatasetsChanged();
        }
    }, {
        key: 'getLabelText',
        value: function getLabelText(dataset) {
            return dataset.label;
        }
    }, {
        key: 'onLabelAdd',
        value: function onLabelAdd(dataset) {
            var _this3 = this;

            this.$nextTick(function () {
                _this3.singleSelectValue = null;
            });
            if (this.activeDatasets.indexOf(dataset) !== -1) {
                return;
            }
            if (this.dropdownDisabled) {
                return;
            }
            this.activeDatasets.push(dataset);
            if (this.dropdown) {
                dataset.hidden = false;
            }
            this.$emit('add', dataset);
        }
    }, {
        key: 'onLabelRemove',
        value: function onLabelRemove(dataset) {
            var index = this.activeDatasets.indexOf(dataset);
            if (index !== -1) {
                this.activeDatasets.splice(index, 1);
            }
            if (this.dropdown) {
                dataset.hidden = true;
            }
            this.$emit('remove', dataset);
        }
    }, {
        key: 'onLabelToggle',
        value: function onLabelToggle(dataset) {
            this.$emit('toggle', dataset);
            dataset.hidden = !dataset.hidden;
        }
    }, {
        key: 'activeDatasets',
        get: function get() {
            return this.value;
        },
        set: function set(value) {
            this.$emit('input', value);
        }
    }, {
        key: 'inactiveDatasets',
        get: function get() {
            return __WEBPACK_IMPORTED_MODULE_10_lodash___default.a.difference(this.datasets, this.activeDatasets);
        }
    }, {
        key: 'dropdownDisabled',
        get: function get() {
            if (!this.dropdown) {
                return false;
            }
            return this.activeDatasets.length >= this.dropdown.limit;
        }
    }]);

    return GraphLegend;
}(__WEBPACK_IMPORTED_MODULE_7_vue__["default"]), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'datasets', [_dec2], {
    enumerable: true,
    initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'dropdown', [_dec3], {
    enumerable: true,
    initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, 'value', [_dec4], {
    enumerable: true,
    initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, 'dropdownPlaceholder', [_dec5], {
    enumerable: true,
    initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, 'onDatasetsChanged', [_dec6, _dec7], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'onDatasetsChanged'), _class2.prototype)), _class2)) || _class);


/***/ }),

/***/ 805:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[(_vm.dropdown)?[_c('div',{staticClass:"col-xs-12 col-lg-5"},[_c('single-select',{attrs:{"options":_vm.inactiveDatasets,"getOptionLabel":_vm.getLabelText,"placeholder":_vm.dropdown.placeholder,"disabled":_vm.dropdownDisabled},on:{"input":_vm.onLabelAdd},model:{value:(_vm.singleSelectValue),callback:function ($$v) {_vm.singleSelectValue=$$v},expression:"singleSelectValue"}})],1),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-lg-7"},[_c('ul',{staticClass:"legend"},_vm._l((_vm.activeDatasets),function(dataset){return _c('li',{staticClass:"legend__item--label",class:{'is-deactived': dataset.hidden},on:{"click":function($event){_vm.onLabelToggle(dataset)}}},[_c('span',[_c('span',{staticClass:"legend__item__dot",style:('background:' + dataset.borderColor)}),_vm._v("\n                        "+_vm._s(dataset.label)+"\n                    ")]),_vm._v(" "),_c('span',{staticClass:"legend__item--label__close",on:{"click":function($event){$event.preventDefault();_vm.onLabelRemove(dataset)}}},[_c('i',{staticClass:"mdi mdi-close"})])])}))])]:_c('div',{staticClass:"col-xs-12"},[_c('ul',{staticClass:"legend"},_vm._l((_vm.activeDatasets),function(dataset){return _c('li',{staticClass:"legend__item--label",class:{'is-deactived': dataset.hidden},on:{"click":function($event){_vm.onLabelToggle(dataset)}}},[_c('span',[_c('span',{staticClass:"legend__item__dot",style:('background:' + dataset.borderColor)}),_vm._v("\n                    "+_vm._s(dataset.label)+"\n                ")])])}))]),_vm._v(" "),(_vm.dropdownDisabled)?_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"dropdown__disabled_warning"},[_c('i',{staticClass:"dropdown__disabled_warning__icon mdi mdi-alert-circle-outline"}),_vm._v(" "+_vm._s(_vm.dropdown.limit_warning)+"\n        ")])]):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 806:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"graph"},[_c('graph-legend',{attrs:{"datasets":_vm.datasets,"dropdown":_vm.dropdown},on:{"add":_vm.onDatasetAdd,"remove":_vm.onDatasetRemove},model:{value:(_vm.enabledDatasets),callback:function ($$v) {_vm.enabledDatasets=$$v},expression:"enabledDatasets"}}),_vm._v(" "),_c('div',{class:{graph__responsive: _vm.responsive}},[_c('div',{class:{graph__graph: _vm.responsive}},[_vm._t("default",[_vm._v("\n                No graph specified\n            ")],{datasets:_vm.enabledDatasets})],2),_vm._v(" "),(_vm.notification)?_vm._t("notification",[_c('div',{staticClass:"graph__notification"},[_c('div',{staticClass:"graph__notification__block"},[_vm._v(_vm._s(_vm.notification))])])],{notification:_vm.notification}):_vm._e()],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 807:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('widget-wrapper',{attrs:{"loader":_vm.api,"title":_vm.$t('widgets.tracker_graph.title'),"id":"tracker-graph"}},[_c('graph-container',{attrs:{"datasets":_vm.datasets,"responsive":true,"dropdown-limit":Infinity},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('tracker-graph',{attrs:{"chart-data":{datasets: scope.datasets, labels: _vm.labels},"height":200,"step":_vm.graphStep,"value":_vm.highlight,"label-xaxis":_vm.axisLabels.xAxis,"label-yaxis":_vm.axisLabels.yAxis},on:{"input":_vm.onHighlightClick}})]}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 808:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row flex draggable"},_vm._l((_vm.areas),function(area){return _c('draggable',{key:area.name,staticClass:"flex__item flex--column draggable__item",class:area.class,attrs:{"options":_vm.dragOptions},on:{"change":_vm.onWidgetMove},model:{value:(area.components),callback:function ($$v) {_vm.$set(area, "components", $$v)},expression:"area.components"}},_vm._l((area.components),function(component,index){return _c(component.class,{key:index,tag:"component",attrs:{"query":_vm.query},model:{value:(component.model),callback:function ($$v) {_vm.$set(component, "model", $$v)},expression:"component.model"}})}))}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 809:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HighlightedDate_vue__ = __webpack_require__(810);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a4142a4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HighlightedDate_vue__ = __webpack_require__(811);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HighlightedDate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a4142a4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HighlightedDate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 810:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HighlightedDate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__general_Datepicker__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);







var _dec, _dec2, _class, _desc, _value, _class2, _descriptor;

function _initDefineProp(target, property, descriptor, context) {
    if (!descriptor) return;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, property, {
        enumerable: descriptor.enumerable,
        configurable: descriptor.configurable,
        writable: descriptor.writable,
        value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
    });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}

function _initializerWarningHelper(descriptor, context) {
    throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}






var HighlightedDate = (_dec = Object(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__["Component"])({
    components: {
        Datepicker: __WEBPACK_IMPORTED_MODULE_8__general_Datepicker__["a" /* default */]
    }
}), _dec2 = Object(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__["Model"])({
    type: Object,
    default: function _default() {
        return {
            begin: null,
            end: null
        };
    }
}), _dec(_class = (_class2 = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(HighlightedDate, _Vue);

    function HighlightedDate() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, HighlightedDate);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = HighlightedDate.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(HighlightedDate)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'daterange', _descriptor, _this), _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(HighlightedDate, [{
        key: 'onResetClicked',
        value: function onResetClicked() {
            this.highlight = null;
        }
    }, {
        key: 'highlight',
        get: function get() {
            return this.daterange.highlight.toDate();
        },
        set: function set(value) {
            if (value) {
                this.daterange.highlight = __WEBPACK_IMPORTED_MODULE_9_moment___default()(value);
            } else {
                this.daterange.highlight = null;
            }
        }
    }]);

    return HighlightedDate;
}(__WEBPACK_IMPORTED_MODULE_6_vue__["default"]), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'daterange', [_dec2], {
    enumerable: true,
    initializer: null
})), _class2)) || _class);


/***/ }),

/***/ 811:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"datepicker__container"},[_vm._v("\n    "+_vm._s(_vm.$t('dashboard.datepickers.highlight'))+"\n    "),_vm._v(" "),_c('datepicker',{staticClass:"datepicker datepicker--readonly",attrs:{"disabled":true},model:{value:(_vm.highlight),callback:function ($$v) {_vm.highlight=$$v},expression:"highlight"}}),_vm._v(" "),_c('a',{staticClass:"datepicker__reset button",on:{"click":_vm.onResetClicked}},[_c('i',{staticClass:"mdi mdi-close"})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 812:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('preset-bar',{model:{value:(_vm.query),callback:function ($$v) {_vm.query=$$v},expression:"query"}}),_vm._v(" "),(_vm.query.daterange.highlight)?_c('highlighted-date',{model:{value:(_vm.query.daterange),callback:function ($$v) {_vm.$set(_vm.query, "daterange", $$v)},expression:"query.daterange"}}):_c('daterange-picker',{model:{value:(_vm.query.daterange),callback:function ($$v) {_vm.$set(_vm.query, "daterange", $$v)},expression:"query.daterange"}}),_vm._v(" "),_c('widget-drag-area',{attrs:{"query":_vm.query}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 813:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Styleguide_vue__ = __webpack_require__(814);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_109c51cb_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Styleguide_vue__ = __webpack_require__(834);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Styleguide_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_109c51cb_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Styleguide_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 814:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Styleguide; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_select__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_v_tooltip__ = __webpack_require__(815);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modals_StyleguideModal__ = __webpack_require__(816);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_modals_StyleguideModalSmall__ = __webpack_require__(819);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_general_StyleguideBlock__ = __webpack_require__(822);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_general_Loader__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_general_Tabs__ = __webpack_require__(825);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_general_Tab__ = __webpack_require__(828);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_general_RatioContainer__ = __webpack_require__(831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_widgets_quick_insights_PercentagePie__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_general_Expander__ = __webpack_require__(363);






var _dec, _class;






__WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_v_tooltip__["a" /* default */]);











var Styleguide = (_dec = Object(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__["Component"])({
    components: {
        Expander: __WEBPACK_IMPORTED_MODULE_17__components_general_Expander__["a" /* default */],
        PercentagePie: __WEBPACK_IMPORTED_MODULE_16__components_widgets_quick_insights_PercentagePie__["a" /* default */],
        RatioContainer: __WEBPACK_IMPORTED_MODULE_15__components_general_RatioContainer__["a" /* default */],
        StyleguideModal: __WEBPACK_IMPORTED_MODULE_9__components_modals_StyleguideModal__["a" /* default */],
        StyleguideModalSmall: __WEBPACK_IMPORTED_MODULE_10__components_modals_StyleguideModalSmall__["a" /* default */],
        StyleguideBlock: __WEBPACK_IMPORTED_MODULE_11__components_general_StyleguideBlock__["a" /* default */],
        Loader: __WEBPACK_IMPORTED_MODULE_12__components_general_Loader__["a" /* default */],
        Tabs: __WEBPACK_IMPORTED_MODULE_13__components_general_Tabs__["a" /* default */], Tab: __WEBPACK_IMPORTED_MODULE_14__components_general_Tab__["a" /* default */],
        vSelect: __WEBPACK_IMPORTED_MODULE_7_vue_select___default.a
    }
}), _dec(_class = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Styleguide, _Vue);

    function Styleguide() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Styleguide);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Styleguide.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Styleguide)).call.apply(_ref, [this].concat(args))), _this), _this.name = 'styleguide', _this.selected = null, _this.loaderLoading = false, _this.loaderError = false, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Styleguide, [{
        key: 'showStyleguideModal',
        value: function showStyleguideModal() {
            this.$modal.show('styleguide-modal');
        }
    }, {
        key: 'showStyleguideModalSmall',
        value: function showStyleguideModalSmall() {
            this.$modal.show('styleguide-modal-small');
        }
    }, {
        key: 'setLoader',
        value: function setLoader(loading, error) {
            this.loaderLoading = loading;
            this.loaderError = error;
        }
    }]);

    return Styleguide;
}(__WEBPACK_IMPORTED_MODULE_5_vue__["default"])) || _class);


/***/ }),

/***/ 816:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StyleguideModal_vue__ = __webpack_require__(817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_92045ce6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StyleguideModal_vue__ = __webpack_require__(818);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StyleguideModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_92045ce6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StyleguideModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 817:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyleguideModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_property_decorator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_general_ModalWrapper__ = __webpack_require__(110);





var _dec, _class;





var StyleguideModal = (_dec = Object(__WEBPACK_IMPORTED_MODULE_5_vue_property_decorator__["Component"])({
    components: {
        ModalWrapper: __WEBPACK_IMPORTED_MODULE_6__components_general_ModalWrapper__["a" /* default */]
    }
}), _dec(_class = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(StyleguideModal, _Vue);

    function StyleguideModal() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, StyleguideModal);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = StyleguideModal.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(StyleguideModal)).call.apply(_ref, [this].concat(args))), _this), _this.name = 'styleguide-modal', _this.selected1 = null, _this.selected2 = null, _this.selected3 = null, _this.selected4 = null, _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    return StyleguideModal;
}(__WEBPACK_IMPORTED_MODULE_4_vue__["default"])) || _class);


/***/ }),

/***/ 818:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-wrapper',{attrs:{"modalClass":"modal","modalName":_vm.name}},[_c('form',{staticClass:"form"},[_c('div',{staticClass:"modal__header"},[_c('h3',[_vm._v("Styleguide modal")])]),_vm._v(" "),_c('div',{staticClass:"modal__content"},[_c('div',{staticClass:"form__group"},[_c('label',{staticClass:"form__label"},[_vm._v("This is a dropdown")]),_vm._v(" "),_c('v-select',{attrs:{"options":['Dropdown Item 1','Dropdown Item 2','Dropdown Item 3'],"value":"Item 1","placeholder":"Choose an item..."},model:{value:(_vm.selected1),callback:function ($$v) {_vm.selected1=$$v},expression:"selected1"}})],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h2',[_vm._v("Extra header")]),_vm._v(" "),_c('div',{staticClass:"form__group"},[_c('label',{staticClass:"form__label"},[_vm._v("This is another dropdown")]),_vm._v(" "),_c('v-select',{attrs:{"options":['Dropdown Item 1','Dropdown Item 2','Dropdown Item 3'],"placeholder":"Choose an item..."},model:{value:(_vm.selected2),callback:function ($$v) {_vm.selected2=$$v},expression:"selected2"}})],1),_vm._v(" "),_c('div',{staticClass:"form__group"},[_c('label',{staticClass:"form__label"},[_vm._v("This is one more dropdown")]),_vm._v(" "),_c('v-select',{attrs:{"options":['Dropdown Item 1','Dropdown Item 2','Dropdown Item 3'],"placeholder":"Choose an item..."},model:{value:(_vm.selected3),callback:function ($$v) {_vm.selected3=$$v},expression:"selected3"}})],1),_vm._v(" "),_c('div',{staticClass:"form__group"},[_c('label',{staticClass:"form__label"},[_vm._v("This is a dropdown to select multiple items")]),_vm._v(" "),_c('v-select',{attrs:{"multiple":"","options":['Multiple dropdown Item 1','Multiple dropdown Item 2','Multiple dropdown Item 3'],"placeholder":"Add item"},model:{value:(_vm.selected4),callback:function ($$v) {_vm.selected4=$$v},expression:"selected4"}})],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h2',[_vm._v("Another header")]),_vm._v(" "),_c('div',{staticClass:"form__group"},[_c('div',{staticClass:"form__label"},[_vm._v("Description text input")]),_vm._v(" "),_c('input',{staticClass:"form__input--text",attrs:{"type":"text","placeholder":"Enter description (optional)..."}})]),_vm._v(" "),_c('div',{staticClass:"form__group"},[_c('label',{staticClass:"form__label"},[_vm._v("Description textarea")]),_vm._v(" "),_c('textarea',{staticClass:"form__input--textarea",attrs:{"placeholder":"Enter remarks (optional)..."}})])]),_vm._v(" "),_c('div',{staticClass:"modal__footer"},[_c('button',{staticClass:"button--cta",attrs:{"type":"submit"}},[_vm._v("Add / Save")]),_vm._v(" "),_c('button',{staticClass:"button--alt",attrs:{"type":"button"},on:{"click":function($event){_vm.$modal.hide(_vm.name)}}},[_vm._v("Cancel")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 819:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StyleguideModalSmall_vue__ = __webpack_require__(820);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_359190eb_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StyleguideModalSmall_vue__ = __webpack_require__(821);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StyleguideModalSmall_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_359190eb_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StyleguideModalSmall_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 820:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyleguideModalSmall; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_property_decorator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_general_ModalWrapper__ = __webpack_require__(110);





var _dec, _class;





var StyleguideModalSmall = (_dec = Object(__WEBPACK_IMPORTED_MODULE_5_vue_property_decorator__["Component"])({
    components: {
        ModalWrapper: __WEBPACK_IMPORTED_MODULE_6__components_general_ModalWrapper__["a" /* default */]
    }
}), _dec(_class = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(StyleguideModalSmall, _Vue);

    function StyleguideModalSmall() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, StyleguideModalSmall);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = StyleguideModalSmall.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(StyleguideModalSmall)).call.apply(_ref, [this].concat(args))), _this), _this.name = 'styleguide-modal-small', _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    return StyleguideModalSmall;
}(__WEBPACK_IMPORTED_MODULE_4_vue__["default"])) || _class);


/***/ }),

/***/ 821:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-wrapper',{attrs:{"modalClass":"modal--small","modalName":_vm.name}},[_c('div',{staticClass:"modal__header"},[_c('h3',[_vm._v("Styleguide modal small")])]),_vm._v(" "),_c('div',{staticClass:"modal__content"},[_vm._v("\n        Modal for for example a confirmation or simple question.\n    ")]),_vm._v(" "),_c('div',{staticClass:"modal__footer"},[_c('button',{staticClass:"button--cta",attrs:{"type":"submit"}},[_vm._v("Ok")]),_vm._v(" "),_c('button',{staticClass:"button--alt",attrs:{"type":"button"},on:{"click":function($event){_vm.$modal.hide(_vm.name)}}},[_vm._v("Cancel")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 822:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StyleguideBlock_vue__ = __webpack_require__(823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08f47c5d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StyleguideBlock_vue__ = __webpack_require__(824);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StyleguideBlock_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08f47c5d_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StyleguideBlock_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 823:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyleguideBlock; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__);






var _dec, _class, _desc, _value, _class2, _descriptor;

function _initDefineProp(target, property, descriptor, context) {
    if (!descriptor) return;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, property, {
        enumerable: descriptor.enumerable,
        configurable: descriptor.configurable,
        writable: descriptor.writable,
        value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
    });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}

function _initializerWarningHelper(descriptor, context) {
    throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}




var StyleguideBlock = (_dec = Object(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__["Prop"])({ type: String }), Object(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__["Component"])(_class = (_class2 = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(StyleguideBlock, _Vue);

    function StyleguideBlock() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, StyleguideBlock);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = StyleguideBlock.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(StyleguideBlock)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'title', _descriptor, _this), _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    return StyleguideBlock;
}(__WEBPACK_IMPORTED_MODULE_5_vue__["default"]), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'title', [_dec], {
    enumerable: true,
    initializer: null
})), _class2)) || _class);


/***/ }),

/***/ 824:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"styleguide__component_block"},[_c('div',{staticClass:"styleguide__component_header"},[_c('h6',[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('div',{staticClass:"styleguide__component_content"},[_vm._t("default")],2)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 825:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tabs_vue__ = __webpack_require__(826);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_130a2b0a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tabs_vue__ = __webpack_require__(827);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tabs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_130a2b0a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tabs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 826:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Tabs; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__);






var _class;




var Tabs = Object(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__["Component"])(_class = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Tabs, _Vue);

    function Tabs() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Tabs);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Tabs.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Tabs)).call.apply(_ref, [this].concat(args))), _this), _this.children = [], _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Tabs, [{
        key: 'mounted',
        value: function mounted() {
            this.$children.find(function (child) {
                return child.enabled;
            }).active = true;
            this.children = this.$children;
        }
    }, {
        key: 'selectTab',
        value: function selectTab(tab, event) {
            event.preventDefault();
            this.$children.forEach(function (child) {
                return child.active = child === tab;
            });
        }
    }]);

    return Tabs;
}(__WEBPACK_IMPORTED_MODULE_5_vue__["default"])) || _class;



/***/ }),

/***/ 827:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabs"},[_c('ul',{staticClass:"tabs__buttons"},_vm._l((_vm.children),function(tab,key){return _c('li',{directives:[{name:"show",rawName:"v-show",value:(tab.enabled),expression:"tab.enabled"}],key:key,staticClass:"tabs__tab",class:{'is-active': tab.active, 'tab-disabled': !tab.enabled}},[_c('a',{on:{"click":function($event){_vm.selectTab(tab, $event)}}},[_vm._v(_vm._s(tab.name))])])})),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 828:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tab_vue__ = __webpack_require__(829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c671748_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tab_vue__ = __webpack_require__(830);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tab_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c671748_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tab_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 829:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Tab; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__);






var _dec, _dec2, _class, _desc, _value, _class2, _descriptor, _descriptor2;

function _initDefineProp(target, property, descriptor, context) {
    if (!descriptor) return;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, property, {
        enumerable: descriptor.enumerable,
        configurable: descriptor.configurable,
        writable: descriptor.writable,
        value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
    });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}

function _initializerWarningHelper(descriptor, context) {
    throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}




var Tab = (_dec = Object(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__["Prop"])({ type: String, required: true }), _dec2 = Object(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__["Prop"])({ type: Boolean, default: true }), Object(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__["Component"])(_class = (_class2 = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Tab, _Vue);

    function Tab() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Tab);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Tab.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(Tab)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'name', _descriptor, _this), _initDefineProp(_this, 'enabled', _descriptor2, _this), _this.active = false, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    return Tab;
}(__WEBPACK_IMPORTED_MODULE_5_vue__["default"]), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'name', [_dec], {
    enumerable: true,
    initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'enabled', [_dec2], {
    enumerable: true,
    initializer: null
})), _class2)) || _class);


/***/ }),

/***/ 830:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.active),expression:"active"}],staticClass:"tabs__panel",attrs:{"aria-hidden":!_vm.active}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 831:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RatioContainer_vue__ = __webpack_require__(832);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3deaadb0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RatioContainer_vue__ = __webpack_require__(833);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RatioContainer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3deaadb0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RatioContainer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 832:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RatioContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_v_media_query__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_v_media_query___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_v_media_query__);








var _dec, _dec2, _class, _desc, _value, _class2, _descriptor;

function _initDefineProp(target, property, descriptor, context) {
    if (!descriptor) return;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, property, {
        enumerable: descriptor.enumerable,
        configurable: descriptor.configurable,
        writable: descriptor.writable,
        value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
    });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}

function _initializerWarningHelper(descriptor, context) {
    throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}





__WEBPACK_IMPORTED_MODULE_7_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_v_media_query___default.a);

var RatioContainer = (_dec = Object(__WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__["Prop"])({ type: Number, default: 1 }), _dec2 = Object(__WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__["Watch"])('$mq.resize'), Object(__WEBPACK_IMPORTED_MODULE_8_vue_property_decorator__["Component"])(_class = (_class2 = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(RatioContainer, _Vue);

    function RatioContainer() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, RatioContainer);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = RatioContainer.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(RatioContainer)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'ratio', _descriptor, _this), _temp), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(RatioContainer, [{
        key: 'onResize',
        value: function onResize() {
            var clientWidth = this.$refs.main.clientWidth;
            var newHeight = clientWidth * this.ratio;
            this.$refs.main.style.height = newHeight + 'px';
        }
    }, {
        key: 'mounted',
        value: function mounted() {
            this.onResize();
        }
    }]);

    return RatioContainer;
}(__WEBPACK_IMPORTED_MODULE_7_vue__["default"]), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'ratio', [_dec], {
    enumerable: true,
    initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, 'onResize', [_dec2], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'onResize'), _class2.prototype)), _class2)) || _class);


/***/ }),

/***/ 833:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"main"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 834:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"styleguide"},[_vm._m(0,false,false),_vm._v(" "),_c('styleguide-block',{attrs:{"title":"Expander"}},[_c('div',{staticStyle:{"display":"flex","justify-content":"start"}},[_c('expander',{staticStyle:{"margin":"5px"}},[_c('img',{attrs:{"src":"https://via.placeholder.com/150x400"}})]),_vm._v(" "),_c('expander',{staticStyle:{"margin":"5px"},scopedSlots:_vm._u([{key:"expander",fn:function(slot){return [_c('button',{staticClass:"button--link",on:{"click":slot.callback}},[_vm._v("Custom expander")])]}},{key:"collapser",fn:function(slot){return [_c('button',{staticClass:"button--link",on:{"click":slot.callback}},[_vm._v("Custom collapser")])]}}])},[_c('img',{attrs:{"src":"https://via.placeholder.com/150x400"}})]),_vm._v(" "),_c('expander',{staticStyle:{"margin":"5px"},attrs:{"allow-collapse":false}},[_c('img',{attrs:{"src":"https://via.placeholder.com/150x400"}})]),_vm._v(" "),_c('expander',{staticStyle:{"margin":"5px"},attrs:{"allow-expand":false}},[_c('img',{attrs:{"src":"https://via.placeholder.com/150x400"}})])],1)]),_vm._v(" "),_c('styleguide-block',{attrs:{"title":"PercentagePie"}},[_c('percentage-pie',[_c('p',[_vm._v("Hello")]),_vm._v(" "),_c('p',[_vm._v("World")])])],1),_vm._v(" "),_c('styleguide-block',{attrs:{"title":"RatioContainer"}},[_c('div',{staticStyle:{"width":"50%"}},[_c('ratio-container',[_c('div',{staticStyle:{"width":"100%","height":"100%","background-color":"red"}},[_vm._v("50% width, height autoadjusted")])])],1),_vm._v(" "),_c('div',{staticStyle:{"width":"70%"}},[_c('ratio-container',[_c('div',{staticStyle:{"width":"100%","height":"100%","background-color":"red"}},[_vm._v("70% width, height autoadjusted")])])],1)]),_vm._v(" "),_c('styleguide-block',{attrs:{"title":"Buttons"}},[_c('a',{staticClass:"button--cta",attrs:{"href":"#"}},[_vm._v("Button CTA")]),_vm._v(" "),_c('a',{staticClass:"button",attrs:{"href":"#"}},[_vm._v("Button")]),_vm._v(" "),_c('a',{staticClass:"button--alt",attrs:{"href":"#"}},[_vm._v("Button ALT")]),_vm._v(" "),_c('a',{staticClass:"button--cta is-disabled",attrs:{"href":"#","disabled":""}},[_vm._v("Button Disabled")])]),_vm._v(" "),_c('styleguide-block',{attrs:{"title":"Search"}},[_c('div',{staticClass:"styleguide__item"},[_c('form',{staticClass:"search"},[_c('input',{staticClass:"search__input",attrs:{"type":"search","placeholder":"Search.."}}),_vm._v(" "),_c('button',{staticClass:"search__button button--cta",attrs:{"type":"submit"}},[_vm._v("Search")])])]),_vm._v(" "),_c('div',{staticClass:"styleguide__item"},[_c('form',{staticClass:"search"},[_c('input',{staticClass:"search__input",attrs:{"type":"search","placeholder":"Search.."}}),_vm._v(" "),_c('button',{staticClass:"search__button button",attrs:{"type":"submit"}},[_vm._v("Search")])])])]),_vm._v(" "),_c('styleguide-block',{attrs:{"title":"Forms"}},[_c('form',{staticClass:"form"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-sm-8 col-md-6"},[_c('div',{staticClass:"form__group"},[_c('label',{staticClass:"form__label"},[_vm._v("These are your options:")]),_vm._v(" "),_c('div',{staticClass:"checkbox is-inline"},[_c('input',{staticClass:"checkbox__cb",attrs:{"type":"checkbox","id":"cb"}}),_vm._v(" "),_c('label',{staticClass:"checkbox__label",attrs:{"for":"cb"}},[_vm._v("Optie 1")])]),_vm._v(" "),_c('div',{staticClass:"checkbox is-inline"},[_c('input',{staticClass:"checkbox__cb",attrs:{"type":"checkbox","id":"cb_2"}}),_vm._v(" "),_c('label',{staticClass:"checkbox__label",attrs:{"for":"cb_2"}},[_vm._v("Optie 2")])])]),_vm._v(" "),_c('div',{staticClass:"form__group"},[_c('label',{staticClass:"form__label"},[_vm._v("Choose an option:")]),_vm._v(" "),_c('div',{staticClass:"radio is-inline"},[_c('input',{staticClass:"radio__rb",attrs:{"type":"radio","name":"radio","id":"radio"}}),_vm._v(" "),_c('label',{staticClass:"radio__label",attrs:{"for":"radio"}},[_vm._v("Radio button 1")])]),_vm._v(" "),_c('div',{staticClass:"radio is-inline"},[_c('input',{staticClass:"radio__rb",attrs:{"type":"radio","name":"radio","id":"radio_1"}}),_vm._v(" "),_c('label',{staticClass:"radio__label",attrs:{"for":"radio_1"}},[_vm._v("Radio button 2")])]),_vm._v(" "),_c('div',{staticClass:"radio is-inline"},[_c('input',{staticClass:"radio__rb",attrs:{"type":"radio","name":"radio","id":"radio_2"}}),_vm._v(" "),_c('label',{staticClass:"radio__label",attrs:{"for":"radio_2"}},[_vm._v("Radio button 3")])])]),_vm._v(" "),_c('div',{staticClass:"form__group"},[_c('label',{staticClass:"form__label"},[_vm._v("Text field 1")]),_vm._v(" "),_c('input',{staticClass:"form__input--text",attrs:{"type":"text","placeholder":"This is an input field"}})]),_vm._v(" "),_c('div',{staticClass:"form__group"},[_c('label',{staticClass:"form__label"},[_vm._v("Textarea")]),_vm._v(" "),_c('textarea',{staticClass:"form__input--textarea",attrs:{"placeholder":"Start typing here..."}})]),_vm._v(" "),_c('div',{staticClass:"form__group"},[_c('label',{staticClass:"form__label"},[_vm._v("Textarea")]),_vm._v(" "),_c('textarea',{staticClass:"form__input--textarea has-error",attrs:{"placeholder":"Start typing here..."}}),_vm._v(" "),_c('span',{staticClass:"form__error_text"},[_vm._v("Error description")])]),_vm._v(" "),_c('div',{staticClass:"form__group"},[_c('label',{staticClass:"form__label"},[_vm._v("Disabled text field")]),_vm._v(" "),_c('input',{staticClass:"form__input--text",attrs:{"type":"text","placeholder":"This is an disabled input field","disabled":""}})]),_vm._v(" "),_c('div',{staticClass:"form__group"},[_c('label',{staticClass:"form__label"},[_vm._v("Text field with an error")]),_vm._v(" "),_c('input',{staticClass:"form__input--text has-error",attrs:{"type":"text","placeholder":"Dit is an input field with an error","value":"test"}}),_vm._v(" "),_c('span',{staticClass:"form__error_text"},[_vm._v("Error description")])]),_vm._v(" "),_c('div',{staticClass:"form__group"},[_c('label',{staticClass:"form__label"},[_vm._v("This is a select")]),_vm._v(" "),_c('div',{staticClass:"select"},[_c('select',[_c('option',[_vm._v("Choose...")]),_vm._v(" "),_c('option',[_vm._v("Option 1")]),_vm._v(" "),_c('option',[_vm._v("Option 2")])])])]),_vm._v(" "),_c('div',{staticClass:"form__group"},[_c('label',{staticClass:"form__label"},[_vm._v("This is an error select")]),_vm._v(" "),_c('div',{staticClass:"select has-error"},[_c('select',[_c('option',[_vm._v("Choose...")]),_vm._v(" "),_c('option',[_vm._v("Option 1")]),_vm._v(" "),_c('option',[_vm._v("Option 2")])])]),_vm._v(" "),_c('span',{staticClass:"form__error_text"},[_vm._v("Error description")])]),_vm._v(" "),_c('div',{staticClass:"form__group"},[_c('label',{staticClass:"form__label"},[_vm._v("This is a dropdown")]),_vm._v(" "),_c('v-select',{attrs:{"options":['Dropdown Item 1','Dropdown Item 2','Dropdown Item 3'],"value":"Item 1","placeholder":"Choose an item..."},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1),_vm._v(" "),_c('div',{staticClass:"form__group"},[_c('label',{staticClass:"form__label"},[_vm._v("This is a large dropdown")]),_vm._v(" "),_c('v-select',{staticClass:"dropdown--large",attrs:{"options":['Dropdown Item 1','Dropdown Item 2','Dropdown Item 3'],"value":"Item 1","placeholder":"Choose an item..."}})],1),_vm._v(" "),_c('div',{staticClass:"form__group"},[_c('label',{staticClass:"form__label"},[_vm._v("This is a multiple select dropdown")]),_vm._v(" "),_c('v-select',{staticClass:"dropdown",attrs:{"multiple":"","options":['First item','Second item','Third item'],"placeholder":"Choose an item..."}})],1),_vm._v(" "),_c('div',{staticClass:"form__group"},[_c('label',{staticClass:"form__label"},[_vm._v("This is a dropdown")]),_vm._v(" "),_c('v-select',{staticClass:"has-error",attrs:{"options":['Dropdown Item 1','Dropdown Item 2','Dropdown Item 3'],"value":"Item 1","placeholder":"Choose an item..."}}),_vm._v(" "),_c('span',{staticClass:"form__error_text"},[_vm._v("Error description")])],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"form__buttons"},[_c('button',{staticClass:"form__button button--cta",attrs:{"type":"submit","href":"#"}},[_vm._v("Button")]),_vm._v(" "),_c('a',{staticClass:"form__button button--alt",attrs:{"href":"#"}},[_vm._v("Cancel")])])])])])]),_vm._v(" "),_c('styleguide-block',{attrs:{"title":"Alerts"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-8 col-lg-6"},[_c('div',{staticClass:"styleguide__item"},[_c('div',{staticClass:"alert"},[_vm._v("This is a normal information alert!")])]),_vm._v(" "),_c('div',{staticClass:"styleguide__item"},[_c('div',{staticClass:"alert--success"},[_vm._v("This is a success alert!")])]),_vm._v(" "),_c('div',{staticClass:"styleguide__item"},[_c('div',{staticClass:"alert--warning"},[_vm._v("This is a warning alert")])]),_vm._v(" "),_c('div',{staticClass:"styleguide__item"},[_c('div',{staticClass:"alert--error"},[_vm._v("This is an error alert")])])])])]),_vm._v(" "),_c('styleguide-block',{attrs:{"title":"Teksten"}},[_c('h1',[_vm._v("This is an H1 text")]),_vm._v(" "),_c('h2',[_vm._v("This is an H2 text")]),_vm._v(" "),_c('h3',[_vm._v("This is an H3 text")]),_vm._v(" "),_c('h4',[_vm._v("This is an H4 text")]),_vm._v(" "),_c('h5',[_vm._v("This is an H5 text")]),_vm._v(" "),_c('h6',[_vm._v("This is an H6 text")]),_vm._v(" "),_c('p',[_vm._v("This is a short text to present what some standard, "),_c('strong',[_vm._v("bold")]),_vm._v(" and "),_c('i',[_vm._v("italic")]),_vm._v(" text and "),_c('a',{attrs:{"href":"#"}},[_vm._v("a link")]),_vm._v(" would look like.")])]),_vm._v(" "),_c('styleguide-block',{attrs:{"title":"Breadcrumb"}},[_c('ul',{staticClass:"breadcrumb"},[_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Home")]),_c('i',{staticClass:"breadcrumb__icon mdi mdi-chevron-right"})]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Category")]),_c('i',{staticClass:"breadcrumb__icon mdi mdi-chevron-right"})]),_vm._v(" "),_c('li',[_vm._v("Security Design Tool")])])]),_vm._v(" "),_c('styleguide-block',{attrs:{"title":"Pagination"}},[_c('ul',{staticClass:"pagination"},[_c('li',{staticClass:"active"},[_c('a',{attrs:{"href":"#"}},[_vm._v("1")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("2")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("3")])])])]),_vm._v(" "),_c('styleguide-block',{attrs:{"title":"Spinner"}},[_c('div',{staticClass:"styleguide__item"},[_c('div',{staticClass:"spinner"})]),_vm._v(" "),_c('div',{staticClass:"styleguide__item"},[_c('div',{staticClass:"spinner--small"})])]),_vm._v(" "),_c('styleguide-block',{attrs:{"title":"Modal"}},[_c('button',{staticClass:"button--cta",on:{"click":_vm.showStyleguideModal}},[_vm._v("Open modal")]),_vm._v(" "),_c('button',{staticClass:"button--cta",on:{"click":_vm.showStyleguideModalSmall}},[_vm._v("Open small modal")])]),_vm._v(" "),_c('styleguide-modal'),_vm._v(" "),_c('styleguide-modal-small'),_vm._v(" "),_c('styleguide-block',{attrs:{"title":"Tooltips"}},[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip.top",value:('This tooltip is positioned at the top!'),expression:"'This tooltip is positioned at the top!'",modifiers:{"top":true}}]},[_c('i',{staticClass:"mdi mdi-cursor-pointer"}),_vm._v(" Top tooltip - Hover over me!")]),_c('br'),_vm._v(" "),_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip.right",value:('This tooltip is positioned on the right!'),expression:"'This tooltip is positioned on the right!'",modifiers:{"right":true}}]},[_c('i',{staticClass:"mdi mdi-cursor-pointer"}),_vm._v(" Right tooltip - Hover over me!")]),_c('br'),_vm._v(" "),_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip.left",value:('This tooltip is positioned on the left!'),expression:"'This tooltip is positioned on the left!'",modifiers:{"left":true}}]},[_c('i',{staticClass:"mdi mdi-cursor-pointer"}),_vm._v(" Left tooltip - Hover over me!")]),_c('br'),_vm._v(" "),_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip.bottom",value:('This tooltip is positioned at the bottom!'),expression:"'This tooltip is positioned at the bottom!'",modifiers:{"bottom":true}}]},[_c('i',{staticClass:"mdi mdi-cursor-pointer"}),_vm._v(" Bottom tooltip - Hover over me!")])]),_vm._v(" "),_c('styleguide-block',{attrs:{"title":"Table"}},[_c('div',{staticClass:"styleguide__item"},[_c('div',{staticClass:"table__responsive"},[_c('table',{staticClass:"table"},[_c('thead',[_c('tr',[_c('th',[_vm._v("#")]),_vm._v(" "),_c('th',{staticClass:"table__wrap"},[_vm._v("Name")]),_vm._v(" "),_c('th',[_vm._v("Type")]),_vm._v(" "),_c('th',[_vm._v("Status")]),_vm._v(" "),_c('th',{staticClass:"table__cell--icon"},[_vm._v("Remarks")]),_vm._v(" "),_c('th',{staticClass:"table__cell--date"},[_vm._v("Last edit")]),_vm._v(" "),_c('th',{staticClass:"table__cell--icon"}),_vm._v(" "),_c('th',{staticClass:"table__cell--icon"})])]),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',[_vm._v("1")]),_vm._v(" "),_c('td',{staticClass:"table__wrap"},[_vm._v("This is the name of some item in this table")]),_vm._v(" "),_c('td',[_vm._v("Type 1")]),_vm._v(" "),_c('td',[_vm._v("Approved")]),_vm._v(" "),_c('td',[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip.bottom",value:('In this tooltip the first words of the remarks will be visible…'),expression:"'In this tooltip the first words of the remarks will be visible…'",modifiers:{"bottom":true}}],staticClass:"table__icon mdi mdi-message-text"})]),_vm._v(" "),_c('td',[_vm._v("10-11-2017")]),_vm._v(" "),_c('td',[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip.right",value:('Edit'),expression:"'Edit'",modifiers:{"right":true}}],staticClass:"table__icon mdi mdi-pencil"})]),_vm._v(" "),_c('td',[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip.right",value:('Delete'),expression:"'Delete'",modifiers:{"right":true}}],staticClass:"table__icon mdi mdi-delete"})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("1")]),_vm._v(" "),_c('td',{staticClass:"table__wrap"},[_vm._v("This is the name of some item in this table")]),_vm._v(" "),_c('td',[_vm._v("Type 2")]),_vm._v(" "),_c('td',[_vm._v("Approved")]),_vm._v(" "),_c('td',[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip.bottom",value:('In this tooltip the first words of the remarks will be visible…'),expression:"'In this tooltip the first words of the remarks will be visible…'",modifiers:{"bottom":true}}],staticClass:"table__icon mdi mdi-message-text"})]),_vm._v(" "),_c('td',[_vm._v("10-11-2017")]),_vm._v(" "),_c('td',[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip.right",value:('Edit'),expression:"'Edit'",modifiers:{"right":true}}],staticClass:"table__icon mdi mdi-pencil"})]),_vm._v(" "),_c('td',[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip.right",value:('Delete'),expression:"'Delete'",modifiers:{"right":true}}],staticClass:"table__icon mdi mdi-delete"})])]),_vm._v(" "),_c('tr',{staticClass:"table__row--sub"},[_c('td'),_vm._v(" "),_c('td',{staticClass:"table__wrap"},[_c('i',{staticClass:"table__icon mdi mdi-subdirectory-arrow-right"}),_vm._v("\n                                Subitem 1\n                            ")]),_vm._v(" "),_c('td',[_vm._v("Type 2")]),_vm._v(" "),_c('td',{attrs:{"colspan":"5"}})]),_vm._v(" "),_c('tr',{staticClass:"table__row--sub"},[_c('td'),_vm._v(" "),_c('td',{staticClass:"table__wrap"},[_c('i',{staticClass:"table__icon mdi mdi-subdirectory-arrow-right"}),_vm._v("\n                                Subitem 2\n                            ")]),_vm._v(" "),_c('td',[_vm._v("Type 3")]),_vm._v(" "),_c('td',{attrs:{"colspan":"5"}})]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("1")]),_vm._v(" "),_c('td',{staticClass:"table__wrap"},[_vm._v("This is another table item")]),_vm._v(" "),_c('td',[_vm._v("Type 4")]),_vm._v(" "),_c('td',[_vm._v("Approved")]),_vm._v(" "),_c('td',[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip.bottom",value:('In this tooltip the first words of the remarks will be visible…'),expression:"'In this tooltip the first words of the remarks will be visible…'",modifiers:{"bottom":true}}],staticClass:"table__icon mdi mdi-message-text"})]),_vm._v(" "),_c('td',[_vm._v("10-11-2017")]),_vm._v(" "),_c('td',[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip.right",value:('Edit'),expression:"'Edit'",modifiers:{"right":true}}],staticClass:"table__icon mdi mdi-pencil"})]),_vm._v(" "),_c('td',[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip.right",value:('Delete'),expression:"'Delete'",modifiers:{"right":true}}],staticClass:"table__icon mdi mdi-delete"})])]),_vm._v(" "),_c('tr',{staticClass:"table__row--sub"},[_c('td'),_vm._v(" "),_c('td',{staticClass:"table__wrap"},[_c('i',{staticClass:"table__icon mdi mdi-subdirectory-arrow-right"}),_vm._v("\n                                Subitem 3\n                            ")]),_vm._v(" "),_c('td',[_vm._v("Type 5")]),_vm._v(" "),_c('td',{attrs:{"colspan":"5"}})])])])])]),_vm._v(" "),_c('div',{staticClass:"styleguide__item"},[_c('div',{staticClass:"table__responsive"},[_c('table',{staticClass:"table--alt"},[_c('thead',[_c('tr',[_c('th',[_vm._v("#")]),_vm._v(" "),_c('th',{staticClass:"table__wrap"},[_vm._v("Name")]),_vm._v(" "),_c('th',[_vm._v("Type")]),_vm._v(" "),_c('th',[_vm._v("Status")]),_vm._v(" "),_c('th',{staticClass:"table__cell--icon"},[_vm._v("Remarks")]),_vm._v(" "),_c('th',{staticClass:"table__cell--date"},[_vm._v("Last edit")]),_vm._v(" "),_c('th',{staticClass:"table__cell--icon"}),_vm._v(" "),_c('th',{staticClass:"table__cell--icon"})])]),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',[_vm._v("1")]),_vm._v(" "),_c('td',{staticClass:"table__wrap"},[_vm._v("This is the name of some item in this table")]),_vm._v(" "),_c('td',[_vm._v("Type 1")]),_vm._v(" "),_c('td',[_vm._v("Approved")]),_vm._v(" "),_c('td',[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip.bottom",value:('In this tooltip the first words of the remarks will be visible…'),expression:"'In this tooltip the first words of the remarks will be visible…'",modifiers:{"bottom":true}}],staticClass:"table__icon mdi mdi-message-text"})]),_vm._v(" "),_c('td',[_vm._v("10-11-2017")]),_vm._v(" "),_c('td',[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip.right",value:('Edit'),expression:"'Edit'",modifiers:{"right":true}}],staticClass:"table__icon mdi mdi-pencil"})]),_vm._v(" "),_c('td',[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip.right",value:('Delete'),expression:"'Delete'",modifiers:{"right":true}}],staticClass:"table__icon mdi mdi-delete"})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("1")]),_vm._v(" "),_c('td',{staticClass:"table__wrap"},[_vm._v("This is the name of some item in this table")]),_vm._v(" "),_c('td',[_vm._v("Type 2")]),_vm._v(" "),_c('td',[_vm._v("Approved")]),_vm._v(" "),_c('td',[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip.bottom",value:('In this tooltip the first words of the remarks will be visible…'),expression:"'In this tooltip the first words of the remarks will be visible…'",modifiers:{"bottom":true}}],staticClass:"table__icon mdi mdi-message-text"})]),_vm._v(" "),_c('td',[_vm._v("10-11-2017")]),_vm._v(" "),_c('td',[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip.right",value:('Edit'),expression:"'Edit'",modifiers:{"right":true}}],staticClass:"table__icon mdi mdi-pencil"})]),_vm._v(" "),_c('td',[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip.right",value:('Delete'),expression:"'Delete'",modifiers:{"right":true}}],staticClass:"table__icon mdi mdi-delete"})])]),_vm._v(" "),_c('tr',{staticClass:"table__row--sub"},[_c('td'),_vm._v(" "),_c('td',{staticClass:"table__wrap"},[_c('i',{staticClass:"table__icon mdi mdi-subdirectory-arrow-right"}),_vm._v("\n                                Subitem 1\n                            ")]),_vm._v(" "),_c('td',[_vm._v("Type 2")]),_vm._v(" "),_c('td',{attrs:{"colspan":"5"}})]),_vm._v(" "),_c('tr',{staticClass:"table__row--sub"},[_c('td'),_vm._v(" "),_c('td',{staticClass:"table__wrap"},[_c('i',{staticClass:"table__icon mdi mdi-subdirectory-arrow-right"}),_vm._v("\n                                Subitem 2\n                            ")]),_vm._v(" "),_c('td',[_vm._v("Type 3")]),_vm._v(" "),_c('td',{attrs:{"colspan":"5"}})]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("1")]),_vm._v(" "),_c('td',{staticClass:"table__wrap"},[_vm._v("This is another table item")]),_vm._v(" "),_c('td',[_vm._v("Type 4")]),_vm._v(" "),_c('td',[_vm._v("Approved")]),_vm._v(" "),_c('td',[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip.bottom",value:('In this tooltip the first words of the remarks will be visible…'),expression:"'In this tooltip the first words of the remarks will be visible…'",modifiers:{"bottom":true}}],staticClass:"table__icon mdi mdi-message-text"})]),_vm._v(" "),_c('td',[_vm._v("10-11-2017")]),_vm._v(" "),_c('td',[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip.right",value:('Edit'),expression:"'Edit'",modifiers:{"right":true}}],staticClass:"table__icon mdi mdi-pencil"})]),_vm._v(" "),_c('td',[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip.right",value:('Delete'),expression:"'Delete'",modifiers:{"right":true}}],staticClass:"table__icon mdi mdi-delete"})])]),_vm._v(" "),_c('tr',{staticClass:"table__row--sub"},[_c('td'),_vm._v(" "),_c('td',{staticClass:"table__wrap"},[_c('i',{staticClass:"table__icon mdi mdi-subdirectory-arrow-right"}),_vm._v("\n                                Subitem 3\n                            ")]),_vm._v(" "),_c('td',[_vm._v("Type 5")]),_vm._v(" "),_c('td',{attrs:{"colspan":"5"}})])])])])])]),_vm._v(" "),_c('styleguide-block',{attrs:{"title":"Loader"}},[_c('div',{staticClass:"styleguide__item"},[_c('button',{staticClass:"button--cta",on:{"click":function($event){_vm.setLoader(true, false)}}},[_vm._v("Show loading")]),_vm._v(" "),_c('button',{staticClass:"button--cta",on:{"click":function($event){_vm.setLoader(false, true)}}},[_vm._v("Show error")]),_vm._v(" "),_c('button',{staticClass:"button--cta",on:{"click":function($event){_vm.setLoader(false, false)}}},[_vm._v("Show finished")])]),_vm._v(" "),_c('div',{staticClass:"styleguide__item"},[_c('loader',{attrs:{"loading":_vm.loaderLoading,"error":_vm.loaderError}},[_c('h3',[_vm._v("State: loaded")])])],1)]),_vm._v(" "),_c('styleguide-block',{attrs:{"title":"Tabs"}},[_c('tabs',[_c('tab',{attrs:{"name":'Tab 1'}},[_c('h1',[_vm._v("Tab 1 content")])]),_vm._v(" "),_c('tab',{attrs:{"name":'Tab 2'}},[_c('h2',[_vm._v("Tab 2 content")])])],1)],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h1',[_vm._v("Styleguide")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 835:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AuthenticationPage_vue__ = __webpack_require__(836);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f14dad6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AuthenticationPage_vue__ = __webpack_require__(843);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AuthenticationPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f14dad6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AuthenticationPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 836:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AuthenticationPage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_property_decorator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_auth_Authentication__ = __webpack_require__(837);





var _dec, _class;





var AuthenticationPage = (_dec = Object(__WEBPACK_IMPORTED_MODULE_5_vue_property_decorator__["Component"])({
    components: {
        Authentication: __WEBPACK_IMPORTED_MODULE_6__components_auth_Authentication__["a" /* default */]
    }
}), _dec(_class = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(AuthenticationPage, _Vue);

    function AuthenticationPage() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, AuthenticationPage);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = AuthenticationPage.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(AuthenticationPage)).call.apply(_ref, [this].concat(args))), _this), _this.name = 'authentication-page', _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    return AuthenticationPage;
}(__WEBPACK_IMPORTED_MODULE_4_vue__["default"])) || _class);


/***/ }),

/***/ 837:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Authentication_vue__ = __webpack_require__(838);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fa50d446_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Authentication_vue__ = __webpack_require__(842);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Authentication_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fa50d446_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Authentication_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 838:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Authentication; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__forms_SingleSignOnForm__ = __webpack_require__(839);






var _class;





var Authentication = Object(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__["Component"])(_class = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Authentication, _Vue);

    function Authentication() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Authentication);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Authentication.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Authentication)).call.apply(_ref, [this].concat(args))), _this), _this.name = 'authentication', _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Authentication, [{
        key: 'created',
        value: function created() {
            console.log('[ Authentication ]', this.$auth.currentUser());
            if (this.$auth.currentUser() !== null) {
                var redirect = this.$route.query.redirect;
                if (redirect) {
                    this.$router.replace(redirect);
                } else {
                    this.$router.replace({
                        name: 'home'
                    });
                }
            }
        }
    }, {
        key: 'authComponent',
        get: function get() {
            return __WEBPACK_IMPORTED_MODULE_7__forms_SingleSignOnForm__["a" /* default */];
        }
    }]);

    return Authentication;
}(__WEBPACK_IMPORTED_MODULE_5_vue__["default"])) || _class;



/***/ }),

/***/ 839:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SingleSignOnForm_vue__ = __webpack_require__(840);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79e787a0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SingleSignOnForm_vue__ = __webpack_require__(841);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SingleSignOnForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79e787a0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SingleSignOnForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 84:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardWidget_vue__ = __webpack_require__(698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d522cd5_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardWidget_vue__ = __webpack_require__(717);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardWidget_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d522cd5_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardWidget_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 840:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SingleSignOnForm; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_modules_auth__ = __webpack_require__(161);







var _dec, _class, _desc, _value, _class2;

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}






var SingleSignOnForm = (_dec = Object(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__["Watch"])('$route.hash'), Object(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__["Component"])(_class = (_class2 = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(SingleSignOnForm, _Vue);

    function SingleSignOnForm() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, SingleSignOnForm);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = SingleSignOnForm.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(SingleSignOnForm)).call.apply(_ref, [this].concat(args))), _this), _this.busy = null, _this.error = false, _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(SingleSignOnForm, [{
        key: 'created',
        value: function created() {
            this.onRouteChanged();
        }
    }, {
        key: 'onRouteChanged',
        value: function onRouteChanged() {
            var _this2 = this;

            if (!this.$route.hash) {
                console.log('[ SSO ]', 'No hash on route');
                return;
            }
            if (this.busy) {
                this.busy.cancel('Hash changed');
                this.busy = null;
            }
            var token = this.$route.hash.substr(1);
            if (!token) {
                console.log('[ SSO ]', 'No token specified');
                return;
            }
            this.busy = __WEBPACK_IMPORTED_MODULE_8_axios___default.a.CancelToken.source();
            this.error = false;
            console.log('[ SSO ]', 'Using token');
            this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_9__store_modules_auth__["a" /* LOGIN_SSO */], token).then(function () {
                console.log('[ SSO ]', 'Success');
                _this2.error = false;
                _this2.onLogin();
            }).catch(function () {
                console.log('[ SSO ]', 'Failed');
                _this2.error = true;
            }).finally(function () {
                return _this2.busy = null;
            });
        }
    }, {
        key: 'onLogin',
        value: function onLogin() {
            var redirect = this.$route.query.redirect || { name: 'home' };
            console.log('[ SSO ]', 'Redirect', redirect);
            this.$router.replace(redirect);
        }
    }, {
        key: 'unauthorizedUrl',
        get: function get() {
            if (this.$config.redirects && this.$config.redirects.unauthorized) {
                return this.$config.redirects.unauthorized;
            } else {
                return undefined;
            }
        }
    }]);

    return SingleSignOnForm;
}(__WEBPACK_IMPORTED_MODULE_6_vue__["default"]), (_applyDecoratedDescriptor(_class2.prototype, 'onRouteChanged', [_dec], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(_class2.prototype, 'onRouteChanged'), _class2.prototype)), _class2)) || _class);


/***/ }),

/***/ 841:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block--small"},[(!_vm.busy && !_vm.error)?_c('h2',{staticClass:"js_missing"},[_vm._v("\n        "+_vm._s(_vm.$t('single_sign_on.header_no_sso'))+"\n    ")]):(_vm.busy)?_c('h2',{staticClass:"js_busy"},[_vm._v("\n        "+_vm._s(_vm.$t('single_sign_on.header_sso_busy'))+"\n    ")]):(_vm.error)?_c('h2',{staticClass:"js_error"},[_vm._v("\n        "+_vm._s(_vm.$t('single_sign_on.header_sso_error'))+"\n    ")]):_vm._e(),_vm._v(" "),_c('p',[(_vm.unauthorizedUrl)?_c('a',{staticClass:"button--cta",attrs:{"href":_vm.unauthorizedUrl}},[_vm._v("\n            "+_vm._s(_vm.$t('single_sign_on.link_go_back'))+"\n        ")]):_c('router-link',{staticClass:"button--cta",attrs:{"to":{ name: 'home' }}},[_vm._v("\n            "+_vm._s(_vm.$t('single_sign_on.link_go_back'))+"\n        ")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 842:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c(_vm.authComponent,{tag:"component"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 843:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block--small"},[_c('authentication')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 844:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnnualReportPage_vue__ = __webpack_require__(845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cb1d0dc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AnnualReportPage_vue__ = __webpack_require__(853);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnnualReportPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cb1d0dc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AnnualReportPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 845:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AnnualReportPage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_widgets_year_graph_YearGraphWidget__ = __webpack_require__(846);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_general_Loader__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_modules_countries__ = __webpack_require__(163);






var _dec, _class;







var AnnualReportPage = (_dec = Object(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__["Component"])({
    components: { Loader: __WEBPACK_IMPORTED_MODULE_8__components_general_Loader__["a" /* default */], YearGraphWidget: __WEBPACK_IMPORTED_MODULE_7__components_widgets_year_graph_YearGraphWidget__["a" /* default */] }
}), _dec(_class = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(AnnualReportPage, _Vue);

    function AnnualReportPage() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, AnnualReportPage);

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (AnnualReportPage.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(AnnualReportPage)).apply(this, arguments));
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(AnnualReportPage, [{
        key: 'created',
        value: function created() {
            this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_9__store_modules_countries__["a" /* COUNTRIES_GET */]);
        }
    }, {
        key: 'countries',
        get: function get() {
            return this.$store.state.countries.countries.filter(function (country) {
                return country.has_sales;
            });
        }
    }, {
        key: 'loading',
        get: function get() {
            return this.$store.state.countries.loading;
        }
    }, {
        key: 'error',
        get: function get() {
            return this.$store.state.countries.errors.length > 0;
        }
    }]);

    return AnnualReportPage;
}(__WEBPACK_IMPORTED_MODULE_5_vue__["default"])) || _class);


/***/ }),

/***/ 846:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_YearGraphWidget_vue__ = __webpack_require__(847);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2eec003a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_YearGraphWidget_vue__ = __webpack_require__(852);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_YearGraphWidget_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2eec003a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_YearGraphWidget_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 847:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return YearGraphWidget; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__DashboardWidget__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__WidgetDataDecorator__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__WidgetWrapper__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__graphs_GraphContainer__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__YearGraph__ = __webpack_require__(848);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__YearTable__ = __webpack_require__(849);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash__);








var _dec, _dec2, _dec3, _dec4, _class, _desc, _value, _class2, _descriptor, _descriptor2, _descriptor3;

function _initDefineProp(target, property, descriptor, context) {
    if (!descriptor) return;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, property, {
        enumerable: descriptor.enumerable,
        configurable: descriptor.configurable,
        writable: descriptor.writable,
        value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
    });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}

function _initializerWarningHelper(descriptor, context) {
    throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}










var YearGraphWidget = (_dec = Object(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__["Component"])({
    components: {
        WidgetWrapper: __WEBPACK_IMPORTED_MODULE_10__WidgetWrapper__["a" /* default */],
        GraphContainer: __WEBPACK_IMPORTED_MODULE_11__graphs_GraphContainer__["a" /* default */],
        YearGraph: __WEBPACK_IMPORTED_MODULE_12__YearGraph__["a" /* default */],
        YearTable: __WEBPACK_IMPORTED_MODULE_13__YearTable__["a" /* default */]
    }
}), _dec2 = Object(__WEBPACK_IMPORTED_MODULE_7_vue_property_decorator__["Prop"])({
    type: Object,
    require: true,
    default: function _default() {
        return {
            'id': 7,
            'code': 'BE',
            'number': null,
            'name': 'Belgie',
            'lat': '50.819818',
            'lng': '4.334106',
            'seo_url': 'belgie',
            'created': '05-03-2008 07:58',
            'created_by': 2,
            'modified': '',
            'modified_by': null
        };
    }
}), _dec3 = Object(__WEBPACK_IMPORTED_MODULE_9__WidgetDataDecorator__["a" /* default */])(function () {
    return __WEBPACK_IMPORTED_MODULE_14_lodash___default.a.times(4, function (i) {
        return { year: 2018 - i, value: __WEBPACK_IMPORTED_MODULE_14_lodash___default.a.random(0, 1000) };
    });
}), _dec4 = Object(__WEBPACK_IMPORTED_MODULE_9__WidgetDataDecorator__["a" /* default */])(function () {
    return __WEBPACK_IMPORTED_MODULE_14_lodash___default.a.times(2, function (i) {
        return {
            label: '' + (2018 - i),
            data: __WEBPACK_IMPORTED_MODULE_14_lodash___default.a.times(12, function () {
                return __WEBPACK_IMPORTED_MODULE_14_lodash___default.a.random(0, 500);
            }),
            hidden: false
        };
    });
}), _dec(_class = (_class2 = function (_DashboardWidget) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(YearGraphWidget, _DashboardWidget);

    function YearGraphWidget() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, YearGraphWidget);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = YearGraphWidget.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(YearGraphWidget)).call.apply(_ref, [this].concat(args))), _this), _this.api = {
            endpoint: 'dashboard/api/sales/monthly_revenue'
        }, _initDefineProp(_this, 'country', _descriptor, _this), _initDefineProp(_this, 'rows', _descriptor2, _this), _initDefineProp(_this, 'lines', _descriptor3, _this), _temp), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(YearGraphWidget, [{
        key: 'mounted',
        value: function mounted() {
            this.requestData();
        }
    }, {
        key: 'onQueryData',
        value: function onQueryData(response) {
            if (!response) {
                this.rows = [];
                this.labels = [];
                return;
            }
            this.rows = response.data.table.reverse();
            this.lines = response.data.graph.reverse().map(function (line, index) {
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, line, {
                    hidden: index >= 2 });
            });
        }
    }, {
        key: 'title',
        get: function get() {
            return this.$t('widgets.year_graph.title', { country: this.$t('countries.' + this.country.code) });
        }
    }, {
        key: 'labels',
        get: function get() {
            return {
                xAxis: this.$t('widgets.year_graph.label_xaxis'),
                yAxis: this.$t('widgets.year_graph.label_yaxis')
            };
        }
    }, {
        key: 'requestParams',
        get: function get() {
            return {
                country_id: this.country.id
            };
        }
    }]);

    return YearGraphWidget;
}(__WEBPACK_IMPORTED_MODULE_8__DashboardWidget__["a" /* default */]), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'country', [_dec2], {
    enumerable: true,
    initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'rows', [_dec3], {
    enumerable: true,
    initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, 'lines', [_dec4], {
    enumerable: true,
    initializer: null
})), _class2)) || _class);


/***/ }),

/***/ 848:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'YearGraph',
    extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["b" /* Line */],
    data: function data() {
        return {
            chartOptions: {
                animation: false,
                title: {
                    display: false
                },
                legend: {
                    display: false
                },
                tooltips: {
                    enabled: true,
                    mode: 'index',
                    axis: 'x',
                    intersect: false
                },
                scales: {
                    yAxes: [{
                        type: 'linear',
                        ticks: {
                            beginAtZero: true,
                            min: 0,
                            suggestedMax: 1
                        },
                        scaleLabel: {}
                    }],
                    xAxes: [{
                        type: 'time',
                        ticks: {
                            autoSkip: true,
                            maxTicksLimit: 11
                        },
                        scaleLabel: {},
                        time: {
                            unit: 'month',
                            displayFormats: {
                                month: 'MMM'
                            },
                            tooltipFormat: 'll' },
                        gridLines: {
                            display: false
                        }
                    }]
                },
                elements: {
                    line: {
                        tension: 0,
                        fill: false
                    },
                    point: {
                        radius: 0
                    }
                }
            }
        };
    },
    props: {
        lines: { type: Array, default: function _default() {
                return [];
            } },
        labelXaxis: { type: String, default: '' },
        labelYaxis: { type: String, default: '' }
    },
    computed: {
        localizationFormats: function localizationFormats() {
            return {
                tooltip: this.$t('widgets.year_graph.format_tooltip'),
                display: this.$t('widgets.year_graph.format_label')
            };
        },
        reactiveHidden: function reactiveHidden() {
            return this.lines.map(function (line) {
                return line.hidden;
            });
        }
    },
    watch: {
        lines: 'updateChart',
        localizationFormats: 'updateChart',
        reactiveHidden: 'updateChart',
        labelXaxis: 'updateChart',
        labelYaxis: 'updateChart'
    },
    mounted: function mounted() {
        this.updateChart();
    },

    methods: {
        updateChart: function updateChart() {
            this.updateChartOptions();
            var chartData = {
                datasets: this.lines,
                labels: __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.times(12, function (i) {
                    return new Date(2000, i, 1);
                })
            };
            this.renderChart(chartData, this.chartOptions);
        },
        updateChartOptions: function updateChartOptions() {
            this.chartOptions.scales.xAxes[0].scaleLabel.display = !!this.labelXaxis;
            this.chartOptions.scales.xAxes[0].scaleLabel.labelString = this.labelXaxis;
            this.chartOptions.scales.yAxes[0].scaleLabel.display = !!this.labelYaxis;
            this.chartOptions.scales.yAxes[0].scaleLabel.labelString = this.labelYaxis;
            this.chartOptions.scales.xAxes[0].time.tooltipFormat = this.localizationFormats.tooltip;
        }
    }
});

/***/ }),

/***/ 849:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_YearTable_vue__ = __webpack_require__(850);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_660f01d6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_YearTable_vue__ = __webpack_require__(851);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_YearTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_660f01d6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_YearTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 85:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WidgetWrapper_vue__ = __webpack_require__(718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_526d3342_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WidgetWrapper_vue__ = __webpack_require__(719);
var normalizeComponent = __webpack_require__(3)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WidgetWrapper_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_526d3342_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WidgetWrapper_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 850:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return YearTable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__);






var _dec, _class, _desc, _value, _class2, _descriptor;

function _initDefineProp(target, property, descriptor, context) {
    if (!descriptor) return;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(target, property, {
        enumerable: descriptor.enumerable,
        configurable: descriptor.configurable,
        writable: descriptor.writable,
        value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
    });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
        desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
        Object['define' + 'Property'](target, property, desc);
        desc = null;
    }

    return desc;
}

function _initializerWarningHelper(descriptor, context) {
    throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}




var YearTable = (_dec = Object(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__["Prop"])({
    type: Array,
    default: function _default() {
        return [{ year: 0, value: 0 }, { year: 1, value: 1 }];
    }
}), Object(__WEBPACK_IMPORTED_MODULE_6_vue_property_decorator__["Component"])(_class = (_class2 = function (_Vue) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(YearTable, _Vue);

    function YearTable() {
        var _ref;

        var _temp, _this, _ret;

        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, YearTable);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = YearTable.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(YearTable)).call.apply(_ref, [this].concat(args))), _this), _initDefineProp(_this, 'rows', _descriptor, _this), _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    return YearTable;
}(__WEBPACK_IMPORTED_MODULE_5_vue__["default"]), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'rows', [_dec], {
    enumerable: true,
    initializer: null
})), _class2)) || _class);


/***/ }),

/***/ 851:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table__responsive"},[_c('table',{staticClass:"table"},[_c('thead',[_c('tr',{staticClass:"table__row--header"},[_c('th',[_vm._v(_vm._s(_vm.$t('widgets.year_graph.columns.year')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$t('widgets.year_graph.columns.value')))])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.rows),function(row){return _c('tr',{key:row.year},[_c('td',[_vm._v(_vm._s(row.year))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$n(row.value, 'money')))])])}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 852:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('widget-wrapper',{staticClass:"js_year_graph",attrs:{"loader":_vm.api,"title":_vm.title,"draggable":false}},[_c('graph-container',{attrs:{"datasets":_vm.lines},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('year-graph',{attrs:{"lines":scope.datasets,"height":200,"label-xaxis":_vm.labels.xAxis,"label-yaxis":_vm.labels.yAxis}})]}}])}),_vm._v(" "),_c('year-table',{attrs:{"rows":_vm.rows}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 853:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v(_vm._s(_vm.$t('annualreport.title')))]),_vm._v(" "),_c('loader',{attrs:{"loading":_vm.loading,"error":_vm.error}},[_c('div',{staticClass:"row flex"},_vm._l((_vm.countries),function(country){return _c('div',{staticClass:"flex__item flex--column col-xs-12"},[_c('year-graph-widget',{key:country.id,staticClass:"flex__item",attrs:{"country":country}})],1)}))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 854:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return axiosInstance; });
/* unused harmony export responseInterceptor */
/* unused harmony export requestInterceptor */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);





var axiosInstance = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create();
axiosInstance.defaults.headers.common['Accept-Language'] = localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en';
axiosInstance.defaults.headers.common['Content-Type'] = 'application/json';

var responseInterceptor = axiosInstance.interceptors.response.use(function (response) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response);
}, function (error) {
    console.log('Intercepted error:', error);
    if (error && error.response && error.response.status && error.response.status === 401 && window.location.pathname !== '/auth') {
        if (__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$config.debug) {
            console.log('[ API ]', 'Cancelled /auth redirect');
        } else {
            window.location.href = '/auth';
        }
    }
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

var requestInterceptor = axiosInstance.interceptors.request.use(function (request) {
    var token = window.localStorage.getItem('token');
    if (token) {
        request.headers['Authorization'] = 'Bearer ' + token;
    }
    var language = window.localStorage.getItem('lang');
    if (language) {
        request.headers['X-Language-Code'] = language.toUpperCase();
    }
    request.headers['X-Requested-With'] = 'XmlHttpRequest';
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(request);
}, function (error) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});



/***/ }),

/***/ 86:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = WidgetData;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_class_component__ = __webpack_require__(720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_class_component__);




function WidgetData(factory) {
    return Object(__WEBPACK_IMPORTED_MODULE_2_vue_class_component__["createDecorator"])(function (component, name) {
        if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(component.computed) !== 'object') {
            component.computed = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default()(null);
        }
        component.computed[name] = {
            get: function get() {
                if (this.widgetData) {
                    return this.widgetData[name];
                } else {
                    return null;
                }
            },
            set: function set(newValue) {
                if (this.widgetData) {
                    this.$set(this.widgetData, name, newValue);
                } else {
                    console.error('this.widgetData does not exist, are you sure the component inherits from DashboardWidget?');
                }
            }
        };
        if (factory) {
            if (!Array.isArray(component.mixins)) {
                component.mixins = [];
            }
            component.mixins.push({
                created: function created() {
                    if (this[name] === undefined) {
                        this[name] = factory(this);
                    }
                }
            });
        }
    });
}

/***/ })

},[365]);


// WEBPACK FOOTER //
// static/js/app.edba88270c89cefa4ca7.js